webpackJsonp([13],{

/***/ 135:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "indDB", function() { return indDB; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "eventBus", function() { return eventBus; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(89);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__ = __webpack_require__(149);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuetify__ = __webpack_require__(412);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuetify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vuetify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__stylus_main_styl__ = __webpack_require__(391);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__stylus_main_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__stylus_main_styl__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__App__ = __webpack_require__(407);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__router__ = __webpack_require__(387);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_axios__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vue_sweetalert2__ = __webpack_require__(410);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_vue_axios__ = __webpack_require__(403);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_vue_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_vue_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_buefy__ = __webpack_require__(389);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_buefy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_buefy__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__store__ = __webpack_require__(388);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_vue_localstorage__ = __webpack_require__(408);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_vue_localstorage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_vue_localstorage__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_dexie__ = __webpack_require__(390);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_vuex_router_sync__ = __webpack_require__(413);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_vuex_router_sync___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_vuex_router_sync__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__assets_js_on_vue_good_table__ = __webpack_require__(386);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_vue_cookies__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_vue_cookies___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18_vue_cookies__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_vue_highcharts__ = __webpack_require__(406);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_highcharts__ = __webpack_require__(134);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_highcharts___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20_highcharts__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_highcharts_modules_no_data_to_display__ = __webpack_require__(398);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_highcharts_modules_no_data_to_display___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21_highcharts_modules_no_data_to_display__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_highcharts_modules_stock__ = __webpack_require__(401);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_highcharts_modules_stock___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22_highcharts_modules_stock__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_highcharts_modules_map__ = __webpack_require__(397);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_highcharts_modules_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23_highcharts_modules_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_highcharts_modules_drilldown__ = __webpack_require__(394);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_highcharts_modules_drilldown___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_24_highcharts_modules_drilldown__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_highcharts_highcharts_more__ = __webpack_require__(392);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_highcharts_highcharts_more___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_25_highcharts_highcharts_more__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26_highcharts_modules_solid_gauge__ = __webpack_require__(400);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26_highcharts_modules_solid_gauge___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_26_highcharts_modules_solid_gauge__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27_highcharts_modules_exporting__ = __webpack_require__(396);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27_highcharts_modules_exporting___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_27_highcharts_modules_exporting__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28_highcharts_modules_export_data__ = __webpack_require__(395);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28_highcharts_modules_export_data___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_28_highcharts_modules_export_data__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29_highcharts_modules_offline_exporting__ = __webpack_require__(399);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29_highcharts_modules_offline_exporting___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_29_highcharts_modules_offline_exporting__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30_highcharts_modules_boost__ = __webpack_require__(393);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30_highcharts_modules_boost___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_30_highcharts_modules_boost__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31_lodash__ = __webpack_require__(402);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_31_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32_vue_firestore__ = __webpack_require__(405);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32_vue_firestore___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_32_vue_firestore__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33_vue_directive_tooltip__ = __webpack_require__(404);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33_vue_directive_tooltip___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_33_vue_directive_tooltip__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34_vue_tour__ = __webpack_require__(411);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34_vue_tour___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_34_vue_tour__);




// the Data fetching function
var getApiData = function () {
  var _ref = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
    var ifConnected;
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;
            _context.next = 3;
            return __WEBPACK_IMPORTED_MODULE_8_axios___default.a.get('https://car-dashboard-others.firebaseio.com/ndState.json').then(function (response) {
              stateNumDenData.push(response.data);
              return stateNumDenData;
            });

          case 3:
            _context.next = 7;
            break;

          case 5:
            _context.prev = 5;
            _context.t0 = _context['catch'](0);

          case 7:
            //    console.log(e)
            try {
              //await axios.get(`https://car-dashboard-others.firebaseio.com/ndlga.json`)        
              //.then(response => {
              // console.log(values);
              // lgaNumDenData.push(response.data);
              // return lgaNumDenData;
              // })
            } catch (e) {}
            //    console.log(e)


            //  console.log(stateNumDenData[0]);
            //  console.log(lgaNumDenData[0]);


            //  Check if there's internet to either update data on the tables or skip the updata
            //  
            ifConnected = window.navigator.onLine;

            if (ifConnected) {
              //Data updates
              console.log('Connection available, Database will Update');
              iDB.transaction('rw', iDB.stateNumDen, function () {

                //Clear the stateNumDen table
                iDB.stateNumDen.clear();

                //Refill the table with latest data
                var objs = stateNumDenData[0];

                var _iteratorNormalCompletion = true;
                var _didIteratorError = false;
                var _iteratorError = undefined;

                try {
                  for (var _iterator = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(objs), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                    var o = _step.value;

                    iDB.stateNumDen.put(o);
                  }
                } catch (err) {
                  _didIteratorError = true;
                  _iteratorError = err;
                } finally {
                  try {
                    if (!_iteratorNormalCompletion && _iterator.return) {
                      _iterator.return();
                    }
                  } finally {
                    if (_didIteratorError) {
                      throw _iteratorError;
                    }
                  }
                }
              }).catch(function (e) {
                // handle errors
              });

              iDB.transaction('rw', iDB.lgaNumDen, function () {

                //Clear the lgaNumDen table
                iDB.lgaNumDen.clear();
                //Refill the table with latest data
                var data = lgaNumDenData[0];

                var _iteratorNormalCompletion2 = true;
                var _didIteratorError2 = false;
                var _iteratorError2 = undefined;

                try {
                  for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(data), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                    var d = _step2.value;

                    iDB.lgaNumDen.put(d);
                  }
                } catch (err) {
                  _didIteratorError2 = true;
                  _iteratorError2 = err;
                } finally {
                  try {
                    if (!_iteratorNormalCompletion2 && _iterator2.return) {
                      _iterator2.return();
                    }
                  } finally {
                    if (_didIteratorError2) {
                      throw _iteratorError2;
                    }
                  }
                }
              }).catch(function (e) {});
            } else {
              //Data Does not update because there's no internet
              console.log('Connection not available, Database will not Update');
            }

          case 10:
          case 'end':
            return _context.stop();
        }
      }
    }, _callee, this, [[0, 5]]);
  }));

  return function getApiData() {
    return _ref.apply(this, arguments);
  };
}();
//Export for use by other components


// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
// import Es6Promise from 'es6-promise'    // import es6Promise
// Es6Promise.polyfill()                   // Use es6Promise for polyfill to support app use in internet explorer



__WEBPACK_IMPORTED_MODULE_3_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_4_vuetify___default.a);
// import 'vuetify/dist/vuetify.css'
// app.js


// import Swal from 'sweetalert2';








// import 'buefy/dist/buefy.css'



__WEBPACK_IMPORTED_MODULE_3_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_9_moment___default.a);
__WEBPACK_IMPORTED_MODULE_3_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_10_vue_sweetalert2__["default"]);

// Initialize indexedDB on the project


// declare the containing variables to hold data
var stateNumDenData = new Array();
var lgaNumDenData = new Array();

//Call the Data fetching function
getApiData();

// Create the database
var iDB = new __WEBPACK_IMPORTED_MODULE_15_dexie__["a" /* default */]('MSDAT-DATABASE');
var version = 1;

iDB.version(version).stores({
  //Create the tables
  stateNumDen: '++id',
  lgaNumDen: '++id',
  users: '++id, user_id, name, email, profession, organization, username, password',
  sub_dashboard_interests: '++id, email, dashboard, created',
  transactions: '++id'
});var indDB = iDB;

// import config from '../config';
// sync route to vuex store so you can access route object
// with store.state.route.{name|path|param|query}


//require('./assets/js-on/bootstrap-tour');
__webpack_require__(385);
__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_16_vuex_router_sync__["sync"])(__WEBPACK_IMPORTED_MODULE_13__store__["a" /* default */], __WEBPACK_IMPORTED_MODULE_7__router__["a" /* default */]);

// import fullscreen from 'vue-fullscreen'
// Vue.use(fullscreen, {
//   name: 'fullscreen',
//   createComputed: true, //created computed members from your variable declarations
//   // bind: true
// })

 //'vue-good-table';

// import high chart



__WEBPACK_IMPORTED_MODULE_21_highcharts_modules_no_data_to_display___default()(__WEBPACK_IMPORTED_MODULE_20_highcharts___default.a);
// import Highcharts from 'highcharts/highstock';

// load these modules as your need



// some charts like solid gauge require `highcharts-more.js`, you can find it in official demo.





// to boost the rendering speed by reducing animations and other stuff that takes rendering time



__WEBPACK_IMPORTED_MODULE_22_highcharts_modules_stock___default()(__WEBPACK_IMPORTED_MODULE_20_highcharts___default.a);
__WEBPACK_IMPORTED_MODULE_23_highcharts_modules_map___default()(__WEBPACK_IMPORTED_MODULE_20_highcharts___default.a);
__WEBPACK_IMPORTED_MODULE_24_highcharts_modules_drilldown___default()(__WEBPACK_IMPORTED_MODULE_20_highcharts___default.a);
__WEBPACK_IMPORTED_MODULE_25_highcharts_highcharts_more___default()(__WEBPACK_IMPORTED_MODULE_20_highcharts___default.a);
__WEBPACK_IMPORTED_MODULE_26_highcharts_modules_solid_gauge___default()(__WEBPACK_IMPORTED_MODULE_20_highcharts___default.a);
__WEBPACK_IMPORTED_MODULE_27_highcharts_modules_exporting___default()(__WEBPACK_IMPORTED_MODULE_20_highcharts___default.a);
__WEBPACK_IMPORTED_MODULE_29_highcharts_modules_offline_exporting___default()(__WEBPACK_IMPORTED_MODULE_20_highcharts___default.a);
// load up the boost modules
__WEBPACK_IMPORTED_MODULE_30_highcharts_modules_boost___default()(__WEBPACK_IMPORTED_MODULE_20_highcharts___default.a);
__WEBPACK_IMPORTED_MODULE_28_highcharts_modules_export_data___default()(__WEBPACK_IMPORTED_MODULE_20_highcharts___default.a);

//Overwrite highchart legend function to highlight hovered item
// (function(H) {
//   H.Legend.prototype.setItemEvents = function(item, legendItem, useHTML) {
//     var legend = this,
//       merge = H.merge,
//       fireEvent = H.fireEvent,
//       Point = H.Point,
//       boxWrapper = legend.chart.renderer.boxWrapper,
//       activeClass = 'highcharts-legend-' +
//       (item instanceof Point ? 'point' : 'series') + '-active';

//     if (!item.initColor) {
//       item.initColor = item.color;
//     }
//     // Set the events on the item group, or in case of useHTML, the item
//     // itself (#1249)
//     (useHTML ? legendItem : item.legendGroup)
//     .on('mouseover', function() {
//         item.setState('hover');

//         // A CSS class to dim or hide other than the hovered series
//         boxWrapper.addClass(activeClass);

//         legendItem.css(legend.options.itemHoverStyle);

//         // item.graph.attr({
//         //   stroke: 'red'
//         // });

//         // item.points.forEach(function(point) {
//         //   point.graphic.attr({
//         //     fill: 'red'
//         //   });
//         // });

//       })
//       .on('mouseout', function() {

//         legendItem.css(
//           merge(item.visible ? legend.itemStyle : legend.itemHiddenStyle)
//         );


//         // A CSS class to dim or hide other than the hovered series
//         boxWrapper.removeClass(activeClass);

//         item.setState();

//         item.graph.attr({
//           stroke: item.initColor
//         });

//         item.points.forEach(function(point) {
//           point.graphic.attr({
//             fill: item.initColor
//           });
//         });
//       })
//       .on('click', function(event) {
//         var strLegendItemClick = 'legendItemClick',
//           fnLegendItemClick = function() {
//             if (item.setVisible) {
//               item.setVisible();
//             }
//           };

//         // A CSS class to dim or hide other than the hovered series. Event
//         // handling in iOS causes the activeClass to be added prior to click
//         // in some cases (#7418).
//         boxWrapper.removeClass(activeClass);

//         // Pass over the click/touch event. #4.
//         event = {
//           browserEvent: event
//         };

//         // click the name or symbol
//         if (item.firePointEvent) { // point
//           item.firePointEvent(
//             strLegendItemClick,
//             event,
//             fnLegendItemClick
//           );
//         } else {
//           fireEvent(item, strLegendItemClick, event, fnLegendItemClick);
//         }
//       });
//   }
// })(Highcharts);

//  Fade other series on hover
(function (Highcharts) {
  var each = Highcharts.each;

  Highcharts.wrap(Highcharts.Legend.prototype, 'renderItem', function (proceed, item) {

    proceed.call(this, item);

    var isPoint = !!item.series,
        collection = isPoint ? item.series.points : this.chart.series,
        groups = isPoint ? ['graphic'] : ['group', 'markerGroup'],
        element = item.legendGroup.element;

    element.onmouseover = function () {
      each(collection, function (seriesItem) {
        if (seriesItem !== item) {
          each(groups, function (group) {
            seriesItem[group].animate({
              opacity: 0.25
            }, {
              duration: 150
            });
          });
        }
      });
    };
    element.onmouseout = function () {
      each(collection, function (seriesItem) {
        if (seriesItem !== item) {
          each(groups, function (group) {
            seriesItem[group].animate({
              opacity: 1
            }, {
              duration: 50
            });
          });
        }
      });
    };
  });
})(__WEBPACK_IMPORTED_MODULE_20_highcharts___default.a);

__WEBPACK_IMPORTED_MODULE_20_highcharts___default.a.SVGRenderer.prototype.symbols.download = function (x, y, w, h) {
  var path = [
  // Arrow stem
  'M', x + w * 0.5, y, 'L', x + w * 0.5, y + h * 0.7,
  // Arrow head
  'M', x + w * 0.3, y + h * 0.5, 'L', x + w * 0.5, y + h * 0.7, 'L', x + w * 0.7, y + h * 0.5,
  // Box
  'M', x, y + h * 0.9, 'L', x, y + h, 'L', x + w, y + h, 'L', x + w, y + h * 0.9];
  return path;
};

Object.defineProperty(__WEBPACK_IMPORTED_MODULE_3_vue__["default"].prototype, '$_', { value: __WEBPACK_IMPORTED_MODULE_31_lodash___default.a });

__WEBPACK_IMPORTED_MODULE_3_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_19_vue_highcharts__["a" /* default */], { Highcharts: __WEBPACK_IMPORTED_MODULE_20_highcharts___default.a });
// Vue.use(VueHighcharts, { Highcharts });

// new components with firebase, graphql, and mongoDB
// import * as firebase from 'firebase/app';
// import 'firebase/auth';

__WEBPACK_IMPORTED_MODULE_3_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_32_vue_firestore___default.a);

__WEBPACK_IMPORTED_MODULE_3_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_18_vue_cookies___default.a);
var VueScrollTo = __webpack_require__(409);
__WEBPACK_IMPORTED_MODULE_3_vue__["default"].use(VueScrollTo, {
  container: "body",
  duration: 1000,
  easing: "linear",
  offset: 0,
  cancelable: true,
  onStart: false,
  onDone: false,
  onCancel: false,
  x: false,
  y: true
});
var eventBus = new __WEBPACK_IMPORTED_MODULE_3_vue__["default"]();

__WEBPACK_IMPORTED_MODULE_3_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_33_vue_directive_tooltip___default.a);

__WEBPACK_IMPORTED_MODULE_3_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_34_vue_tour___default.a);

__WEBPACK_IMPORTED_MODULE_3_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_11_vue_axios___default.a, __WEBPACK_IMPORTED_MODULE_8_axios___default.a);
__WEBPACK_IMPORTED_MODULE_3_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_4_vuetify___default.a);
__WEBPACK_IMPORTED_MODULE_3_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_14_vue_localstorage___default.a, {
  name: 'ls',
  createComputed: true //created computed members from your variable declarations
});
__WEBPACK_IMPORTED_MODULE_3_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_12_buefy___default.a);
__WEBPACK_IMPORTED_MODULE_3_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_17__assets_js_on_vue_good_table__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_3_vue__["default"].config.productionTip = false;
// use v-focus directive
__WEBPACK_IMPORTED_MODULE_3_vue__["default"].directive('focus', {
  // When the bound element is inserted into the DOM...
  inserted: function inserted(el) {
    // Focus the element
    el.focus();
  }
});

/* eslint-disable no-new */
var app = new __WEBPACK_IMPORTED_MODULE_3_vue__["default"]({
  el: '#app',
  store: __WEBPACK_IMPORTED_MODULE_13__store__["a" /* default */],
  router: __WEBPACK_IMPORTED_MODULE_7__router__["a" /* default */],
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_6__App___default.a }
});

// add custom js codes
function launchApplication(l_url, l_windowName) {
  // window.name = 'web';
  // console.log(window)
  if (typeof launchApplication.winrefs == 'undefined') {
    launchApplication.winrefs = {};
  }
  if (typeof launchApplication.winrefs[l_windowName] == 'undefined' || launchApplication.winrefs[l_windowName].closed) {
    launchApplication.winrefs[l_windowName] = window.open(l_url, l_windowName);
  } else {
    launchApplication.winrefs[l_windowName].focus();
  }
}

/***/ }),

/***/ 154:
/***/ (function(module, exports) {

module.exports = {"aes-128-ecb":{"cipher":"AES","key":128,"iv":0,"mode":"ECB","type":"block"},"aes-192-ecb":{"cipher":"AES","key":192,"iv":0,"mode":"ECB","type":"block"},"aes-256-ecb":{"cipher":"AES","key":256,"iv":0,"mode":"ECB","type":"block"},"aes-128-cbc":{"cipher":"AES","key":128,"iv":16,"mode":"CBC","type":"block"},"aes-192-cbc":{"cipher":"AES","key":192,"iv":16,"mode":"CBC","type":"block"},"aes-256-cbc":{"cipher":"AES","key":256,"iv":16,"mode":"CBC","type":"block"},"aes128":{"cipher":"AES","key":128,"iv":16,"mode":"CBC","type":"block"},"aes192":{"cipher":"AES","key":192,"iv":16,"mode":"CBC","type":"block"},"aes256":{"cipher":"AES","key":256,"iv":16,"mode":"CBC","type":"block"},"aes-128-cfb":{"cipher":"AES","key":128,"iv":16,"mode":"CFB","type":"stream"},"aes-192-cfb":{"cipher":"AES","key":192,"iv":16,"mode":"CFB","type":"stream"},"aes-256-cfb":{"cipher":"AES","key":256,"iv":16,"mode":"CFB","type":"stream"},"aes-128-cfb8":{"cipher":"AES","key":128,"iv":16,"mode":"CFB8","type":"stream"},"aes-192-cfb8":{"cipher":"AES","key":192,"iv":16,"mode":"CFB8","type":"stream"},"aes-256-cfb8":{"cipher":"AES","key":256,"iv":16,"mode":"CFB8","type":"stream"},"aes-128-cfb1":{"cipher":"AES","key":128,"iv":16,"mode":"CFB1","type":"stream"},"aes-192-cfb1":{"cipher":"AES","key":192,"iv":16,"mode":"CFB1","type":"stream"},"aes-256-cfb1":{"cipher":"AES","key":256,"iv":16,"mode":"CFB1","type":"stream"},"aes-128-ofb":{"cipher":"AES","key":128,"iv":16,"mode":"OFB","type":"stream"},"aes-192-ofb":{"cipher":"AES","key":192,"iv":16,"mode":"OFB","type":"stream"},"aes-256-ofb":{"cipher":"AES","key":256,"iv":16,"mode":"OFB","type":"stream"},"aes-128-ctr":{"cipher":"AES","key":128,"iv":16,"mode":"CTR","type":"stream"},"aes-192-ctr":{"cipher":"AES","key":192,"iv":16,"mode":"CTR","type":"stream"},"aes-256-ctr":{"cipher":"AES","key":256,"iv":16,"mode":"CTR","type":"stream"},"aes-128-gcm":{"cipher":"AES","key":128,"iv":12,"mode":"GCM","type":"auth"},"aes-192-gcm":{"cipher":"AES","key":192,"iv":12,"mode":"GCM","type":"auth"},"aes-256-gcm":{"cipher":"AES","key":256,"iv":12,"mode":"GCM","type":"auth"}}

/***/ }),

/***/ 156:
/***/ (function(module, exports) {

module.exports = {"sha224WithRSAEncryption":{"sign":"rsa","hash":"sha224","id":"302d300d06096086480165030402040500041c"},"RSA-SHA224":{"sign":"ecdsa/rsa","hash":"sha224","id":"302d300d06096086480165030402040500041c"},"sha256WithRSAEncryption":{"sign":"rsa","hash":"sha256","id":"3031300d060960864801650304020105000420"},"RSA-SHA256":{"sign":"ecdsa/rsa","hash":"sha256","id":"3031300d060960864801650304020105000420"},"sha384WithRSAEncryption":{"sign":"rsa","hash":"sha384","id":"3041300d060960864801650304020205000430"},"RSA-SHA384":{"sign":"ecdsa/rsa","hash":"sha384","id":"3041300d060960864801650304020205000430"},"sha512WithRSAEncryption":{"sign":"rsa","hash":"sha512","id":"3051300d060960864801650304020305000440"},"RSA-SHA512":{"sign":"ecdsa/rsa","hash":"sha512","id":"3051300d060960864801650304020305000440"},"RSA-SHA1":{"sign":"rsa","hash":"sha1","id":"3021300906052b0e03021a05000414"},"ecdsa-with-SHA1":{"sign":"ecdsa","hash":"sha1","id":""},"sha256":{"sign":"ecdsa","hash":"sha256","id":""},"sha224":{"sign":"ecdsa","hash":"sha224","id":""},"sha384":{"sign":"ecdsa","hash":"sha384","id":""},"sha512":{"sign":"ecdsa","hash":"sha512","id":""},"DSA-SHA":{"sign":"dsa","hash":"sha1","id":""},"DSA-SHA1":{"sign":"dsa","hash":"sha1","id":""},"DSA":{"sign":"dsa","hash":"sha1","id":""},"DSA-WITH-SHA224":{"sign":"dsa","hash":"sha224","id":""},"DSA-SHA224":{"sign":"dsa","hash":"sha224","id":""},"DSA-WITH-SHA256":{"sign":"dsa","hash":"sha256","id":""},"DSA-SHA256":{"sign":"dsa","hash":"sha256","id":""},"DSA-WITH-SHA384":{"sign":"dsa","hash":"sha384","id":""},"DSA-SHA384":{"sign":"dsa","hash":"sha384","id":""},"DSA-WITH-SHA512":{"sign":"dsa","hash":"sha512","id":""},"DSA-SHA512":{"sign":"dsa","hash":"sha512","id":""},"DSA-RIPEMD160":{"sign":"dsa","hash":"rmd160","id":""},"ripemd160WithRSA":{"sign":"rsa","hash":"rmd160","id":"3021300906052b2403020105000414"},"RSA-RIPEMD160":{"sign":"rsa","hash":"rmd160","id":"3021300906052b2403020105000414"},"md5WithRSAEncryption":{"sign":"rsa","hash":"md5","id":"3020300c06082a864886f70d020505000410"},"RSA-MD5":{"sign":"rsa","hash":"md5","id":"3020300c06082a864886f70d020505000410"}}

/***/ }),

/***/ 157:
/***/ (function(module, exports) {

module.exports = {"1.3.132.0.10":"secp256k1","1.3.132.0.33":"p224","1.2.840.10045.3.1.1":"p192","1.2.840.10045.3.1.7":"p256","1.3.132.0.34":"p384","1.3.132.0.35":"p521"}

/***/ }),

/***/ 385:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(__webpack_provided_window_dot_jQuery, module, global) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__);

/**
 * Intro.js v2.9.3
 * https://github.com/usablica/intro.js
 *
 * Copyright (C) 2017 Afshin Mehrabani (@afshinmeh)
 */

(function (f) {
  if ((typeof exports === "undefined" ? "undefined" : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(exports)) === "object" && typeof module !== "undefined") {
    module.exports = f();
    // deprecated function
    // @since 2.8.0
    module.exports.introJs = function () {
      console.warn('Deprecated: please use require("intro.js") directly, instead of the introJs method of the function');
      // introJs()
      return f().apply(this, arguments);
    };
  } else if (typeof define === "function" && __webpack_require__(384)) {
    define([], f);
  } else {
    var g;
    if (typeof window !== "undefined") {
      g = window;
    } else if (typeof global !== "undefined") {
      g = global;
    } else if (typeof self !== "undefined") {
      g = self;
    } else {
      g = this;
    }
    g.introJs = f();
  }
})(function () {
  //Default config/variables
  var VERSION = '2.9.3';

  /**
   * IntroJs main class
   *
   * @class IntroJs
   */
  function IntroJs(obj) {
    this._targetElement = obj;
    this._introItems = [];

    this._options = {
      /* Next button label in tooltip box */
      nextLabel: 'Next &rarr;',
      /* Skip button label in tooltip box */
      skipLabel: 'Skip',
      /* Previous button label in tooltip box */
      prevLabel: '&larr; Back',

      /* Done button label in tooltip box */
      doneLabel: 'Done',
      /* Hide previous button in the first step? Otherwise, it will be disabled button. */
      hidePrev: false,
      /* Hide next button in the last step? Otherwise, it will be disabled button. */
      hideNext: false,
      /* Default tooltip box position */
      tooltipPosition: 'bottom',
      /* Next CSS class for tooltip boxes */
      tooltipClass: '',
      /* CSS class that is added to the helperLayer */
      highlightClass: '',
      /* Close introduction when pressing Escape button? */
      exitOnEsc: true,
      /* Close introduction when clicking on overlay layer? */
      exitOnOverlayClick: true,
      /* Show step numbers in introduction? */
      showStepNumbers: true,
      /* Let user use keyboard to navigate the tour? */
      keyboardNavigation: true,
      /* Show tour control buttons? */
      showButtons: true,
      /* Show tour bullets? */
      showBullets: true,
      /* Show tour progress? */
      showProgress: false,
      /* Scroll to highlighted element? */
      scrollToElement: true,
      /*
       * Should we scroll the tooltip or target element?
       *
       * Options are: 'element' or 'tooltip'
       */
      scrollTo: 'element',
      /* Padding to add after scrolling when element is not in the viewport (in pixels) */
      scrollPadding: 30,
      /* Set the overlay opacity */
      overlayOpacity: 0.8,
      /* Precedence of positions, when auto is enabled */
      positionPrecedence: ["bottom", "top", "right", "left"],
      /* Disable an interaction with element? */
      disableInteraction: false,
      /* Set how much padding to be used around helper element */
      helperElementPadding: 0,
      /* Default hint position */
      hintPosition: 'top-middle',
      /* Hint button label */
      hintButtonLabel: 'Got it',
      /* Adding animation to hints? */
      hintAnimation: true,
      /* additional classes to put on the buttons */
      buttonClass: "introjs-button"
    };
  }

  /**
   * Initiate a new introduction/guide from an element in the page
   *
   * @api private
   * @method _introForElement
   * @param {Object} targetElm
   * @param {String} group
   * @returns {Boolean} Success or not?
   */
  function _introForElement(targetElm, group) {
    var allIntroSteps = targetElm.querySelectorAll("*[data-intro]"),
        introItems = [];

    if (this._options.steps) {
      //use steps passed programmatically
      _forEach(this._options.steps, function (step) {
        var currentItem = _cloneObject(step);

        //set the step
        currentItem.step = introItems.length + 1;

        //use querySelector function only when developer used CSS selector
        if (typeof currentItem.element === 'string') {
          //grab the element with given selector from the page
          currentItem.element = document.querySelector(currentItem.element);
        }

        //intro without element
        if (typeof currentItem.element === 'undefined' || currentItem.element === null) {
          var floatingElementQuery = document.querySelector(".introjsFloatingElement");

          if (floatingElementQuery === null) {
            floatingElementQuery = document.createElement('div');
            floatingElementQuery.className = 'introjsFloatingElement';

            document.body.appendChild(floatingElementQuery);
          }

          currentItem.element = floatingElementQuery;
          currentItem.position = 'floating';
        }

        currentItem.scrollTo = currentItem.scrollTo || this._options.scrollTo;

        if (typeof currentItem.disableInteraction === 'undefined') {
          currentItem.disableInteraction = this._options.disableInteraction;
        }

        if (currentItem.element !== null) {
          introItems.push(currentItem);
        }
      }.bind(this));
    } else {
      //use steps from data-* annotations
      var elmsLength = allIntroSteps.length;
      var disableInteraction;

      //if there's no element to intro
      if (elmsLength < 1) {
        return false;
      }

      _forEach(allIntroSteps, function (currentElement) {

        // PR #80
        // start intro for groups of elements
        if (group && currentElement.getAttribute("data-intro-group") !== group) {
          return;
        }

        // skip hidden elements
        if (currentElement.style.display === 'none') {
          return;
        }

        var step = parseInt(currentElement.getAttribute('data-step'), 10);

        if (typeof currentElement.getAttribute('data-disable-interaction') !== 'undefined') {
          disableInteraction = !!currentElement.getAttribute('data-disable-interaction');
        } else {
          disableInteraction = this._options.disableInteraction;
        }

        if (step > 0) {
          introItems[step - 1] = {
            element: currentElement,
            intro: currentElement.getAttribute('data-intro'),
            step: parseInt(currentElement.getAttribute('data-step'), 10),
            tooltipClass: currentElement.getAttribute('data-tooltipclass'),
            highlightClass: currentElement.getAttribute('data-highlightclass'),
            position: currentElement.getAttribute('data-position') || this._options.tooltipPosition,
            scrollTo: currentElement.getAttribute('data-scrollto') || this._options.scrollTo,
            disableInteraction: disableInteraction
          };
        }
      }.bind(this));

      //next add intro items without data-step
      //todo: we need a cleanup here, two loops are redundant
      var nextStep = 0;

      _forEach(allIntroSteps, function (currentElement) {

        // PR #80
        // start intro for groups of elements
        if (group && currentElement.getAttribute("data-intro-group") !== group) {
          return;
        }

        if (currentElement.getAttribute('data-step') === null) {

          while (true) {
            if (typeof introItems[nextStep] === 'undefined') {
              break;
            } else {
              nextStep++;
            }
          }

          if (typeof currentElement.getAttribute('data-disable-interaction') !== 'undefined') {
            disableInteraction = !!currentElement.getAttribute('data-disable-interaction');
          } else {
            disableInteraction = this._options.disableInteraction;
          }

          introItems[nextStep] = {
            element: currentElement,
            intro: currentElement.getAttribute('data-intro'),
            step: nextStep + 1,
            tooltipClass: currentElement.getAttribute('data-tooltipclass'),
            highlightClass: currentElement.getAttribute('data-highlightclass'),
            position: currentElement.getAttribute('data-position') || this._options.tooltipPosition,
            scrollTo: currentElement.getAttribute('data-scrollto') || this._options.scrollTo,
            disableInteraction: disableInteraction
          };
        }
      }.bind(this));
    }

    //removing undefined/null elements
    var tempIntroItems = [];
    for (var z = 0; z < introItems.length; z++) {
      if (introItems[z]) {
        // copy non-falsy values to the end of the array
        tempIntroItems.push(introItems[z]);
      }
    }

    introItems = tempIntroItems;

    //Ok, sort all items with given steps
    introItems.sort(function (a, b) {
      return a.step - b.step;
    });

    //set it to the introJs object
    this._introItems = introItems;

    //add overlay layer to the page
    if (_addOverlayLayer.call(this, targetElm)) {
      //then, start the show
      _nextStep.call(this);

      if (this._options.keyboardNavigation) {
        DOMEvent.on(window, 'keydown', _onKeyDown, this, true);
      }
      //for window resize
      DOMEvent.on(window, 'resize', _onResize, this, true);
    }
    return false;
  }

  function _onResize() {
    this.refresh.call(this);
  }

  /**
  * on keyCode:
  * https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent/keyCode
  * This feature has been removed from the Web standards.
  * Though some browsers may still support it, it is in
  * the process of being dropped.
  * Instead, you should use KeyboardEvent.code,
  * if it's implemented.
  *
  * jQuery's approach is to test for
  *   (1) e.which, then
  *   (2) e.charCode, then
  *   (3) e.keyCode
  * https://github.com/jquery/jquery/blob/a6b0705294d336ae2f63f7276de0da1195495363/src/event.js#L638
  *
  * @param type var
  * @return type
  */
  function _onKeyDown(e) {
    var code = e.code === null ? e.which : e.code;

    // if code/e.which is null
    if (code === null) {
      code = e.charCode === null ? e.keyCode : e.charCode;
    }

    if ((code === 'Escape' || code === 27) && this._options.exitOnEsc === true) {
      //escape key pressed, exit the intro
      //check if exit callback is defined
      _exitIntro.call(this, this._targetElement);
    } else if (code === 'ArrowLeft' || code === 37) {
      //left arrow
      _previousStep.call(this);
    } else if (code === 'ArrowRight' || code === 39) {
      //right arrow
      _nextStep.call(this);
    } else if (code === 'Enter' || code === 13) {
      //srcElement === ie
      var target = e.target || e.srcElement;
      if (target && target.className.match('introjs-prevbutton')) {
        //user hit enter while focusing on previous button
        _previousStep.call(this);
      } else if (target && target.className.match('introjs-skipbutton')) {
        //user hit enter while focusing on skip button
        if (this._introItems.length - 1 === this._currentStep && typeof this._introCompleteCallback === 'function') {
          this._introCompleteCallback.call(this);
        }

        _exitIntro.call(this, this._targetElement);
      } else if (target && target.getAttribute('data-stepnumber')) {
        // user hit enter while focusing on step bullet
        target.click();
      } else {
        //default behavior for responding to enter
        _nextStep.call(this);
      }

      //prevent default behaviour on hitting Enter, to prevent steps being skipped in some browsers
      if (e.preventDefault) {
        e.preventDefault();
      } else {
        e.returnValue = false;
      }
    }
  }

  /*
    * makes a copy of the object
    * @api private
    * @method _cloneObject
   */
  function _cloneObject(object) {
    if (object === null || (typeof object === "undefined" ? "undefined" : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(object)) !== 'object' || typeof object.nodeType !== 'undefined') {
      return object;
    }
    var temp = {};
    for (var key in object) {
      if (typeof __webpack_provided_window_dot_jQuery !== 'undefined' && object[key] instanceof __webpack_provided_window_dot_jQuery) {
        temp[key] = object[key];
      } else {
        temp[key] = _cloneObject(object[key]);
      }
    }
    return temp;
  }
  /**
   * Go to specific step of introduction
   *
   * @api private
   * @method _goToStep
   */
  function _goToStep(step) {
    //because steps starts with zero
    this._currentStep = step - 2;
    if (typeof this._introItems !== 'undefined') {
      _nextStep.call(this);
    }
  }

  /**
   * Go to the specific step of introduction with the explicit [data-step] number
   *
   * @api private
   * @method _goToStepNumber
   */
  function _goToStepNumber(step) {
    this._currentStepNumber = step;
    if (typeof this._introItems !== 'undefined') {
      _nextStep.call(this);
    }
  }

  /**
   * Go to next step on intro
   *
   * @api private
   * @method _nextStep
   */
  function _nextStep() {
    this._direction = 'forward';

    if (typeof this._currentStepNumber !== 'undefined') {
      _forEach(this._introItems, function (item, i) {
        if (item.step === this._currentStepNumber) {
          this._currentStep = i - 1;
          this._currentStepNumber = undefined;
        }
      }.bind(this));
    }

    if (typeof this._currentStep === 'undefined') {
      this._currentStep = 0;
    } else {
      ++this._currentStep;
    }

    var nextStep = this._introItems[this._currentStep];
    var continueStep = true;

    if (typeof this._introBeforeChangeCallback !== 'undefined') {
      continueStep = this._introBeforeChangeCallback.call(this, nextStep.element);
    }

    // if `onbeforechange` returned `false`, stop displaying the element
    if (continueStep === false) {
      --this._currentStep;
      return false;
    }

    if (this._introItems.length <= this._currentStep) {
      //end of the intro
      //check if any callback is defined
      if (typeof this._introCompleteCallback === 'function') {
        this._introCompleteCallback.call(this);
      }
      _exitIntro.call(this, this._targetElement);
      return;
    }

    _showElement.call(this, nextStep);
  }

  /**
   * Go to previous step on intro
   *
   * @api private
   * @method _previousStep
   */
  function _previousStep() {
    this._direction = 'backward';

    if (this._currentStep === 0) {
      return false;
    }

    --this._currentStep;

    var nextStep = this._introItems[this._currentStep];
    var continueStep = true;

    if (typeof this._introBeforeChangeCallback !== 'undefined') {
      continueStep = this._introBeforeChangeCallback.call(this, nextStep.element);
    }

    // if `onbeforechange` returned `false`, stop displaying the element
    if (continueStep === false) {
      ++this._currentStep;
      return false;
    }

    _showElement.call(this, nextStep);
  }

  /**
   * Update placement of the intro objects on the screen
   * @api private
   */
  function _refresh() {
    // re-align intros
    _setHelperLayerPosition.call(this, document.querySelector('.introjs-helperLayer'));
    _setHelperLayerPosition.call(this, document.querySelector('.introjs-tooltipReferenceLayer'));
    _setHelperLayerPosition.call(this, document.querySelector('.introjs-disableInteraction'));

    // re-align tooltip
    if (this._currentStep !== undefined && this._currentStep !== null) {
      var oldHelperNumberLayer = document.querySelector('.introjs-helperNumberLayer'),
          oldArrowLayer = document.querySelector('.introjs-arrow'),
          oldtooltipContainer = document.querySelector('.introjs-tooltip');
      _placeTooltip.call(this, this._introItems[this._currentStep].element, oldtooltipContainer, oldArrowLayer, oldHelperNumberLayer);
    }

    //re-align hints
    _reAlignHints.call(this);
    return this;
  }

  /**
   * Exit from intro
   *
   * @api private
   * @method _exitIntro
   * @param {Object} targetElement
   * @param {Boolean} force - Setting to `true` will skip the result of beforeExit callback
   */
  function _exitIntro(targetElement, force) {
    var continueExit = true;

    // calling onbeforeexit callback
    //
    // If this callback return `false`, it would halt the process
    if (this._introBeforeExitCallback !== undefined) {
      continueExit = this._introBeforeExitCallback.call(this);
    }

    // skip this check if `force` parameter is `true`
    // otherwise, if `onbeforeexit` returned `false`, don't exit the intro
    if (!force && continueExit === false) return;

    //remove overlay layers from the page
    var overlayLayers = targetElement.querySelectorAll('.introjs-overlay');

    if (overlayLayers && overlayLayers.length) {
      _forEach(overlayLayers, function (overlayLayer) {
        overlayLayer.style.opacity = 0;
        window.setTimeout(function () {
          if (this.parentNode) {
            this.parentNode.removeChild(this);
          }
        }.bind(overlayLayer), 500);
      }.bind(this));
    }

    //remove all helper layers
    var helperLayer = targetElement.querySelector('.introjs-helperLayer');
    if (helperLayer) {
      helperLayer.parentNode.removeChild(helperLayer);
    }

    var referenceLayer = targetElement.querySelector('.introjs-tooltipReferenceLayer');
    if (referenceLayer) {
      referenceLayer.parentNode.removeChild(referenceLayer);
    }

    //remove disableInteractionLayer
    var disableInteractionLayer = targetElement.querySelector('.introjs-disableInteraction');
    if (disableInteractionLayer) {
      disableInteractionLayer.parentNode.removeChild(disableInteractionLayer);
    }

    //remove intro floating element
    var floatingElement = document.querySelector('.introjsFloatingElement');
    if (floatingElement) {
      floatingElement.parentNode.removeChild(floatingElement);
    }

    _removeShowElement();

    //remove `introjs-fixParent` class from the elements
    var fixParents = document.querySelectorAll('.introjs-fixParent');
    _forEach(fixParents, function (parent) {
      _removeClass(parent, /introjs-fixParent/g);
    });

    //clean listeners
    DOMEvent.off(window, 'keydown', _onKeyDown, this, true);
    DOMEvent.off(window, 'resize', _onResize, this, true);

    //check if any callback is defined
    if (this._introExitCallback !== undefined) {
      this._introExitCallback.call(this);
    }

    //set the step to zero
    this._currentStep = undefined;
  }

  /**
   * Render tooltip box in the page
   *
   * @api private
   * @method _placeTooltip
   * @param {HTMLElement} targetElement
   * @param {HTMLElement} tooltipLayer
   * @param {HTMLElement} arrowLayer
   * @param {HTMLElement} helperNumberLayer
   * @param {Boolean} hintMode
   */
  function _placeTooltip(targetElement, tooltipLayer, arrowLayer, helperNumberLayer, hintMode) {
    var tooltipCssClass = '',
        currentStepObj,
        tooltipOffset,
        targetOffset,
        windowSize,
        currentTooltipPosition;

    hintMode = hintMode || false;

    //reset the old style
    tooltipLayer.style.top = null;
    tooltipLayer.style.right = null;
    tooltipLayer.style.bottom = null;
    tooltipLayer.style.left = null;
    tooltipLayer.style.marginLeft = null;
    tooltipLayer.style.marginTop = null;

    arrowLayer.style.display = 'inherit';

    if (typeof helperNumberLayer !== 'undefined' && helperNumberLayer !== null) {
      helperNumberLayer.style.top = null;
      helperNumberLayer.style.left = null;
    }

    //prevent error when `this._currentStep` is undefined
    if (!this._introItems[this._currentStep]) return;

    //if we have a custom css class for each step
    currentStepObj = this._introItems[this._currentStep];
    if (typeof currentStepObj.tooltipClass === 'string') {
      tooltipCssClass = currentStepObj.tooltipClass;
    } else {
      tooltipCssClass = this._options.tooltipClass;
    }

    tooltipLayer.className = ('introjs-tooltip ' + tooltipCssClass).replace(/^\s+|\s+$/g, '');
    tooltipLayer.setAttribute('role', 'dialog');

    currentTooltipPosition = this._introItems[this._currentStep].position;

    // Floating is always valid, no point in calculating
    if (currentTooltipPosition !== "floating") {
      currentTooltipPosition = _determineAutoPosition.call(this, targetElement, tooltipLayer, currentTooltipPosition);
    }

    var tooltipLayerStyleLeft;
    targetOffset = _getOffset(targetElement);
    tooltipOffset = _getOffset(tooltipLayer);
    windowSize = _getWinSize();

    _addClass(tooltipLayer, 'introjs-' + currentTooltipPosition);

    switch (currentTooltipPosition) {
      case 'top-right-aligned':
        arrowLayer.className = 'introjs-arrow bottom-right';

        var tooltipLayerStyleRight = 0;
        _checkLeft(targetOffset, tooltipLayerStyleRight, tooltipOffset, tooltipLayer);
        tooltipLayer.style.bottom = targetOffset.height + 20 + 'px';
        break;

      case 'top-middle-aligned':
        arrowLayer.className = 'introjs-arrow bottom-middle';

        var tooltipLayerStyleLeftRight = targetOffset.width / 2 - tooltipOffset.width / 2;

        // a fix for middle aligned hints
        if (hintMode) {
          tooltipLayerStyleLeftRight += 5;
        }

        if (_checkLeft(targetOffset, tooltipLayerStyleLeftRight, tooltipOffset, tooltipLayer)) {
          tooltipLayer.style.right = null;
          _checkRight(targetOffset, tooltipLayerStyleLeftRight, tooltipOffset, windowSize, tooltipLayer);
        }
        tooltipLayer.style.bottom = targetOffset.height + 20 + 'px';
        break;

      case 'top-left-aligned':
      // top-left-aligned is the same as the default top
      case 'top':
        arrowLayer.className = 'introjs-arrow bottom';

        tooltipLayerStyleLeft = hintMode ? 0 : 15;

        _checkRight(targetOffset, tooltipLayerStyleLeft, tooltipOffset, windowSize, tooltipLayer);
        tooltipLayer.style.bottom = targetOffset.height + 20 + 'px';
        break;
      case 'right':
        tooltipLayer.style.left = targetOffset.width + 20 + 'px';
        if (targetOffset.top + tooltipOffset.height > windowSize.height) {
          // In this case, right would have fallen below the bottom of the screen.
          // Modify so that the bottom of the tooltip connects with the target
          arrowLayer.className = "introjs-arrow left-bottom";
          tooltipLayer.style.top = "-" + (tooltipOffset.height - targetOffset.height - 20) + "px";
        } else {
          arrowLayer.className = 'introjs-arrow left';
        }
        break;
      case 'left':
        if (!hintMode && this._options.showStepNumbers === true) {
          tooltipLayer.style.top = '15px';
        }

        if (targetOffset.top + tooltipOffset.height > windowSize.height) {
          // In this case, left would have fallen below the bottom of the screen.
          // Modify so that the bottom of the tooltip connects with the target
          tooltipLayer.style.top = "-" + (tooltipOffset.height - targetOffset.height - 20) + "px";
          arrowLayer.className = 'introjs-arrow right-bottom';
        } else {
          arrowLayer.className = 'introjs-arrow right';
        }
        tooltipLayer.style.right = targetOffset.width + 20 + 'px';

        break;
      case 'floating':
        arrowLayer.style.display = 'none';

        //we have to adjust the top and left of layer manually for intro items without element
        tooltipLayer.style.left = '50%';
        tooltipLayer.style.top = '50%';
        tooltipLayer.style.marginLeft = '-' + tooltipOffset.width / 2 + 'px';
        tooltipLayer.style.marginTop = '-' + tooltipOffset.height / 2 + 'px';

        if (typeof helperNumberLayer !== 'undefined' && helperNumberLayer !== null) {
          helperNumberLayer.style.left = '-' + (tooltipOffset.width / 2 + 18) + 'px';
          helperNumberLayer.style.top = '-' + (tooltipOffset.height / 2 + 18) + 'px';
        }

        break;
      case 'bottom-right-aligned':
        arrowLayer.className = 'introjs-arrow top-right';

        tooltipLayerStyleRight = 0;
        _checkLeft(targetOffset, tooltipLayerStyleRight, tooltipOffset, tooltipLayer);
        tooltipLayer.style.top = targetOffset.height + 20 + 'px';
        break;

      case 'bottom-middle-aligned':
        arrowLayer.className = 'introjs-arrow top-middle';

        tooltipLayerStyleLeftRight = targetOffset.width / 2 - tooltipOffset.width / 2;

        // a fix for middle aligned hints
        if (hintMode) {
          tooltipLayerStyleLeftRight += 5;
        }

        if (_checkLeft(targetOffset, tooltipLayerStyleLeftRight, tooltipOffset, tooltipLayer)) {
          tooltipLayer.style.right = null;
          _checkRight(targetOffset, tooltipLayerStyleLeftRight, tooltipOffset, windowSize, tooltipLayer);
        }
        tooltipLayer.style.top = targetOffset.height + 20 + 'px';
        break;

      // case 'bottom-left-aligned':
      // Bottom-left-aligned is the same as the default bottom
      // case 'bottom':
      // Bottom going to follow the default behavior
      default:
        arrowLayer.className = 'introjs-arrow top';

        tooltipLayerStyleLeft = 0;
        _checkRight(targetOffset, tooltipLayerStyleLeft, tooltipOffset, windowSize, tooltipLayer);
        tooltipLayer.style.top = targetOffset.height + 20 + 'px';
    }
  }

  /**
   * Set tooltip left so it doesn't go off the right side of the window
   *
   * @return boolean true, if tooltipLayerStyleLeft is ok.  false, otherwise.
   */
  function _checkRight(targetOffset, tooltipLayerStyleLeft, tooltipOffset, windowSize, tooltipLayer) {
    if (targetOffset.left + tooltipLayerStyleLeft + tooltipOffset.width > windowSize.width) {
      // off the right side of the window
      tooltipLayer.style.left = windowSize.width - tooltipOffset.width - targetOffset.left + 'px';
      return false;
    }
    tooltipLayer.style.left = tooltipLayerStyleLeft + 'px';
    return true;
  }

  /**
   * Set tooltip right so it doesn't go off the left side of the window
   *
   * @return boolean true, if tooltipLayerStyleRight is ok.  false, otherwise.
   */
  function _checkLeft(targetOffset, tooltipLayerStyleRight, tooltipOffset, tooltipLayer) {
    if (targetOffset.left + targetOffset.width - tooltipLayerStyleRight - tooltipOffset.width < 0) {
      // off the left side of the window
      tooltipLayer.style.left = -targetOffset.left + 'px';
      return false;
    }
    tooltipLayer.style.right = tooltipLayerStyleRight + 'px';
    return true;
  }

  /**
   * Determines the position of the tooltip based on the position precedence and availability
   * of screen space.
   *
   * @param {Object}    targetElement
   * @param {Object}    tooltipLayer
   * @param {String}    desiredTooltipPosition
   * @return {String}   calculatedPosition
   */
  function _determineAutoPosition(targetElement, tooltipLayer, desiredTooltipPosition) {

    // Take a clone of position precedence. These will be the available
    var possiblePositions = this._options.positionPrecedence.slice();

    var windowSize = _getWinSize();
    var tooltipHeight = _getOffset(tooltipLayer).height + 10;
    var tooltipWidth = _getOffset(tooltipLayer).width + 20;
    var targetElementRect = targetElement.getBoundingClientRect();

    // If we check all the possible areas, and there are no valid places for the tooltip, the element
    // must take up most of the screen real estate. Show the tooltip floating in the middle of the screen.
    var calculatedPosition = "floating";

    /*
    * auto determine position 
    */

    // Check for space below
    if (targetElementRect.bottom + tooltipHeight + tooltipHeight > windowSize.height) {
      _removeEntry(possiblePositions, "bottom");
    }

    // Check for space above
    if (targetElementRect.top - tooltipHeight < 0) {
      _removeEntry(possiblePositions, "top");
    }

    // Check for space to the right
    if (targetElementRect.right + tooltipWidth > windowSize.width) {
      _removeEntry(possiblePositions, "right");
    }

    // Check for space to the left
    if (targetElementRect.left - tooltipWidth < 0) {
      _removeEntry(possiblePositions, "left");
    }

    // @var {String}  ex: 'right-aligned'
    var desiredAlignment = function (pos) {
      var hyphenIndex = pos.indexOf('-');
      if (hyphenIndex !== -1) {
        // has alignment
        return pos.substr(hyphenIndex);
      }
      return '';
    }(desiredTooltipPosition || '');

    // strip alignment from position
    if (desiredTooltipPosition) {
      // ex: "bottom-right-aligned"
      // should return 'bottom'
      desiredTooltipPosition = desiredTooltipPosition.split('-')[0];
    }

    if (possiblePositions.length) {
      if (desiredTooltipPosition !== "auto" && possiblePositions.indexOf(desiredTooltipPosition) > -1) {
        // If the requested position is in the list, choose that
        calculatedPosition = desiredTooltipPosition;
      } else {
        // Pick the first valid position, in order
        calculatedPosition = possiblePositions[0];
      }
    }

    // only top and bottom positions have optional alignments
    if (['top', 'bottom'].indexOf(calculatedPosition) !== -1) {
      calculatedPosition += _determineAutoAlignment(targetElementRect.left, tooltipWidth, windowSize, desiredAlignment);
    }

    return calculatedPosition;
  }

  /**
  * auto-determine alignment
  * @param {Integer}  offsetLeft
  * @param {Integer}  tooltipWidth
  * @param {Object}   windowSize
  * @param {String}   desiredAlignment
  * @return {String}  calculatedAlignment
  */
  function _determineAutoAlignment(offsetLeft, tooltipWidth, windowSize, desiredAlignment) {
    var halfTooltipWidth = tooltipWidth / 2,
        winWidth = Math.min(windowSize.width, window.screen.width),
        possibleAlignments = ['-left-aligned', '-middle-aligned', '-right-aligned'],
        calculatedAlignment = '';

    // valid left must be at least a tooltipWidth
    // away from right side
    if (winWidth - offsetLeft < tooltipWidth) {
      _removeEntry(possibleAlignments, '-left-aligned');
    }

    // valid middle must be at least half 
    // width away from both sides
    if (offsetLeft < halfTooltipWidth || winWidth - offsetLeft < halfTooltipWidth) {
      _removeEntry(possibleAlignments, '-middle-aligned');
    }

    // valid right must be at least a tooltipWidth
    // width away from left side
    if (offsetLeft < tooltipWidth) {
      _removeEntry(possibleAlignments, '-right-aligned');
    }

    if (possibleAlignments.length) {
      if (possibleAlignments.indexOf(desiredAlignment) !== -1) {
        // the desired alignment is valid
        calculatedAlignment = desiredAlignment;
      } else {
        // pick the first valid position, in order
        calculatedAlignment = possibleAlignments[0];
      }
    } else {
      // if screen width is too small 
      // for ANY alignment, middle is 
      // probably the best for visibility
      calculatedAlignment = '-middle-aligned';
    }

    return calculatedAlignment;
  }

  /**
   * Remove an entry from a string array if it's there, does nothing if it isn't there.
   *
   * @param {Array} stringArray
   * @param {String} stringToRemove
   */
  function _removeEntry(stringArray, stringToRemove) {
    if (stringArray.indexOf(stringToRemove) > -1) {
      stringArray.splice(stringArray.indexOf(stringToRemove), 1);
    }
  }

  /**
   * Update the position of the helper layer on the screen
   *
   * @api private
   * @method _setHelperLayerPosition
   * @param {Object} helperLayer
   */
  function _setHelperLayerPosition(helperLayer) {
    if (helperLayer) {
      //prevent error when `this._currentStep` in undefined
      if (!this._introItems[this._currentStep]) return;

      var currentElement = this._introItems[this._currentStep],
          elementPosition = _getOffset(currentElement.element),
          widthHeightPadding = this._options.helperElementPadding;

      // If the target element is fixed, the tooltip should be fixed as well.
      // Otherwise, remove a fixed class that may be left over from the previous
      // step.
      if (_isFixed(currentElement.element)) {
        _addClass(helperLayer, 'introjs-fixedTooltip');
      } else {
        _removeClass(helperLayer, 'introjs-fixedTooltip');
      }

      if (currentElement.position === 'floating') {
        widthHeightPadding = 0;
      }

      //set new position to helper layer
      helperLayer.style.cssText = 'width: ' + (elementPosition.width + widthHeightPadding) + 'px; ' + 'height:' + (elementPosition.height + widthHeightPadding) + 'px; ' + 'top:' + (elementPosition.top - widthHeightPadding / 2) + 'px;' + 'left: ' + (elementPosition.left - widthHeightPadding / 2) + 'px;';
    }
  }

  /**
   * Add disableinteraction layer and adjust the size and position of the layer
   *
   * @api private
   * @method _disableInteraction
   */
  function _disableInteraction() {
    var disableInteractionLayer = document.querySelector('.introjs-disableInteraction');

    if (disableInteractionLayer === null) {
      disableInteractionLayer = document.createElement('div');
      disableInteractionLayer.className = 'introjs-disableInteraction';
      this._targetElement.appendChild(disableInteractionLayer);
    }

    _setHelperLayerPosition.call(this, disableInteractionLayer);
  }

  /**
   * Setting anchors to behave like buttons
   *
   * @api private
   * @method _setAnchorAsButton
   */
  function _setAnchorAsButton(anchor) {
    anchor.setAttribute('role', 'button');
    anchor.tabIndex = 0;
  }

  /**
   * Show an element on the page
   *
   * @api private
   * @method _showElement
   * @param {Object} targetElement
   */
  function _showElement(targetElement) {
    if (typeof this._introChangeCallback !== 'undefined') {
      this._introChangeCallback.call(this, targetElement.element);
    }

    var self = this,
        oldHelperLayer = document.querySelector('.introjs-helperLayer'),
        oldReferenceLayer = document.querySelector('.introjs-tooltipReferenceLayer'),
        highlightClass = 'introjs-helperLayer',
        nextTooltipButton,
        prevTooltipButton,
        skipTooltipButton,
        scrollParent;

    //check for a current step highlight class
    if (typeof targetElement.highlightClass === 'string') {
      highlightClass += ' ' + targetElement.highlightClass;
    }
    //check for options highlight class
    if (typeof this._options.highlightClass === 'string') {
      highlightClass += ' ' + this._options.highlightClass;
    }

    if (oldHelperLayer !== null) {
      var oldHelperNumberLayer = oldReferenceLayer.querySelector('.introjs-helperNumberLayer'),
          oldtooltipLayer = oldReferenceLayer.querySelector('.introjs-tooltiptext'),
          oldArrowLayer = oldReferenceLayer.querySelector('.introjs-arrow'),
          oldtooltipContainer = oldReferenceLayer.querySelector('.introjs-tooltip');

      skipTooltipButton = oldReferenceLayer.querySelector('.introjs-skipbutton');
      prevTooltipButton = oldReferenceLayer.querySelector('.introjs-prevbutton');
      nextTooltipButton = oldReferenceLayer.querySelector('.introjs-nextbutton');

      //update or reset the helper highlight class
      oldHelperLayer.className = highlightClass;
      //hide the tooltip
      oldtooltipContainer.style.opacity = 0;
      oldtooltipContainer.style.display = "none";

      if (oldHelperNumberLayer !== null) {
        var lastIntroItem = this._introItems[targetElement.step - 2 >= 0 ? targetElement.step - 2 : 0];

        if (lastIntroItem !== null && this._direction === 'forward' && lastIntroItem.position === 'floating' || this._direction === 'backward' && targetElement.position === 'floating') {
          oldHelperNumberLayer.style.opacity = 0;
        }
      }

      // scroll to element
      scrollParent = _getScrollParent(targetElement.element);

      if (scrollParent !== document.body) {
        // target is within a scrollable element
        _scrollParentToElement(scrollParent, targetElement.element);
      }

      // set new position to helper layer
      _setHelperLayerPosition.call(self, oldHelperLayer);
      _setHelperLayerPosition.call(self, oldReferenceLayer);

      //remove `introjs-fixParent` class from the elements
      var fixParents = document.querySelectorAll('.introjs-fixParent');
      _forEach(fixParents, function (parent) {
        _removeClass(parent, /introjs-fixParent/g);
      });

      //remove old classes if the element still exist
      _removeShowElement();

      //we should wait until the CSS3 transition is competed (it's 0.3 sec) to prevent incorrect `height` and `width` calculation
      if (self._lastShowElementTimer) {
        window.clearTimeout(self._lastShowElementTimer);
      }

      self._lastShowElementTimer = window.setTimeout(function () {
        //set current step to the label
        if (oldHelperNumberLayer !== null) {
          oldHelperNumberLayer.innerHTML = targetElement.step;
        }
        //set current tooltip text
        oldtooltipLayer.innerHTML = targetElement.intro;
        //set the tooltip position
        oldtooltipContainer.style.display = "block";
        _placeTooltip.call(self, targetElement.element, oldtooltipContainer, oldArrowLayer, oldHelperNumberLayer);

        //change active bullet
        if (self._options.showBullets) {
          oldReferenceLayer.querySelector('.introjs-bullets li > a.active').className = '';
          oldReferenceLayer.querySelector('.introjs-bullets li > a[data-stepnumber="' + targetElement.step + '"]').className = 'active';
        }
        oldReferenceLayer.querySelector('.introjs-progress .introjs-progressbar').style.cssText = 'width:' + _getProgress.call(self) + '%;';
        oldReferenceLayer.querySelector('.introjs-progress .introjs-progressbar').setAttribute('aria-valuenow', _getProgress.call(self));

        //show the tooltip
        oldtooltipContainer.style.opacity = 1;
        if (oldHelperNumberLayer) oldHelperNumberLayer.style.opacity = 1;

        //reset button focus
        if (typeof skipTooltipButton !== "undefined" && skipTooltipButton !== null && /introjs-donebutton/gi.test(skipTooltipButton.className)) {
          // skip button is now "done" button
          skipTooltipButton.focus();
        } else if (typeof nextTooltipButton !== "undefined" && nextTooltipButton !== null) {
          //still in the tour, focus on next
          nextTooltipButton.focus();
        }

        // change the scroll of the window, if needed
        _scrollTo.call(self, targetElement.scrollTo, targetElement, oldtooltipLayer);
      }, 350);

      // end of old element if-else condition
    } else {
      var helperLayer = document.createElement('div'),
          referenceLayer = document.createElement('div'),
          arrowLayer = document.createElement('div'),
          tooltipLayer = document.createElement('div'),
          tooltipTextLayer = document.createElement('div'),
          bulletsLayer = document.createElement('div'),
          progressLayer = document.createElement('div'),
          buttonsLayer = document.createElement('div');

      helperLayer.className = highlightClass;
      referenceLayer.className = 'introjs-tooltipReferenceLayer';

      // scroll to element
      scrollParent = _getScrollParent(targetElement.element);

      if (scrollParent !== document.body) {
        // target is within a scrollable element
        _scrollParentToElement(scrollParent, targetElement.element);
      }

      //set new position to helper layer
      _setHelperLayerPosition.call(self, helperLayer);
      _setHelperLayerPosition.call(self, referenceLayer);

      //add helper layer to target element
      this._targetElement.appendChild(helperLayer);
      this._targetElement.appendChild(referenceLayer);

      arrowLayer.className = 'introjs-arrow';

      tooltipTextLayer.className = 'introjs-tooltiptext';
      tooltipTextLayer.innerHTML = targetElement.intro;

      bulletsLayer.className = 'introjs-bullets';

      if (this._options.showBullets === false) {
        bulletsLayer.style.display = 'none';
      }

      var ulContainer = document.createElement('ul');
      ulContainer.setAttribute('role', 'tablist');

      var anchorClick = function anchorClick() {
        self.goToStep(this.getAttribute('data-stepnumber'));
      };

      _forEach(this._introItems, function (item, i) {
        var innerLi = document.createElement('li');
        var anchorLink = document.createElement('a');

        innerLi.setAttribute('role', 'presentation');
        anchorLink.setAttribute('role', 'tab');

        anchorLink.onclick = anchorClick;

        if (i === targetElement.step - 1) {
          anchorLink.className = 'active';
        }

        _setAnchorAsButton(anchorLink);
        anchorLink.innerHTML = "&nbsp;";
        anchorLink.setAttribute('data-stepnumber', item.step);

        innerLi.appendChild(anchorLink);
        ulContainer.appendChild(innerLi);
      });

      bulletsLayer.appendChild(ulContainer);

      progressLayer.className = 'introjs-progress';

      if (this._options.showProgress === false) {
        progressLayer.style.display = 'none';
      }
      var progressBar = document.createElement('div');
      progressBar.className = 'introjs-progressbar';
      progressBar.setAttribute('role', 'progress');
      progressBar.setAttribute('aria-valuemin', 0);
      progressBar.setAttribute('aria-valuemax', 100);
      progressBar.setAttribute('aria-valuenow', _getProgress.call(this));
      progressBar.style.cssText = 'width:' + _getProgress.call(this) + '%;';

      progressLayer.appendChild(progressBar);

      buttonsLayer.className = 'introjs-tooltipbuttons';
      if (this._options.showButtons === false) {
        buttonsLayer.style.display = 'none';
      }

      tooltipLayer.className = 'introjs-tooltip';
      tooltipLayer.appendChild(tooltipTextLayer);
      tooltipLayer.appendChild(bulletsLayer);
      tooltipLayer.appendChild(progressLayer);

      //add helper layer number
      var helperNumberLayer = document.createElement('span');
      if (this._options.showStepNumbers === true) {
        helperNumberLayer.className = 'introjs-helperNumberLayer';
        helperNumberLayer.innerHTML = targetElement.step;
        referenceLayer.appendChild(helperNumberLayer);
      }

      tooltipLayer.appendChild(arrowLayer);
      referenceLayer.appendChild(tooltipLayer);

      //next button
      nextTooltipButton = document.createElement('a');

      nextTooltipButton.onclick = function () {
        if (self._introItems.length - 1 !== self._currentStep) {
          _nextStep.call(self);
        }
      };

      _setAnchorAsButton(nextTooltipButton);
      nextTooltipButton.innerHTML = this._options.nextLabel;

      //previous button
      prevTooltipButton = document.createElement('a');

      prevTooltipButton.onclick = function () {
        if (self._currentStep !== 0) {
          _previousStep.call(self);
        }
      };

      _setAnchorAsButton(prevTooltipButton);
      prevTooltipButton.innerHTML = this._options.prevLabel;

      //skip button
      skipTooltipButton = document.createElement('a');
      skipTooltipButton.className = this._options.buttonClass + ' introjs-skipbutton ';
      _setAnchorAsButton(skipTooltipButton);
      skipTooltipButton.innerHTML = this._options.skipLabel;

      skipTooltipButton.onclick = function () {
        if (self._introItems.length - 1 === self._currentStep && typeof self._introCompleteCallback === 'function') {
          self._introCompleteCallback.call(self);
        }

        if (self._introItems.length - 1 !== self._currentStep && typeof self._introExitCallback === 'function') {
          self._introExitCallback.call(self);
        }

        if (typeof self._introSkipCallback === 'function') {
          self._introSkipCallback.call(self);
        }

        _exitIntro.call(self, self._targetElement);
      };

      buttonsLayer.appendChild(skipTooltipButton);

      //in order to prevent displaying next/previous button always
      if (this._introItems.length > 1) {
        buttonsLayer.appendChild(prevTooltipButton);
        buttonsLayer.appendChild(nextTooltipButton);
      }

      tooltipLayer.appendChild(buttonsLayer);

      //set proper position
      _placeTooltip.call(self, targetElement.element, tooltipLayer, arrowLayer, helperNumberLayer);

      // change the scroll of the window, if needed
      _scrollTo.call(this, targetElement.scrollTo, targetElement, tooltipLayer);

      //end of new element if-else condition
    }

    // removing previous disable interaction layer
    var disableInteractionLayer = self._targetElement.querySelector('.introjs-disableInteraction');
    if (disableInteractionLayer) {
      disableInteractionLayer.parentNode.removeChild(disableInteractionLayer);
    }

    //disable interaction
    if (targetElement.disableInteraction) {
      _disableInteraction.call(self);
    }

    // when it's the first step of tour
    if (this._currentStep === 0 && this._introItems.length > 1) {
      if (typeof skipTooltipButton !== "undefined" && skipTooltipButton !== null) {
        skipTooltipButton.className = this._options.buttonClass + ' introjs-skipbutton';
      }
      if (typeof nextTooltipButton !== "undefined" && nextTooltipButton !== null) {
        nextTooltipButton.className = this._options.buttonClass + ' introjs-nextbutton';
      }

      if (this._options.hidePrev === true) {
        if (typeof prevTooltipButton !== "undefined" && prevTooltipButton !== null) {
          prevTooltipButton.className = this._options.buttonClass + ' introjs-prevbutton introjs-hidden';
        }
        if (typeof nextTooltipButton !== "undefined" && nextTooltipButton !== null) {
          _addClass(nextTooltipButton, 'introjs-fullbutton');
        }
      } else {
        if (typeof prevTooltipButton !== "undefined" && prevTooltipButton !== null) {
          prevTooltipButton.className = this._options.buttonClass + ' introjs-prevbutton introjs-disabled';
        }
      }

      if (typeof skipTooltipButton !== "undefined" && skipTooltipButton !== null) {
        skipTooltipButton.innerHTML = this._options.skipLabel;
      }
    } else if (this._introItems.length - 1 === this._currentStep || this._introItems.length === 1) {
      // last step of tour
      if (typeof skipTooltipButton !== "undefined" && skipTooltipButton !== null) {
        skipTooltipButton.innerHTML = this._options.doneLabel;
        // adding donebutton class in addition to skipbutton
        _addClass(skipTooltipButton, 'introjs-donebutton');
      }
      if (typeof prevTooltipButton !== "undefined" && prevTooltipButton !== null) {
        prevTooltipButton.className = this._options.buttonClass + ' introjs-prevbutton';
      }

      if (this._options.hideNext === true) {
        if (typeof nextTooltipButton !== "undefined" && nextTooltipButton !== null) {
          nextTooltipButton.className = this._options.buttonClass + ' introjs-nextbutton introjs-hidden';
        }
        if (typeof prevTooltipButton !== "undefined" && prevTooltipButton !== null) {
          _addClass(prevTooltipButton, 'introjs-fullbutton');
        }
      } else {
        if (typeof nextTooltipButton !== "undefined" && nextTooltipButton !== null) {
          nextTooltipButton.className = this._options.buttonClass + ' introjs-nextbutton introjs-disabled';
        }
      }
    } else {
      // steps between start and end
      if (typeof skipTooltipButton !== "undefined" && skipTooltipButton !== null) {
        skipTooltipButton.className = this._options.buttonClass + ' introjs-skipbutton';
      }
      if (typeof prevTooltipButton !== "undefined" && prevTooltipButton !== null) {
        prevTooltipButton.className = this._options.buttonClass + ' introjs-prevbutton';
      }
      if (typeof nextTooltipButton !== "undefined" && nextTooltipButton !== null) {
        nextTooltipButton.className = this._options.buttonClass + ' introjs-nextbutton';
      }
      if (typeof skipTooltipButton !== "undefined" && skipTooltipButton !== null) {
        skipTooltipButton.innerHTML = this._options.skipLabel;
      }
    }

    prevTooltipButton.setAttribute('role', 'button');
    nextTooltipButton.setAttribute('role', 'button');
    skipTooltipButton.setAttribute('role', 'button');

    //Set focus on "next" button, so that hitting Enter always moves you onto the next step
    if (typeof nextTooltipButton !== "undefined" && nextTooltipButton !== null) {
      nextTooltipButton.focus();
    }

    _setShowElement(targetElement);

    if (typeof this._introAfterChangeCallback !== 'undefined') {
      this._introAfterChangeCallback.call(this, targetElement.element);
    }
  }

  /**
   * To change the scroll of `window` after highlighting an element
   *
   * @api private
   * @method _scrollTo
   * @param {String} scrollTo
   * @param {Object} targetElement
   * @param {Object} tooltipLayer
   */
  function _scrollTo(scrollTo, targetElement, tooltipLayer) {
    if (scrollTo === 'off') return;
    var rect;

    if (!this._options.scrollToElement) return;

    if (scrollTo === 'tooltip') {
      rect = tooltipLayer.getBoundingClientRect();
    } else {
      rect = targetElement.element.getBoundingClientRect();
    }

    if (!_elementInViewport(targetElement.element)) {
      var winHeight = _getWinSize().height;
      var top = rect.bottom - (rect.bottom - rect.top);

      // TODO (afshinm): do we need scroll padding now?
      // I have changed the scroll option and now it scrolls the window to
      // the center of the target element or tooltip.

      if (top < 0 || targetElement.element.clientHeight > winHeight) {
        window.scrollBy(0, rect.top - (winHeight / 2 - rect.height / 2) - this._options.scrollPadding); // 30px padding from edge to look nice

        //Scroll down
      } else {
        window.scrollBy(0, rect.top - (winHeight / 2 - rect.height / 2) + this._options.scrollPadding); // 30px padding from edge to look nice
      }
    }
  }

  /**
   * To remove all show element(s)
   *
   * @api private
   * @method _removeShowElement
   */
  function _removeShowElement() {
    var elms = document.querySelectorAll('.introjs-showElement');

    _forEach(elms, function (elm) {
      _removeClass(elm, /introjs-[a-zA-Z]+/g);
    });
  }

  /**
   * To set the show element
   * This function set a relative (in most cases) position and changes the z-index
   *
   * @api private
   * @method _setShowElement
   * @param {Object} targetElement
   */
  function _setShowElement(targetElement) {
    var parentElm;
    // we need to add this show element class to the parent of SVG elements
    // because the SVG elements can't have independent z-index
    if (targetElement.element instanceof SVGElement) {
      parentElm = targetElement.element.parentNode;

      while (targetElement.element.parentNode !== null) {
        if (!parentElm.tagName || parentElm.tagName.toLowerCase() === 'body') break;

        if (parentElm.tagName.toLowerCase() === 'svg') {
          _addClass(parentElm, 'introjs-showElement introjs-relativePosition');
        }

        parentElm = parentElm.parentNode;
      }
    }

    _addClass(targetElement.element, 'introjs-showElement');

    var currentElementPosition = _getPropValue(targetElement.element, 'position');
    if (currentElementPosition !== 'absolute' && currentElementPosition !== 'relative' && currentElementPosition !== 'fixed') {
      //change to new intro item
      _addClass(targetElement.element, 'introjs-relativePosition');
    }

    parentElm = targetElement.element.parentNode;
    while (parentElm !== null) {
      if (!parentElm.tagName || parentElm.tagName.toLowerCase() === 'body') break;

      //fix The Stacking Context problem.
      //More detail: https://developer.mozilla.org/en-US/docs/Web/Guide/CSS/Understanding_z_index/The_stacking_context
      var zIndex = _getPropValue(parentElm, 'z-index');
      var opacity = parseFloat(_getPropValue(parentElm, 'opacity'));
      var transform = _getPropValue(parentElm, 'transform') || _getPropValue(parentElm, '-webkit-transform') || _getPropValue(parentElm, '-moz-transform') || _getPropValue(parentElm, '-ms-transform') || _getPropValue(parentElm, '-o-transform');
      if (/[0-9]+/.test(zIndex) || opacity < 1 || transform !== 'none' && transform !== undefined) {
        _addClass(parentElm, 'introjs-fixParent');
      }

      parentElm = parentElm.parentNode;
    }
  }

  /**
  * Iterates arrays
  *
  * @param {Array} arr
  * @param {Function} forEachFnc
  * @param {Function} completeFnc
  * @return {Null}
  */
  function _forEach(arr, forEachFnc, completeFnc) {
    // in case arr is an empty query selector node list
    if (arr) {
      for (var i = 0, len = arr.length; i < len; i++) {
        forEachFnc(arr[i], i);
      }
    }

    if (typeof completeFnc === 'function') {
      completeFnc();
    }
  }

  /**
  * Mark any object with an incrementing number
  * used for keeping track of objects
  *
  * @param Object obj   Any object or DOM Element
  * @param String key
  * @return Object
  */
  var _stamp = function () {
    var keys = {};
    return function stamp(obj, key) {

      // get group key
      key = key || 'introjs-stamp';

      // each group increments from 0
      keys[key] = keys[key] || 0;

      // stamp only once per object
      if (obj[key] === undefined) {
        // increment key for each new object
        obj[key] = keys[key]++;
      }

      return obj[key];
    };
  }();

  /**
  * DOMEvent Handles all DOM events
  *
  * methods:
  *
  * on - add event handler
  * off - remove event
  */
  var DOMEvent = function () {
    function DOMEvent() {
      var events_key = 'introjs_event';

      /**
      * Gets a unique ID for an event listener
      *
      * @param Object obj
      * @param String type        event type
      * @param Function listener
      * @param Object context
      * @return String
      */
      this._id = function (obj, type, listener, context) {
        return type + _stamp(listener) + (context ? '_' + _stamp(context) : '');
      };

      /**
      * Adds event listener
      *
      * @param Object obj
      * @param String type        event type
      * @param Function listener
      * @param Object context
      * @param Boolean useCapture
      * @return null
      */
      this.on = function (obj, type, listener, context, useCapture) {
        var id = this._id.apply(this, arguments),
            handler = function handler(e) {
          return listener.call(context || obj, e || window.event);
        };

        if ('addEventListener' in obj) {
          obj.addEventListener(type, handler, useCapture);
        } else if ('attachEvent' in obj) {
          obj.attachEvent('on' + type, handler);
        }

        obj[events_key] = obj[events_key] || {};
        obj[events_key][id] = handler;
      };

      /**
      * Removes event listener
      *
      * @param Object obj
      * @param String type        event type
      * @param Function listener
      * @param Object context
      * @param Boolean useCapture
      * @return null
      */
      this.off = function (obj, type, listener, context, useCapture) {
        var id = this._id.apply(this, arguments),
            handler = obj[events_key] && obj[events_key][id];

        if (!handler) {
          return;
        }

        if ('removeEventListener' in obj) {
          obj.removeEventListener(type, handler, useCapture);
        } else if ('detachEvent' in obj) {
          obj.detachEvent('on' + type, handler);
        }

        obj[events_key][id] = null;
      };
    }

    return new DOMEvent();
  }();

  /**
   * Append a class to an element
   *
   * @api private
   * @method _addClass
   * @param {Object} element
   * @param {String} className
   * @returns null
   */
  function _addClass(element, className) {
    if (element instanceof SVGElement) {
      // svg
      var pre = element.getAttribute('class') || '';

      element.setAttribute('class', pre + ' ' + className);
    } else {
      if (element.classList !== undefined) {
        // check for modern classList property
        var classes = className.split(' ');
        _forEach(classes, function (cls) {
          element.classList.add(cls);
        });
      } else if (!element.className.match(className)) {
        // check if element doesn't already have className
        element.className += ' ' + className;
      }
    }
  }

  /**
   * Remove a class from an element
   *
   * @api private
   * @method _removeClass
   * @param {Object} element
   * @param {RegExp|String} classNameRegex can be regex or string
   * @returns null
   */
  function _removeClass(element, classNameRegex) {
    if (element instanceof SVGElement) {
      var pre = element.getAttribute('class') || '';

      element.setAttribute('class', pre.replace(classNameRegex, '').replace(/^\s+|\s+$/g, ''));
    } else {
      element.className = element.className.replace(classNameRegex, '').replace(/^\s+|\s+$/g, '');
    }
  }

  /**
   * Get an element CSS property on the page
   * Thanks to JavaScript Kit: http://www.javascriptkit.com/dhtmltutors/dhtmlcascade4.shtml
   *
   * @api private
   * @method _getPropValue
   * @param {Object} element
   * @param {String} propName
   * @returns Element's property value
   */
  function _getPropValue(element, propName) {
    var propValue = '';
    if (element.currentStyle) {
      //IE
      propValue = element.currentStyle[propName];
    } else if (document.defaultView && document.defaultView.getComputedStyle) {
      //Others
      propValue = document.defaultView.getComputedStyle(element, null).getPropertyValue(propName);
    }

    //Prevent exception in IE
    if (propValue && propValue.toLowerCase) {
      return propValue.toLowerCase();
    } else {
      return propValue;
    }
  }

  /**
   * Checks to see if target element (or parents) position is fixed or not
   *
   * @api private
   * @method _isFixed
   * @param {Object} element
   * @returns Boolean
   */
  function _isFixed(element) {
    var p = element.parentNode;

    if (!p || p.nodeName === 'HTML') {
      return false;
    }

    if (_getPropValue(element, 'position') === 'fixed') {
      return true;
    }

    return _isFixed(p);
  }

  /**
   * Provides a cross-browser way to get the screen dimensions
   * via: http://stackoverflow.com/questions/5864467/internet-explorer-innerheight
   *
   * @api private
   * @method _getWinSize
   * @returns {Object} width and height attributes
   */
  function _getWinSize() {
    if (window.innerWidth !== undefined) {
      return { width: window.innerWidth, height: window.innerHeight };
    } else {
      var D = document.documentElement;
      return { width: D.clientWidth, height: D.clientHeight };
    }
  }

  /**
   * Check to see if the element is in the viewport or not
   * http://stackoverflow.com/questions/123999/how-to-tell-if-a-dom-element-is-visible-in-the-current-viewport
   *
   * @api private
   * @method _elementInViewport
   * @param {Object} el
   */
  function _elementInViewport(el) {
    var rect = el.getBoundingClientRect();

    return rect.top >= 0 && rect.left >= 0 && rect.bottom + 80 <= window.innerHeight && // add 80 to get the text right
    rect.right <= window.innerWidth;
  }

  /**
   * Add overlay layer to the page
   *
   * @api private
   * @method _addOverlayLayer
   * @param {Object} targetElm
   */
  function _addOverlayLayer(targetElm) {
    var overlayLayer = document.createElement('div'),
        styleText = '',
        self = this;

    //set css class name
    overlayLayer.className = 'introjs-overlay';

    //check if the target element is body, we should calculate the size of overlay layer in a better way
    if (!targetElm.tagName || targetElm.tagName.toLowerCase() === 'body') {
      styleText += 'top: 0;bottom: 0; left: 0;right: 0;position: fixed;';
      overlayLayer.style.cssText = styleText;
    } else {
      //set overlay layer position
      var elementPosition = _getOffset(targetElm);
      if (elementPosition) {
        styleText += 'width: ' + elementPosition.width + 'px; height:' + elementPosition.height + 'px; top:' + elementPosition.top + 'px;left: ' + elementPosition.left + 'px;';
        overlayLayer.style.cssText = styleText;
      }
    }

    targetElm.appendChild(overlayLayer);

    overlayLayer.onclick = function () {
      if (self._options.exitOnOverlayClick === true) {
        _exitIntro.call(self, targetElm);
      }
    };

    window.setTimeout(function () {
      styleText += 'opacity: ' + self._options.overlayOpacity.toString() + ';';
      overlayLayer.style.cssText = styleText;
    }, 10);

    return true;
  }

  /**
   * Removes open hint (tooltip hint)
   *
   * @api private
   * @method _removeHintTooltip
   */
  function _removeHintTooltip() {
    var tooltip = document.querySelector('.introjs-hintReference');

    if (tooltip) {
      var step = tooltip.getAttribute('data-step');
      tooltip.parentNode.removeChild(tooltip);
      return step;
    }
  }

  /**
   * Start parsing hint items
   *
   * @api private
   * @param {Object} targetElm
   * @method _startHint
   */
  function _populateHints(targetElm) {

    this._introItems = [];

    if (this._options.hints) {
      _forEach(this._options.hints, function (hint) {
        var currentItem = _cloneObject(hint);

        if (typeof currentItem.element === 'string') {
          //grab the element with given selector from the page
          currentItem.element = document.querySelector(currentItem.element);
        }

        currentItem.hintPosition = currentItem.hintPosition || this._options.hintPosition;
        currentItem.hintAnimation = currentItem.hintAnimation || this._options.hintAnimation;

        if (currentItem.element !== null) {
          this._introItems.push(currentItem);
        }
      }.bind(this));
    } else {
      var hints = targetElm.querySelectorAll('*[data-hint]');

      if (!hints || !hints.length) {
        return false;
      }

      //first add intro items with data-step
      _forEach(hints, function (currentElement) {
        // hint animation
        var hintAnimation = currentElement.getAttribute('data-hintanimation');

        if (hintAnimation) {
          hintAnimation = hintAnimation === 'true';
        } else {
          hintAnimation = this._options.hintAnimation;
        }

        this._introItems.push({
          element: currentElement,
          hint: currentElement.getAttribute('data-hint'),
          hintPosition: currentElement.getAttribute('data-hintposition') || this._options.hintPosition,
          hintAnimation: hintAnimation,
          tooltipClass: currentElement.getAttribute('data-tooltipclass'),
          position: currentElement.getAttribute('data-position') || this._options.tooltipPosition
        });
      }.bind(this));
    }

    _addHints.call(this);

    /* 
    todo:
    these events should be removed at some point 
    */
    DOMEvent.on(document, 'click', _removeHintTooltip, this, false);
    DOMEvent.on(window, 'resize', _reAlignHints, this, true);
  }

  /**
   * Re-aligns all hint elements
   *
   * @api private
   * @method _reAlignHints
   */
  function _reAlignHints() {
    _forEach(this._introItems, function (item) {
      if (typeof item.targetElement === 'undefined') {
        return;
      }

      _alignHintPosition.call(this, item.hintPosition, item.element, item.targetElement);
    }.bind(this));
  }

  /**
  * Get a queryselector within the hint wrapper
  *
  * @param {String} selector
  * @return {NodeList|Array}
  */
  function _hintQuerySelectorAll(selector) {
    var hintsWrapper = document.querySelector('.introjs-hints');
    return hintsWrapper ? hintsWrapper.querySelectorAll(selector) : [];
  }

  /**
   * Hide a hint
   *
   * @api private
   * @method _hideHint
   */
  function _hideHint(stepId) {
    var hint = _hintQuerySelectorAll('.introjs-hint[data-step="' + stepId + '"]')[0];

    _removeHintTooltip.call(this);

    if (hint) {
      _addClass(hint, 'introjs-hidehint');
    }

    // call the callback function (if any)
    if (typeof this._hintCloseCallback !== 'undefined') {
      this._hintCloseCallback.call(this, stepId);
    }
  }

  /**
   * Hide all hints
   *
   * @api private
   * @method _hideHints
   */
  function _hideHints() {
    var hints = _hintQuerySelectorAll('.introjs-hint');

    _forEach(hints, function (hint) {
      _hideHint.call(this, hint.getAttribute('data-step'));
    }.bind(this));
  }

  /**
   * Show all hints
   *
   * @api private
   * @method _showHints
   */
  function _showHints() {
    var hints = _hintQuerySelectorAll('.introjs-hint');

    if (hints && hints.length) {
      _forEach(hints, function (hint) {
        _showHint.call(this, hint.getAttribute('data-step'));
      }.bind(this));
    } else {
      _populateHints.call(this, this._targetElement);
    }
  }

  /**
   * Show a hint
   *
   * @api private
   * @method _showHint
   */
  function _showHint(stepId) {
    var hint = _hintQuerySelectorAll('.introjs-hint[data-step="' + stepId + '"]')[0];

    if (hint) {
      _removeClass(hint, /introjs-hidehint/g);
    }
  }

  /**
   * Removes all hint elements on the page
   * Useful when you want to destroy the elements and add them again (e.g. a modal or popup)
   *
   * @api private
   * @method _removeHints
   */
  function _removeHints() {
    var hints = _hintQuerySelectorAll('.introjs-hint');

    _forEach(hints, function (hint) {
      _removeHint.call(this, hint.getAttribute('data-step'));
    }.bind(this));
  }

  /**
   * Remove one single hint element from the page
   * Useful when you want to destroy the element and add them again (e.g. a modal or popup)
   * Use removeHints if you want to remove all elements.
   *
   * @api private
   * @method _removeHint
   */
  function _removeHint(stepId) {
    var hint = _hintQuerySelectorAll('.introjs-hint[data-step="' + stepId + '"]')[0];

    if (hint) {
      hint.parentNode.removeChild(hint);
    }
  }

  /**
   * Add all available hints to the page
   *
   * @api private
   * @method _addHints
   */
  function _addHints() {
    var self = this;

    var hintsWrapper = document.querySelector('.introjs-hints');

    if (hintsWrapper === null) {
      hintsWrapper = document.createElement('div');
      hintsWrapper.className = 'introjs-hints';
    }

    /**
    * Returns an event handler unique to the hint iteration
    * 
    * @param {Integer} i
    * @return {Function}
    */
    var getHintClick = function getHintClick(i) {
      return function (e) {
        var evt = e ? e : window.event;

        if (evt.stopPropagation) {
          evt.stopPropagation();
        }

        if (evt.cancelBubble !== null) {
          evt.cancelBubble = true;
        }

        _showHintDialog.call(self, i);
      };
    };

    _forEach(this._introItems, function (item, i) {
      // avoid append a hint twice
      if (document.querySelector('.introjs-hint[data-step="' + i + '"]')) {
        return;
      }

      var hint = document.createElement('a');
      _setAnchorAsButton(hint);

      hint.onclick = getHintClick(i);

      hint.className = 'introjs-hint';

      if (!item.hintAnimation) {
        _addClass(hint, 'introjs-hint-no-anim');
      }

      // hint's position should be fixed if the target element's position is fixed
      if (_isFixed(item.element)) {
        _addClass(hint, 'introjs-fixedhint');
      }

      var hintDot = document.createElement('div');
      hintDot.className = 'introjs-hint-dot';
      var hintPulse = document.createElement('div');
      hintPulse.className = 'introjs-hint-pulse';

      hint.appendChild(hintDot);
      hint.appendChild(hintPulse);
      hint.setAttribute('data-step', i);

      // we swap the hint element with target element
      // because _setHelperLayerPosition uses `element` property
      item.targetElement = item.element;
      item.element = hint;

      // align the hint position
      _alignHintPosition.call(this, item.hintPosition, hint, item.targetElement);

      hintsWrapper.appendChild(hint);
    }.bind(this));

    // adding the hints wrapper
    document.body.appendChild(hintsWrapper);

    // call the callback function (if any)
    if (typeof this._hintsAddedCallback !== 'undefined') {
      this._hintsAddedCallback.call(this);
    }
  }

  /**
   * Aligns hint position
   *
   * @api private
   * @method _alignHintPosition
   * @param {String} position
   * @param {Object} hint
   * @param {Object} element
   */
  function _alignHintPosition(position, hint, element) {
    // get/calculate offset of target element
    var offset = _getOffset.call(this, element);
    var iconWidth = 20;
    var iconHeight = 20;

    // align the hint element
    switch (position) {
      default:
      case 'top-left':
        hint.style.left = offset.left + 'px';
        hint.style.top = offset.top + 'px';
        break;
      case 'top-right':
        hint.style.left = offset.left + offset.width - iconWidth + 'px';
        hint.style.top = offset.top + 'px';
        break;
      case 'bottom-left':
        hint.style.left = offset.left + 'px';
        hint.style.top = offset.top + offset.height - iconHeight + 'px';
        break;
      case 'bottom-right':
        hint.style.left = offset.left + offset.width - iconWidth + 'px';
        hint.style.top = offset.top + offset.height - iconHeight + 'px';
        break;
      case 'middle-left':
        hint.style.left = offset.left + 'px';
        hint.style.top = offset.top + (offset.height - iconHeight) / 2 + 'px';
        break;
      case 'middle-right':
        hint.style.left = offset.left + offset.width - iconWidth + 'px';
        hint.style.top = offset.top + (offset.height - iconHeight) / 2 + 'px';
        break;
      case 'middle-middle':
        hint.style.left = offset.left + (offset.width - iconWidth) / 2 + 'px';
        hint.style.top = offset.top + (offset.height - iconHeight) / 2 + 'px';
        break;
      case 'bottom-middle':
        hint.style.left = offset.left + (offset.width - iconWidth) / 2 + 'px';
        hint.style.top = offset.top + offset.height - iconHeight + 'px';
        break;
      case 'top-middle':
        hint.style.left = offset.left + (offset.width - iconWidth) / 2 + 'px';
        hint.style.top = offset.top + 'px';
        break;
    }
  }

  /**
   * Triggers when user clicks on the hint element
   *
   * @api private
   * @method _showHintDialog
   * @param {Number} stepId
   */
  function _showHintDialog(stepId) {
    var hintElement = document.querySelector('.introjs-hint[data-step="' + stepId + '"]');
    var item = this._introItems[stepId];

    // call the callback function (if any)
    if (typeof this._hintClickCallback !== 'undefined') {
      this._hintClickCallback.call(this, hintElement, item, stepId);
    }

    // remove all open tooltips
    var removedStep = _removeHintTooltip.call(this);

    // to toggle the tooltip
    if (parseInt(removedStep, 10) === stepId) {
      return;
    }

    var tooltipLayer = document.createElement('div');
    var tooltipTextLayer = document.createElement('div');
    var arrowLayer = document.createElement('div');
    var referenceLayer = document.createElement('div');

    tooltipLayer.className = 'introjs-tooltip';

    tooltipLayer.onclick = function (e) {
      //IE9 & Other Browsers
      if (e.stopPropagation) {
        e.stopPropagation();
      }
      //IE8 and Lower
      else {
          e.cancelBubble = true;
        }
    };

    tooltipTextLayer.className = 'introjs-tooltiptext';

    var tooltipWrapper = document.createElement('p');
    tooltipWrapper.innerHTML = item.hint;

    var closeButton = document.createElement('a');
    closeButton.className = this._options.buttonClass;
    closeButton.setAttribute('role', 'button');
    closeButton.innerHTML = this._options.hintButtonLabel;
    closeButton.onclick = _hideHint.bind(this, stepId);

    tooltipTextLayer.appendChild(tooltipWrapper);
    tooltipTextLayer.appendChild(closeButton);

    arrowLayer.className = 'introjs-arrow';
    tooltipLayer.appendChild(arrowLayer);

    tooltipLayer.appendChild(tooltipTextLayer);

    // set current step for _placeTooltip function
    this._currentStep = hintElement.getAttribute('data-step');

    // align reference layer position
    referenceLayer.className = 'introjs-tooltipReferenceLayer introjs-hintReference';
    referenceLayer.setAttribute('data-step', hintElement.getAttribute('data-step'));
    _setHelperLayerPosition.call(this, referenceLayer);

    referenceLayer.appendChild(tooltipLayer);
    document.body.appendChild(referenceLayer);

    //set proper position
    _placeTooltip.call(this, hintElement, tooltipLayer, arrowLayer, null, true);
  }

  /**
   * Get an element position on the page
   * Thanks to `meouw`: http://stackoverflow.com/a/442474/375966
   *
   * @api private
   * @method _getOffset
   * @param {Object} element
   * @returns Element's position info
   */
  function _getOffset(element) {
    var body = document.body;
    var docEl = document.documentElement;
    var scrollTop = window.pageYOffset || docEl.scrollTop || body.scrollTop;
    var scrollLeft = window.pageXOffset || docEl.scrollLeft || body.scrollLeft;
    var x = element.getBoundingClientRect();
    return {
      top: x.top + scrollTop,
      width: x.width,
      height: x.height,
      left: x.left + scrollLeft
    };
  }

  /**
  * Find the nearest scrollable parent
  * copied from https://stackoverflow.com/questions/35939886/find-first-scrollable-parent
  *
  * @param Element element
  * @return Element
  */
  function _getScrollParent(element) {
    var style = window.getComputedStyle(element);
    var excludeStaticParent = style.position === "absolute";
    var overflowRegex = /(auto|scroll)/;

    if (style.position === "fixed") return document.body;

    for (var parent = element; parent = parent.parentElement;) {
      style = window.getComputedStyle(parent);
      if (excludeStaticParent && style.position === "static") {
        continue;
      }
      if (overflowRegex.test(style.overflow + style.overflowY + style.overflowX)) return parent;
    }

    return document.body;
  }

  /**
  * scroll a scrollable element to a child element
  *
  * @param Element parent
  * @param Element element
  * @return Null
  */
  function _scrollParentToElement(parent, element) {
    parent.scrollTop = element.offsetTop - parent.offsetTop;
  }

  /**
   * Gets the current progress percentage
   *
   * @api private
   * @method _getProgress
   * @returns current progress percentage
   */
  function _getProgress() {
    // Steps are 0 indexed
    var currentStep = parseInt(this._currentStep + 1, 10);
    return currentStep / this._introItems.length * 100;
  }

  /**
   * Overwrites obj1's values with obj2's and adds obj2's if non existent in obj1
   * via: http://stackoverflow.com/questions/171251/how-can-i-merge-properties-of-two-javascript-objects-dynamically
   *
   * @param obj1
   * @param obj2
   * @returns obj3 a new object based on obj1 and obj2
   */
  function _mergeOptions(obj1, obj2) {
    var obj3 = {},
        attrname;
    for (attrname in obj1) {
      obj3[attrname] = obj1[attrname];
    }
    for (attrname in obj2) {
      obj3[attrname] = obj2[attrname];
    }
    return obj3;
  }

  var introJs = function introJs(targetElm) {
    var instance;

    if ((typeof targetElm === "undefined" ? "undefined" : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(targetElm)) === 'object') {
      //Ok, create a new instance
      instance = new IntroJs(targetElm);
    } else if (typeof targetElm === 'string') {
      //select the target element with query selector
      var targetElement = document.querySelector(targetElm);

      if (targetElement) {
        instance = new IntroJs(targetElement);
      } else {
        throw new Error('There is no element with given selector.');
      }
    } else {
      instance = new IntroJs(document.body);
    }
    // add instance to list of _instances
    // passing group to _stamp to increment
    // from 0 onward somewhat reliably
    introJs.instances[_stamp(instance, 'introjs-instance')] = instance;

    return instance;
  };

  /**
   * Current IntroJs version
   *
   * @property version
   * @type String
   */
  introJs.version = VERSION;

  /**
  * key-val object helper for introJs instances
  *
  * @property instances
  * @type Object
  */
  introJs.instances = {};

  //Prototype
  introJs.fn = IntroJs.prototype = {
    clone: function clone() {
      return new IntroJs(this);
    },
    setOption: function setOption(option, value) {
      this._options[option] = value;
      return this;
    },
    setOptions: function setOptions(options) {
      this._options = _mergeOptions(this._options, options);
      return this;
    },
    start: function start(group) {
      _introForElement.call(this, this._targetElement, group);
      return this;
    },
    goToStep: function goToStep(step) {
      _goToStep.call(this, step);
      return this;
    },
    addStep: function addStep(options) {
      if (!this._options.steps) {
        this._options.steps = [];
      }

      this._options.steps.push(options);

      return this;
    },
    addSteps: function addSteps(steps) {
      if (!steps.length) return;

      for (var index = 0; index < steps.length; index++) {
        this.addStep(steps[index]);
      }

      return this;
    },
    goToStepNumber: function goToStepNumber(step) {
      _goToStepNumber.call(this, step);

      return this;
    },
    nextStep: function nextStep() {
      _nextStep.call(this);
      return this;
    },
    previousStep: function previousStep() {
      _previousStep.call(this);
      return this;
    },
    exit: function exit(force) {
      _exitIntro.call(this, this._targetElement, force);
      return this;
    },
    refresh: function refresh() {
      _refresh.call(this);
      return this;
    },
    onbeforechange: function onbeforechange(providedCallback) {
      if (typeof providedCallback === 'function') {
        this._introBeforeChangeCallback = providedCallback;
      } else {
        throw new Error('Provided callback for onbeforechange was not a function');
      }
      return this;
    },
    onchange: function onchange(providedCallback) {
      if (typeof providedCallback === 'function') {
        this._introChangeCallback = providedCallback;
      } else {
        throw new Error('Provided callback for onchange was not a function.');
      }
      return this;
    },
    onafterchange: function onafterchange(providedCallback) {
      if (typeof providedCallback === 'function') {
        this._introAfterChangeCallback = providedCallback;
      } else {
        throw new Error('Provided callback for onafterchange was not a function');
      }
      return this;
    },
    oncomplete: function oncomplete(providedCallback) {
      if (typeof providedCallback === 'function') {
        this._introCompleteCallback = providedCallback;
      } else {
        throw new Error('Provided callback for oncomplete was not a function.');
      }
      return this;
    },
    onhintsadded: function onhintsadded(providedCallback) {
      if (typeof providedCallback === 'function') {
        this._hintsAddedCallback = providedCallback;
      } else {
        throw new Error('Provided callback for onhintsadded was not a function.');
      }
      return this;
    },
    onhintclick: function onhintclick(providedCallback) {
      if (typeof providedCallback === 'function') {
        this._hintClickCallback = providedCallback;
      } else {
        throw new Error('Provided callback for onhintclick was not a function.');
      }
      return this;
    },
    onhintclose: function onhintclose(providedCallback) {
      if (typeof providedCallback === 'function') {
        this._hintCloseCallback = providedCallback;
      } else {
        throw new Error('Provided callback for onhintclose was not a function.');
      }
      return this;
    },
    onexit: function onexit(providedCallback) {
      if (typeof providedCallback === 'function') {
        this._introExitCallback = providedCallback;
      } else {
        throw new Error('Provided callback for onexit was not a function.');
      }
      return this;
    },
    onskip: function onskip(providedCallback) {
      if (typeof providedCallback === 'function') {
        this._introSkipCallback = providedCallback;
      } else {
        throw new Error('Provided callback for onskip was not a function.');
      }
      return this;
    },
    onbeforeexit: function onbeforeexit(providedCallback) {
      if (typeof providedCallback === 'function') {
        this._introBeforeExitCallback = providedCallback;
      } else {
        throw new Error('Provided callback for onbeforeexit was not a function.');
      }
      return this;
    },
    addHints: function addHints() {
      _populateHints.call(this, this._targetElement);
      return this;
    },
    hideHint: function hideHint(stepId) {
      _hideHint.call(this, stepId);
      return this;
    },
    hideHints: function hideHints() {
      _hideHints.call(this);
      return this;
    },
    showHint: function showHint(stepId) {
      _showHint.call(this, stepId);
      return this;
    },
    showHints: function showHints() {
      _showHints.call(this);
      return this;
    },
    removeHints: function removeHints() {
      _removeHints.call(this);
      return this;
    },
    removeHint: function removeHint(stepId) {
      _removeHint.call(this, stepId);
      return this;
    },
    showHintDialog: function showHintDialog(stepId) {
      _showHintDialog.call(this, stepId);
      return this;
    }
  };

  return introJs;
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(416), __webpack_require__(796)(module), __webpack_require__(6)))

/***/ }),

/***/ 386:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Table_vue__ = __webpack_require__(773);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Table_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Table_vue__);
/* unused harmony reexport VueGoodTable */


var VueGoodTablePlugin = {
  install: function install(Vue, options) {
    Vue.component(__WEBPACK_IMPORTED_MODULE_0__components_Table_vue___default.a.name, __WEBPACK_IMPORTED_MODULE_0__components_Table_vue___default.a);
  }
};

// Automatic installation if Vue has been added to the global scope.
if (typeof window !== 'undefined' && window.Vue) {
  window.Vue.use(VueGoodTablePlugin);
}

/* harmony default export */ __webpack_exports__["a"] = (VueGoodTablePlugin);


/***/ }),

/***/ 387:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(__dirname) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(793);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_meta__ = __webpack_require__(792);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_meta___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_meta__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Auth_auth__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_cookies__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_cookies___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue_cookies__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Auth_Login_vue__ = __webpack_require__(780);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Auth_Login_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_Auth_Login_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Auth_Signup__ = __webpack_require__(781);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Auth_Signup___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_Auth_Signup__);




// Auth


// import CAR from '@/components/dashboards/car/Dashboard'


// import Home from '@/components/Home'
// this is a new way to lazy load routes, i.e. you don't load the routes
// they are needed... However, we have to load some routes for basic functioning
var NotFound = function NotFound() {
  return __webpack_require__.e/* import() */(9).then(__webpack_require__.bind(null, 807));
};
var Settings = function Settings() {
  return __webpack_require__.e/* import() */(11).then(__webpack_require__.bind(null, 804));
};
var UserSettings = function UserSettings() {
  return __webpack_require__.e/* import() */(10).then(__webpack_require__.bind(null, 805));
};
var FeedBack = function FeedBack() {
  return __webpack_require__.e/* import() */(3).then(__webpack_require__.bind(null, 806));
};
var MainCar = function MainCar() {
  return __webpack_require__.e/* import() */(0).then(__webpack_require__.bind(null, 808));
};
var CAR_HELP = function CAR_HELP() {
  return __webpack_require__.e/* import() */(7).then(__webpack_require__.bind(null, 810));
};
var CAR_ABOUT = function CAR_ABOUT() {
  return __webpack_require__.e/* import() */(1).then(__webpack_require__.bind(null, 809));
};
var Contact = function Contact() {
  return __webpack_require__.e/* import() */(6).then(__webpack_require__.bind(null, 811));
};

var UPDATE_LOG = function UPDATE_LOG() {
  return __webpack_require__.e/* import() */(8).then(__webpack_require__.bind(null, 815));
};
var nhmisAnalysis = function nhmisAnalysis() {
  return __webpack_require__.e/* import() */(2).then(__webpack_require__.bind(null, 813));
};
var healthFacilitySurvey = function healthFacilitySurvey() {
  return __webpack_require__.e/* import() */(5).then(__webpack_require__.bind(null, 812));
};
var stateProfile = function stateProfile() {
  return __webpack_require__.e/* import() */(4).then(__webpack_require__.bind(null, 814));
};

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_2_vue_meta___default.a);

var router = new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  mode: 'history',
  base: __dirname,
  routes: [{
    path: '/',
    name: 'home',
    // component: Home,
    redirect: '/central_analytics'
  },
  // {
  //   path: '/central_analytics/:sharer',
  //   name: 'central_analytics_with_url_params',
  //   component: MainCar,
  // },
  // {
  //   path: '/login',
  //   name: 'login',
  //   component: Login
  // },


  ////////////////////////////////////////////////////////////////////////////////////////////////////
  // SUB DASHBOARD ROUTES
  {
    path: '/nhmis_analysis',
    name: 'nhmisAnalysis',
    component: nhmisAnalysis
  }, {
    path: '/health_facility_survey',
    name: 'healthFacilitySurvey',
    component: healthFacilitySurvey
  }, {
    path: '/state_profile',
    name: 'stateProfile',
    component: stateProfile
  },
  ////////////////////////////////////////////////////////////////////////////////////////////////////


  {
    path: '/login',
    name: 'login',
    component: __WEBPACK_IMPORTED_MODULE_5__components_Auth_Login_vue___default.a
  }, {
    path: '/contact',
    name: 'contact',
    component: Contact
  }, {
    path: '/updateLog',
    name: 'updatelog',
    component: UPDATE_LOG
  }, {
    path: '/signup',
    name: 'signUp',
    component: __WEBPACK_IMPORTED_MODULE_6__components_Auth_Signup___default.a
  }, {
    path: '/logout',
    name: 'logout',
    beforeEnter: function beforeEnter(to, from, next) {
      __WEBPACK_IMPORTED_MODULE_3__components_Auth_auth__["a" /* default */].logout();
      next('/');
    }
  }, {
    path: '/car_dashboard',
    name: 'main_car',
    component: function component() {
      return MainCar;
    },
    redirect: 'central_analytics'
    // beforeEnter: requireAuth
  }, {
    path: '/central_analytics',
    name: 'central_analytics',
    component: MainCar
    // beforeEnter: requireAuth,
  }, {
    path: '/help',
    name: 'car_help',
    component: CAR_HELP
    // beforeEnter: requireAuth,
  }, {
    path: '/about',
    name: 'car_about',
    component: CAR_ABOUT
    // meta: {
    //   title: 'About MSDAT Dashboard',
    //   metaTags: [
    //     {
    //       name: 'description',
    //       content: 'Description of the multisource data analytics and triangulation dashboard'
    //     },
    //     {
    //       property: 'og:description',
    //       content: 'Description of the multisource data analytics and triangulation dashboard'
    //     }
    //   ]
    // }
  }, {
    path: '/central_analytics/:ind_vars*/:ind_yr',
    name: 'central_analytics_with_params',
    component: MainCar,
    // beforeEnter: requireAuth,
    props: function props(route) {
      return {
        indicator_variables: route.params.ind_vars,
        indicator_year: parseInt(route.params.ind_yr)
      };
    }
  }, { path: '/admin/feedback',
    name: 'feddback',
    component: FeedBack,
    beforeEnter: requireAuth
  }, {
    path: '/admin/settings',
    name: 'Settings',
    component: Settings,
    // redirect: to => {
    //   getRedirectPath(to.fullPath)
    // },
    beforeEnter: requireAuth
  }, {
    path: '/admin/user/settings',
    name: 'user_settings',
    component: UserSettings,
    beforeEnter: requireAuth
  }, { // Always leave this as last one
    path: '*',
    component: NotFound, // () => import('pages/404'),
    meta: { standalone: true }
  }]
});

var locRedirects = {
  "/car_dashboard": ["HMH FMOH", "PERM. Sec. FMOH", "FMOH Director DPRS", "FMOH ICT", "FMOH DPRS MnE", "FMOH Public Health", "NPHCDA ED", "NPHCDA DPRS", "Admin"],
  "/login": ["HMH FMOH", "PERM. Sec. FMOH", "FMOH Director DPRS", "FMOH Public Health", "FMOH ICT", "FMOH DPRS MnE", "NPHCDA ED", "NPHCDA DPRS", "NERICC", "Admin", "Guest"],
  "/logout": ["HMH FMOH", "PERM. Sec. FMOH", "FMOH Director DPRS", "FMOH Public Health", "FMOH ICT", "FMOH DPRS MnE", "NPHCDA ED", "NPHCDA DPRS", "NERICC", "Admin", "Guest"],
  "/admin/settings": ["Admin"],
  "/dashboard_usage": ["Admin"],
  "/admin/user/settings": ["HMH FMOH", "PERM. Sec. FMOH", "FMOH Director DPRS", "FMOH Public Health", "FMOH ICT", "FMOH DPRS MnE", "NPHCDA ED", "NPHCDA DPRS", "NERICC", "Admin", "Guest"]
};

function getRedirectPath(toFullPath) {
  // ensure that the user has the permission to view the redirect page
  var red_path = toFullPath;
  var red_locs = locRedirects[red_path]; // allowed redirect locations for the redirect path

  var red_path_found = false;
  // red_locs.map( (elem, index) => {
  //   if (elem === auth.getLocation()) {
  //     red_path_found = true;
  //   }
  // })

  // Check if user has permission to access the route he seeks
  if (red_locs.indexOf(__WEBPACK_IMPORTED_MODULE_3__components_Auth_auth__["a" /* default */].getLocation()) > -1) {
    red_path_found = true;
  }

  // Check the route he has permission to access
  if (!red_path_found) {
    // user has no permission to access the route he seeks
    for (var loc in locRedirects) {
      if (locRedirects.hasOwnProperty(loc)) {
        if (locRedirects[loc].indexOf(__WEBPACK_IMPORTED_MODULE_3__components_Auth_auth__["a" /* default */].getLocation()) > -1) {
          red_path = loc; // send user to the route he has permission for.
          red_path_found = true;
          break;
        }
      }
    }
    // user has no right to access the redirect path, send user to the route he has permission to : user is Guest
    if (!red_path_found) {
      red_path = '/nhmis_reporting';
    }
  }
  return red_path;
}

function requireAuth(to, from, next) {

  if (to === from) {
    next(false);
  }
  // get the appropriate redirect path for the user.
  // var red_path = getRedirectPath(to.fullPath)
  // console.log(auth.getLocation(), red_path, to.fullPath);
  if (!__WEBPACK_IMPORTED_MODULE_3__components_Auth_auth__["a" /* default */].loggedIn()) {
    next({
      path: '/login',
      query: { redirect: to.fullPath }
    });
  } else {
    // to.fullPath = getRedirectPath(red_path)
    //  router.push(red_path);
    // var red_path = getRedirectPath(to.fullPath)
    // console.log(typeof red_path);
    // '/nhmis_reporting'
    next();
  }
}

// You can define an after each property on each every route
// router.afterEach((to, from) => {
//   let pathArray = to.path;
//   pathArray = pathArray.split('_');
//   console.log(pathArray)
// })

/* harmony default export */ __webpack_exports__["a"] = (router);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, "/"))

/***/ }),

/***/ 388:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(414);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__modules_car__ = __webpack_require__(460);





__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* default */].Store({
  modules: {
    namespaced: true,
    CAR: __WEBPACK_IMPORTED_MODULE_2__modules_car__["a" /* default */]
  }
}));

/***/ }),

/***/ 391:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 407:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(687)
  __webpack_require__(685)
  __webpack_require__(686)
  __webpack_require__(688)
}
var Component = __webpack_require__(15)(
  /* script */
  __webpack_require__(461),
  /* template */
  __webpack_require__(788),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-600d74be",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 454:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_clone__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_clone___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_clone__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__default__ = __webpack_require__(67);



var boolean = __WEBPACK_IMPORTED_MODULE_0_lodash_clone___default()(__WEBPACK_IMPORTED_MODULE_1__default__["a" /* default */]);

boolean.isRight = true;

boolean.filterPredicate = function (rowval, filter) {
  return boolean.compare(rowval, filter) === 0;
};

boolean.compare = function (x, y) {
  function cook(d) {
    // if d is null or undefined we give it the smallest
    // possible value
    if (typeof d !== 'boolean') return -Infinity;
    return d ? 1 : 0;
  }

  x = cook(x);
  y = cook(y);
  if (x < y) return -1;
  if (x > y) return 1;
  return 0;
};

/* harmony default export */ __webpack_exports__["default"] = (boolean);

/***/ }),

/***/ 455:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_date_fns__ = __webpack_require__(592);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_clone__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_clone___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_clone__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__default__ = __webpack_require__(67);




var date = __WEBPACK_IMPORTED_MODULE_1_lodash_clone___default()(__WEBPACK_IMPORTED_MODULE_2__default__["a" /* default */]);

date.isRight = true;

date.compare = function (x, y, column) {
  function cook(d) {
    if (column && column.dateInputFormat) {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_date_fns__["a" /* parse */])('' + d, '' + column.dateInputFormat, new Date());
    }
    return d;
  }
  x = cook(x);
  y = cook(y);
  if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_date_fns__["b" /* isValid */])(x)) {
    return -1;
  }
  if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_date_fns__["b" /* isValid */])(y)) {
    return 1;
  }
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_date_fns__["c" /* compareAsc */])(x, y);
};

date.format = function (v, column) {
  if (v === undefined || v === null) return '';
  // convert to date
  var date = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_date_fns__["a" /* parse */])(v, column.dateInputFormat, new Date());
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_date_fns__["d" /* format */])(date, column.dateOutputFormat);
};

/* harmony default export */ __webpack_exports__["default"] = (date);

/***/ }),

/***/ 456:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_clone__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_clone___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_clone__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__number__ = __webpack_require__(95);



var decimal = __WEBPACK_IMPORTED_MODULE_0_lodash_clone___default()(__WEBPACK_IMPORTED_MODULE_1__number__["default"]);
decimal.format = function (v) {
  if (v === undefined || v === null) return '';
  return parseFloat(Math.round(v * 100) / 100).toFixed(2);
};

/* harmony default export */ __webpack_exports__["default"] = (decimal);

/***/ }),

/***/ 457:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__date__ = __webpack_require__(455);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__decimal__ = __webpack_require__(456);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__number__ = __webpack_require__(95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__percentage__ = __webpack_require__(458);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__boolean__ = __webpack_require__(454);






/* harmony default export */ __webpack_exports__["a"] = ({
  date: __WEBPACK_IMPORTED_MODULE_0__date__,
  decimal: __WEBPACK_IMPORTED_MODULE_1__decimal__,
  number: __WEBPACK_IMPORTED_MODULE_2__number__,
  percentage: __WEBPACK_IMPORTED_MODULE_3__percentage__,
  boolean: __WEBPACK_IMPORTED_MODULE_4__boolean__
});

/***/ }),

/***/ 458:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_clone__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_clone___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_clone__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__number__ = __webpack_require__(95);



var percentage = __WEBPACK_IMPORTED_MODULE_0_lodash_clone___default()(__WEBPACK_IMPORTED_MODULE_1__number__["default"]);

percentage.format = function (v) {
  if (v === undefined || v === null) return '';
  return parseFloat(v * 100).toFixed(2) + '%';
};

/* harmony default export */ __webpack_exports__["default"] = (percentage);

/***/ }),

/***/ 459:
/***/ (function(module, exports) {

var loginDetails = [{ "username": "fmoh_director_dprs", "password": "dprsdir#19", "location": "FMOH Director DPRS", "body": "FMOH" }, { "username": "fmoh_perm_sec", "password": "123456", "location": "PERM. Sec. FMOH", "body": "FMOH" }, { "username": "hmh_fmoh", "password": "123456", "location": "HMH FMOH", "body": "FMOH" }, { "username": "fmoh_public_health", "password": "123456", "location": "FMOH Public Health", "body": "FMOH" }, { "username": "fmoh_ict", "password": "123456", "location": "FMOH ICT", "body": "FMOH" }, { "username": "fmoh_dprs_mne", "password": "dirmne#19", "location": "FMOH DPRS MnE", "body": "FMOH" }, { "username": "nphcda_ed", "password": "ednphcda$19", "location": "NPHCDA ED", "body": "NPHCDA" }, { "username": "nphcda_dprs", "password": "nphcdadprs$19", "location": "NPHCDA DPRS", "body": "NPHCDA" }, { "username": "nericc", "password": "nericc$#19", "location": "NERICC", "body": "NPHCDA" }, { "username": "admin", "password": "dashboard", "location": "Admin", "body": "e4e" }, { "username": "bmgf", "password": "dashboard", "location": "Admin", "body": "bmgf" }, { "username": "superadmin", "password": "Chukwuma123", "location": "Admin", "body": "bmgf" }];

module.exports = loginDetails;

/***/ }),

/***/ 460:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(136);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__ = __webpack_require__(137);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);



var _CAR$actions;



var CAR = {};

var sourceIndicatorTableData = [{
  label: "Indicators",
  children: [{
    label: "INDICATORS",
    field: "indicator",
    filterable: false,
    type: "text",
    html: true,
    index: 0,
    hidden: false,
    sortable: false
    // width: '330px',
  }]
}, {
  label: "Routine",
  children: [{
    label: "NHMIS",
    field: "nhmis",
    type: "text",
    html: true,
    filterable: false,
    fullName: "National Health Management Information System",
    hasValue: true,
    index: 1,
    headerField: "'Routine'",
    class: "Routine",
    hidden: false,
    sortable: false,
    uncertainty: false
  }]
}, {
  label: "National Surveys",
  children: [{
    label: "NDHS",
    field: "ndhs",
    type: "text",
    html: true,
    filterable: false,
    fullName: "National Demographic and Health Survey",
    hasValue: true,
    index: 2,
    class: "N.S",
    hidden: false,
    sortable: false,
    uncertainty: false
  }, {
    label: "MICS",
    field: "mics",
    type: "text",
    html: true,
    fullName: "Multiple Indicator Cluster Survey",
    hasValue: true,
    index: 3,
    class: "N.S",
    hidden: false,
    sortable: false,
    uncertainty: false
  }, {
    label: "NNHS",
    field: "nnhs",
    type: "text",
    html: true,
    filterable: false,
    fullName: "National Nutrition and Health Survey",
    hasValue: true,
    index: 4,
    class: "N.S",
    hidden: false,
    sortable: false,
    uncertainty: false
  }, {
    label: "NMIS",
    field: "nmis",
    type: "text",
    html: true,
    fullName: "Nigeria Malaria Indicator Survey",
    hasValue: true,
    index: 5,
    class: "N.S",
    hidden: false,
    sortable: false,
    uncertainty: false
  }, {
    label: "NARHS",
    field: "narhs",
    type: "text",
    html: true,
    fullName: "National HIV and AIDS and Reproductive Health Survey",
    hasValue: true,
    index: 6,
    class: "N.S",
    hidden: false,
    sortable: false,
    uncertainty: false
  }]
}, {
  label: "Estimates",
  children: [{
    label: "WHO-GHO",
    field: "who",
    type: "text",
    html: true,
    fullName: "World Health Organization",
    index: 7,
    class: "O.E",
    hidden: false,
    sortable: false,
    uncertainty: false
  }, {
    label: "World Bank",
    field: "world_bank",
    type: "text",
    html: true,
    fullName: "World Bank",
    hasValue: true,
    index: 8,
    class: "O.E",
    hidden: false,
    sortable: false,
    uncertainty: false
  }, {
    label: "IHME",
    field: "ihme",
    type: "text",
    html: true,
    fullName: "Institute for Health Metrics and Evaluation",
    index: 9,
    gameL: 1,
    hasValue: true,
    class: "O.E",
    hidden: false,
    sortable: false,
    uncertainty: false
  }, {
    label: "WUENIC",
    field: "wuenic",
    type: "text",
    html: true,
    fullName: "WHO and UNICEF estimates",
    index: 10,
    hasValue: true,
    class: "O.E",
    hidden: false,
    sortable: false,
    uncertainty: false
  }]
}];
var faqs = [{
  title: "What is the platform about?",
  ans: "The Multi-Source Data Analytics and Triangulation (MSDAT) Platform, developed by the Federal Ministry of Health (FMoH) Nigeria provides a single transparent view of key health indicators from multiple data sources. Recognizing that data quality, trends and interpretation depend on the data source and methodology, the platform offers comparisons of key metrics across three categories of data sources, namely; routine, surveys, and global estimates.",
  show: false
}, {
  title: "What are some future plans for the platform? (e.g. interoperability and APIs, data projections, state profile platforms, etc.)",
  ans: "The MSDAT platform will capture data from all geographical disaggregations (National, geopolitical zones, state, senatorial district, LGAs and health facilities) across the country. The platform will accommodate more indicators from more program areas, development of a mobile application, data projections and state profile platforms.",
  show: false
}, {
  title: "Who owns the MSDAT Platform?",
  ans: "The MSDAT platform is owned by the Federal Ministry of Health (FMoH)",
  show: false
}, {
  title: "Where is the data for the platform obtained from? And how?",
  ans: "Data from MSDAT is obtained from the National Health Management Information System (NHMIS), from Survey reports, and Global estimates. Data is extracted, cleaned and reviewed before it is used on the platform.",
  show: false
}, {
  title: "What are the levels of data aggregation found on the platform? (i.e. is state, LGA, community/facility-level data available?)",
  ans: "National, zonal, state and LGA data are available on the platform",
  show: false
}, {
  title: "What program areas are available?",
  ans: "The program areas currently available on the platform are:\n                <ul>\n                  <li>Reproductive, Maternal, Newborn and Child Health</li>\n               <li>Mortality</li>\n                <li>Immunization</li>\n                <li>Malaria</li>\n                 <li>HIV</li>\n                  <li>Nutrition</li>\n                </ul>\n            In case there are other program areas you would like to see, you can send an email to: <a href=\"https://msdatfeedback@e4email.net\">msdatfeedback@e4email.net</a>",
  show: false
}, {
  title: "Is there a plan to include more indicators and data sources on the MSDAT Platform?",
  ans: "The platform is scalable to accommodate more indicators and data sources. About 200 new indicators will be available on the platform by the end of 2020. However, the addition of new indicators to the platform is subject to approval from the DHPRS-FMoH. If there are new indicators you would like to be added, we can be contacted here: <a href=\"https://msdatfeedback@e4email.net\">msdatfeedback@e4email.net</a>",
  show: false
}, {
  title: "What criteria are used in selecting which indicators and data sources appear on the platform? Who does the selection and how long does the approval process take?",
  ans: "A set of criteria has been developed and approved by the DHPRS-FMoH. All potential data sources and indicators are screened using these criteria and are subject to review sessions by select health stakeholders.",
  show: false
}, {
  title: "How can I submit a data source to be included on MSDAT?",
  ans: "There is a \u201CSubmit new dataset\u201D icon on the MSDAT platform. This is the link: <a href=\"https://mapping.fmohconnect.gov.ng/data-inventory/add-dataset/\">https://mapping.fmohconnect.gov.ng/data-inventory/add-dataset/</a>. Please click on it and follow the prompts.",
  show: false
}, {
  title: "Can I download or request for the raw data on the platform?",
  ans: "Yes. datasets for all the visualizations are available in downloadable formats.",
  show: false
}, {
  title: "Can the MSDAT platform triangulate data across data sources with differing methodologies?",
  ans: "Not at this time, but it provides information about the methodology from each data source about an indicator that could be used to triangulate the available data.",
  show: false
}, {
  title: "How is the platform currently being used?",
  ans: "It is currently being used for health data analytics and development of state health profiles. Researchers are also able to get access to needed data on health outcomes of interest.",
  show: false
}, {
  title: "How often is the data on the MSDAT platform updated? Is the data real-time?",
  ans: "No. The data is not real-time. The platform is reviewed monthly and if data sources are available, the corresponding changes are made to the platform.",
  show: false
}, {
  title: "What checks are in place to ensure that data is accurate and up to date?",
  ans: "The data undergoes a six-sigma methodology with the aim of ensuring data accuracy on the platform on a monthly basis. Data is sourced only from government-approved bodies.",
  show: false
}, {
  title: "Is monthly data available on the MSDAT Platform?",
  ans: "Not yet. Processes are in motion to include that in upcoming versions of the platform",
  show: false
}, {
  title: "Does the platform work offline?",
  ans: "Yes. Once the platform has been fully loaded once, it will always be available for viewing on the browser. It can also be installed on the desktop of the user for quick access.",
  show: false
}, {
  title: "What can I do if I cannot find data on indicators specific to my program area?",
  ans: "The platform is continually growing, and new indicators will be added. We can notify you when indicators specific to your program areas have been added. You can fill in your contact details in this form <a href=\"msdat.fmohconnect.gov.ng/#/contact\">msdat.fmohconnect.gov.ng/#/contact</a>",
  show: false
}, {
  title: "Whom can I contact for feedback concerning the platform?",
  ans: "You can send an email to <a href=\"mailto:msdatfeedback@e4email.net\">msdatfeedback@e4email.net</a> or you can follow this <a href=\"\">link</a> and fill in the form.",
  show: false
}];
var dashboardHelp = [{
  title: "How to Change Selected indicator",
  steps: {
    First_Method: ["Click on the dropdown arrow next to the main indicator.", "Scroll down  to the appropriate program area where the desired indicator can be found.", "Click on the program dropdown.", "You can also type keywords of the desired indicator into the search field.", "When found, click on the desired indicator."],
    Second_Method: ["Go to the indicator search field at the top of the platform.", "Scroll down to the appropriate program area where the desired indicator can be found.", "Click on the program dropdown.", "You can also type keywords of the desired indicator into the search field.", "When found, click on the desired indicator."]
  },
  show: false
}, {
  title: "How to change related indicator",
  steps: ["Click on the dropdown arrow next to the related indicator you want to change.", "Scroll down to the appropriate program area where the desired indicator can be found.", "Click on the program dropdown.", "You can also type keywords of the desired indicator into the search field.", "When found, click on the desired indicator."],
  show: false
}, {
  title: "How to check for more information on the indicator",
  steps: ["Select the indicator you want to see more information on.",
  // 'On the table, click on the <i data-v-862f69e2 class="fas fa icon fa-info-circle" style="color: black;"></i> to the left of the indicator.',
  'On the table, click on the info icon <i data-v-862f69e2 class="fas fa icon fa-info-circle" style="color: #41918E; font-size: 15px;"></i> to the left of the indicator.', "Information on the indicator is given with respect to the data source, therefore, you can switch between the available data sources.", "You can also get more information on the indicator by going to the Information Page."],
  show: false
}, {
  title: "How to check information on the Data Source",
  steps: [
  // 'On the table, click on the <i data-v-862f69e2 class="fas fa icon fa-info-circle" style="color: black;"></i> by the data source you are interested in.',
  'On the table, click on the info icon <i data-v-862f69e2 class="fas fa icon fa-info-circle" style="color: #41918E; font-size: 15px;"></i> by the data source you are interested in.', "You can also get more information on the data sources by going to the information page."],
  show: false
}, {
  title: "How to change the dataset showing on all the charts",
  steps: ["Click on the desired dataset on the table."],
  show: false
}, {
  title: "How to change the period showing on the Bar chart",
  steps: ["Click in the period filter found over the bar chart.", "There would be a drop down showing only periods with available data.", "Click on the desired period."],
  show: false
}, {
  title: "How to change Location of the data showing on the indicator table and data trend (Line chart) chart",
  steps: ["Click on the Location filter found at the top right of the platform.", "Search and select the desired location.", "Data for the selected location will reflect on the Indicator table and line chart."],
  show: false
}, {
  title: "How to change data set showing on the Zonal chart",
  steps: ["Select the Dataset filter just above the zonal chart.", "Click on the dataset you want to see.", "The selected dataset will show on both the zonal chart and map."],
  show: false
}, {
  title: "How to change the period on the zonal chart",
  steps: ["Click on the period filter just above the zonal chart.", "Select the desired period."],
  show: false
}, {
  title: "How to compare multiple datasets for an indicator across the states",
  steps: ["Go to the multi-dataset comparison panel.", "Select the indicator you want to compare from the indicator filter just above the panel.", "Select the data sets you want to compare from the filter above the panel.", "You can select up to four datasets."],
  show: false
}, {
  title: "How to compare different indicators from the same data sets",
  steps: ["Open the “Compare Indicators” Panel.", "Select the data set you want to compare indicators from on the the filter just above the panel.", "Select the indicators you want to compare on the individual charts.", "You can change chart types: bar chart, column chart, a zonal chart and a states map for each chart."],
  show: false
}, {
  title: "How to download the data from a chart",
  steps: ["Click on the download button on each chart.", "Select either download as csv or download as xls."],
  show: false
}, {
  title: "How to download the chart as an image",
  steps: ["Click on the download button on each chart.", "Select the picture type you want to download the chart as: png, jpeg, pdf, vector image."],
  show: false
}, {
  title: "How to view information on the National target",
  steps: ["Click on the target line."],
  show: false
}, {
  title: "How to check the confidence range.",
  steps: ["On the table, find the data set you want to check the confidence range for.", "If the confidence range is available, there would be a toggle under the data set on the table.", "Toggle the switch to view the confidence range."],
  show: false
}];

var columns = [{
  label: "INDICATORS",
  field: "indicator",
  filterable: false,
  type: "string",
  html: true,
  index: 0,
  hidden: false,
  width: "330px"
}, {
  label: "NHMIS",
  field: "nhmis",
  type: "string",
  html: true,
  filterable: false,
  fullName: "National Health Management Information System",
  hasValue: true,
  index: 1,
  headerField: "'Routine'",
  class: "Routine",
  hidden: false
}, {
  label: "NDHS",
  field: "ndhs",
  type: "string",
  html: true,
  filterable: false,
  fullName: "National Demographic and Health Survey",
  hasValue: true,
  index: 2,
  class: "N.S",
  hidden: false
}, {
  label: "MICS",
  field: "mics",
  type: "string",
  html: true,
  fullName: "Multiple Indicator Cluster Survey",
  hasValue: true,
  index: 3,
  class: "N.S",
  hidden: false
}, {
  label: "NNHS",
  field: "nnhs",
  type: "string",
  html: true,
  filterable: false,
  fullName: "National Nutrition and Health Survey",
  hasValue: true,
  index: 4,
  class: "N.S",
  hidden: false
}, {
  label: "NMIS",
  field: "nmis",
  type: "string",
  html: true,
  fullName: "Nigeria Malaria Indicator Survey",
  hasValue: true,
  index: 5,
  class: "N.S",
  hidden: false
}, {
  label: "NARHS",
  field: "narhs",
  type: "string",
  html: true,
  fullName: "National HIV and AIDS and Reproductive Health Survey",
  hasValue: true,
  index: 6,
  class: "N.S",
  hidden: false
}, {
  label: "WHO-GHO",
  field: "who",
  type: "string",
  html: true,
  fullName: "World Health Organization",
  index: 7,
  class: "O.E",
  hidden: false
}, {
  label: "World Bank",
  field: "world_bank",
  type: "string",
  html: true,
  fullName: "World Bank",
  hasValue: true,
  index: 8,
  class: "O.E",
  hidden: false
}, {
  label: "IHME",
  field: "ihme",
  type: "string",
  html: true,
  fullName: "Institute for Health Metrics and Evaluation",
  index: 9,
  gameL: 1,
  hasValue: true,
  class: "O.E",
  hidden: false
}, {
  label: "WUENIC",
  field: "wuenic",
  type: "string",
  html: true,
  fullName: "WHO and UNICEF estimates",
  index: 10,
  hasValue: true,
  class: "O.E",
  hidden: false
}];

var dataSourceDescriptions = {
  MICS: "Multiple Indicator Cluster Survey 2016-2017: The fifth MICS which is an international household survey developed by UNICEF involving the collection of data on a wide range of indicators on the situation of children and women. Target groups: Women and men aged 15-49 years; Children less than 5 years.  Number of sampled households: 33,901. See more: <a target=\"_blank\" href=\"https://mapping.fmohconnect.gov.ng/dataset/multiple-indicator-cluster-survey-2016-2017/\">https://mapping.fmohconnect.gov.ng/dataset/multiple-indicator-cluster-survey-2016-2017/</a>",
  NDHS: "Demographic and Health Survey 2013: A national sample survey that provides up-to-date information on background characteristics of the respondents. Target groups: Women and men aged 15-49 years. Number of sampled households: 38,522. See more: <a target=\"_blank\" target=\"_blank\" href=\"https://mapping.fmohconnect.gov.ng/dataset/nigeria-demographic-health-survey-2013/\">https://mapping.fmohconnect.gov.ng/dataset/nigeria-demographic-health-survey-2013/</a>",
  NARHS: "National HIV and AIDS and Reproductive Health Survey 2012: The 2012 National HIV and AIDS and Reproductive Health Survey (NARHS Plus II) was a nationally representative survey carried out to provide information on key HIV & AIDS and reproductive health knowledge and behavior related issues. Target groups: Females aged between 15 and 49 years and males aged 15 to 64 years. Number of sampled households sampled: 32,543.",
  NMIS: "Nigeria Malaria Indicator Survey 2015: A follow-up survey to the 2010 NMIS baseline survey with the primary objectives of providing information on malaria indicators and malaria prevalence at the national level and also in each of the 36 states of the country and the Federal Capital Territory. Target groups: Number of sampled households: 37,674. See more: <a target=\"_blank\" href=\"https://mapping.fmohconnect.gov.ng/dataset/nigeria-malaria-indicator-survey-2015/\">https://mapping.fmohconnect.gov.ng/dataset/nigeria-malaria-indicator-survey-2015/</a>",
  NNHS: "National Nutrition and Health Survey 2015: The second national survey conducted in all 36 states of Nigeria and Federal Capital Territory (FCT) to assess the nutritional and health status of women and children. In order to provide reliable data for planning and monitoring of key activities, new key indicators on Malaria and Antenatal care. Target groups: Children under 5 years and women aged 15 to 49. Number of households sampled: 25,210.",
  NHMIS: "National Health Management Information System: Nigeria has adopted the DHIS2 as the National tool for the reporting of routine health-related data. This data is reported and aggregated monthly using this platform",
  "World Bank": "Health Nutrition and Statistics data obtained from World Bank open data catalog. It contains key health, nutrition and population statistics gathered from a variety of international sources",
  IHME: "Institute for Health Metrics and Evaluation",
  "WHO-GHO": "World Health Organization",
  WUENIC: "Data is jointy produced from WHO and UNICEF. Estimates are country specific and obtained from the review of reports regarding national immunization coverage, finalized survey reports and data from published and grey literature. See more: <a target=\"_blank\" target=\"_blank\" href=\"http://www.who.int/immunization/monitoring_surveillance/routine/coverage/en/index4.html\">http://www.who.int/immunization/monitoring_surveillance/routine/coverage/en/index4.html</a>"
};

var targetGroups = {
  MICS: "Women and men aged 15-49 years; Children less than 5 years",
  NDHS: "Women and men aged 15-49 years",
  NARHS: "Females aged between 15 and 49 years and males aged 15 to 64 years",
  NMIS: "Women and men aged 15-49 years; Children less than 5 years",
  NNHS: "Children under 5 years and women aged 15 to 49",
  NHMIS: "",
  "World Bank": "",
  IHME: "",
  // "IHME-SDG":``,
  "WHO-GHO": "",
  // COUNTRY: ``,
  WUENIC: ""
  // "ADM EST": ``
};

var sampledHouseHold = {
  MICS: 33901,
  NDHS: 38522,
  NARHS: 32543,
  NMIS: 37674,
  NNHS: 25210,
  NHMIS: "",
  "World Bank": "",
  IHME: "",
  // "IHME-SDG":``,
  "WHO-GHO": "",
  // COUNTRY: ``,
  WUENIC: ""
  // "ADM EST": ``
};

var stateNameLookUpTable = {
  Abia: "in Abia",
  Adamawa: "in Adamawa",
  "Akwa Ibom": "in Akwa Ibom",
  Anambra: "in Anambra",
  Bauchi: "in Bauchi",
  Bayelsa: "in Bayelsa",
  Benue: "in Benue",
  Borno: "in Borno",
  "Cross River": "in Cross River",
  Delta: "in Delta",
  Ebonyi: "in Ebonyi",
  Edo: "in Edo",
  Ekiti: "in Ekiti",
  Enugu: "in Enugu",
  FCT: "in FCT",
  Gombe: "in Gombe",
  Imo: "in Imo",
  Jigawa: "in Jigawa",
  Kaduna: "in Kaduna",
  Kano: "in Kano",
  Katsina: "in Katsina",
  Kebbi: "in Kebbi",
  Kogi: "in Kogi",
  Kwara: "in Kwara",
  Lagos: "in Lagos",
  Nasarawa: "in Nasarawa",
  National: "across the country",
  Niger: "in Niger",
  Ogun: "in Ogun",
  Ondo: "in Ondo",
  Osun: "in Osun",
  Oyo: "in Oyo",
  Plateau: "in Plateau",
  Rivers: "in Rivers",
  Sokoto: "in Sokoto",
  Taraba: "in Taraba",
  Yobe: "in Yobe",
  Zamfara: "in Zamfara",
  "North-East": "in North-East Nigeria",
  "North-West": "in North-West Nigeria",
  "North-Central": "in North-Central Nigeria",
  "South-East": "in South-East Nigeria",
  "South-West": "in South-West Nigeria",
  "South-South": "in South-South Nigeria"
};

var estimatesIndicatorOptions = [
// {name: "Adolescent fertility rate"},
{ name: "Adolescent birth rate" }, { name: "Maternal Mortality Ratio" }, { name: "Neonatal mortality rate (per 1000 live births)" }, {
  name: "Percentage of children fully immunized against childhood diseases by age 1"
},
// {name:"Prevalence of stunting among under 5 childen"},
{ name: "Prevalence of stunting among under 5 children" }, { name: "Prevalence of wasting among children under 5" }, { name: "Skilled attendance at delivery or birth" }, { name: "Under 5 Mortality rate" }];

var optionStates2 = ["Abia", "Adamawa", "Akwa Ibom", "Anambra", "Bauchi", "Bayelsa", "Benue", "Borno", "Cross River", "Delta", "Ebonyi", "Edo", "Ekiti", "Enugu", "FCT", "Gombe", "Imo", "Jigawa", "Kaduna", "Kano", "Katsina", "Kebbi", "Kogi", "Kwara", "Lagos", "Nasarawa", "National", "Niger", "Nigeria", "Ogun", "Ondo", "Osun", "Oyo", "Plateau", "Rivers", "Sokoto", "Taraba", "Yobe", "Zamfara"];

var optionStates = ["Abia", "Adamawa", "Akwa Ibom", "Anambra", "Bauchi", "Benue", "Borno", "Bayelsa", "Cross River", "Delta", "Ebonyi", "Edo", "Ekiti", "Enugu", "FCT", "Gombe", "Imo", "Jigawa", "Kaduna", "Kano", "Katsina", "Kebbi", "Kogi", "Kwara", "Lagos", "Nasarawa", "National", "Niger", "Ogun", "Ondo", "Osun", "Oyo", "Plateau", "Rivers", "Sokoto", "Taraba", "Yobe", "Zamfara", "North-East", "North-West", "North-Central", "South-East", "South-West", "South-South"];

var shortIndicatorNames = {
  "Skilled attendance at delivery or birth": "Skilled attendance at delivery or birth"
};
var indicatorsAndRelative = {
  "Skilled attendance at delivery or birth": ["Maternal Mortality Ratio", "ANC Coverage (4 visits)"]
};
var programAreasToIndicators = {
  RMNCH: ["Skilled attendance at delivery or birth", "ANC Coverage (at least 1 visit)", "ANC Coverage (4 visits)", "Contraceptive prevalence rate", "Adolescent birth rate", "Total fertility rate", "Unmet need for family planning", "Prevalence of Symptoms of Acute Respiratory Infection among under five children", "Percentage of children with diarrhoea who received treatment", "Prevalence of Diarrhoea", "Postnatal care coverage (mother)", "Proportion of children under 5 with ARI who received antibiotics"]
};
var indicatorAttributesOtherSources = {
  "Skilled attendance at delivery or birth": [["G", "R"], "P"]
};

CAR.state = {
  // ndDataStore: [],
  lsData: [],
  // apiUrl: "https://nphcda-daily-reporting.firebaseio.com/progAreaSheet.json",
  name: "CAR Platform",
  tableColumnHeaderIndex: null,
  tableColumnHeaderName: null,
  fullscreen: false,
  columns: columns,
  carSources: ["MICS", "NHMIS", "NNHS", "NDHS", "NMIS", "NARHS", "IBBS", "World Bank", "IHME", "WHO-GHO", "HFS", "COUNTRY", "WUENIC", "ADM EST"],
  indicators: [],
  indicatorsAndRelative: indicatorsAndRelative,
  programAreasToIndicators: programAreasToIndicators,
  estimatesIndicatorOptions: estimatesIndicatorOptions,
  optionStates2: optionStates2,
  optionStates: optionStates,
  // indicatorsAndProgramAreas: {},
  // indicatorAttributes,
  indicatorLength: "32",
  sourceMetaData: "17",
  lastUpdated: "Loading...",
  indicatorSelected: "",
  indicatorAttributesOtherSources: indicatorAttributesOtherSources,
  selectedIndicator: "Skilled attendance at delivery or birth",
  selectedState: "National",
  lsDataDHIS2: [],
  lsDataMultipleSources: [],
  lsTargetData: [],
  lsLgaData: [],
  lsCARdata: [],
  lsMetaData: [],
  storeMetaData: [],
  ndStateData: [],
  // progAreaData: [],
  shortIndicatorNames: shortIndicatorNames,
  stateNameLookUpTable: stateNameLookUpTable,
  stateSelectedIndicatorSource: {},
  dataSourceDescriptions: dataSourceDescriptions,
  targetGroups: targetGroups,
  dashboardHelp: dashboardHelp,
  faqs: faqs,
  sampledHouseHold: sampledHouseHold,
  sourceIndicatorTableData: sourceIndicatorTableData,
  defaultSource: null,
  currentCARTableColumns: [],
  ngMapData: {},
  estimateDataMultipleSources: null,
  shareCounter: 0,
  zonalChartCounter: 0,
  reloadDataState: false,
  tableSourceSelected: "",
  params: {},

  compareSection: {
    state: "National",
    relatedIndicators: []
  },
  NhmisMonthlyData: JSON.parse(localStorage.getItem("nhmis_monthly"))
};

CAR.actions = (_CAR$actions = {
  // storeNdData: ({commit}, data) => {
  // commit('setData', {list: data})
  // },
  storeCARData: function storeCARData(_ref, data) {
    var commit = _ref.commit;

    commit("setData", { list: data });
  },
  storeSourceClicked: function storeSourceClicked(_ref2, data) {
    var commit = _ref2.commit;

    commit("setSourceClicked", { list: data });
  },
  storeHeaderIndex: function storeHeaderIndex(_ref3, data) {
    var commit = _ref3.commit;

    commit("setHeaderIndex", { list: data });
  },
  storeDefaultSource: function storeDefaultSource(_ref4, data) {
    var commit = _ref4.commit;

    commit("setDefaultSource", { list: data });
  },
  storeInitIndicatorSource: function storeInitIndicatorSource(_ref5, data) {
    var commit = _ref5.commit;

    commit("setInitIndicatorSource", { list: data });
  },
  storeEstimateSourceData: function storeEstimateSourceData(_ref6, data) {
    var commit = _ref6.commit;

    commit("setEstimateSourceData", { list: data });
  },
  storeIndicatorSelected: function storeIndicatorSelected(_ref7, data) {
    var commit = _ref7.commit;

    commit("setIndicatorSelected", { list: data });
  },
  storeIndicators: function storeIndicators(_ref8, data) {
    var commit = _ref8.commit;

    commit("setIndicators", { list: data });
  },
  storeMultipleSourceData: function storeMultipleSourceData(_ref9, data) {
    var commit = _ref9.commit;

    commit("setMultipleSourceData", { list: data });
  },
  storeTargetData: function storeTargetData(_ref10, data) {
    var commit = _ref10.commit;

    commit("setTargetData", { list: data });
  },
  storeLgaData: function storeLgaData(_ref11, data) {
    var commit = _ref11.commit;

    commit("setLgaData", { list: data });
  }
}, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_CAR$actions, "storeCARData", function storeCARData(_ref12, data) {
  var commit = _ref12.commit;

  commit("setCARdata", { list: data });
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_CAR$actions, "storeMetaData", function storeMetaData(_ref13, data) {
  var commit = _ref13.commit;

  commit("setMetaData", { list: data });
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_CAR$actions, "storeIndicatorMetaData", function storeIndicatorMetaData(_ref14, data) {
  var commit = _ref14.commit;

  commit("setIndicatorMetaData", data);
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_CAR$actions, "storeSelectedIndicator", function storeSelectedIndicator(_ref15, data) {
  var commit = _ref15.commit;

  commit("setSelectedIndicator", data);
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_CAR$actions, "storeNdStateData", function storeNdStateData(_ref16, data) {
  var commit = _ref16.commit;

  commit("setNdStateData", data);
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_CAR$actions, "storeSelectedState", function storeSelectedState(_ref17, data) {
  var commit = _ref17.commit;

  commit("setSelectedState", data);
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_CAR$actions, "indicatorsAndProgramAreas", function indicatorsAndProgramAreas(_ref18, data) {
  var commit = _ref18.commit;

  commit("setIndicatorsAndProgramAreas", data);
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_CAR$actions, "indicatorLength", function indicatorLength(_ref19, data) {
  var commit = _ref19.commit;

  commit("setIndicatorLength", data);
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_CAR$actions, "lastUpdated", function lastUpdated(_ref20, data) {
  var commit = _ref20.commit;

  commit("setLastUpdated", data);
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_CAR$actions, "sourceLength", function sourceLength(_ref21, data) {
  var commit = _ref21.commit;

  commit("setSourceMetaData", data);
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_CAR$actions, "indicatorAttributes", function indicatorAttributes(_ref22, data) {
  var commit = _ref22.commit;

  commit("setIndicatorAttributes", data);
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_CAR$actions, "indicatorShortNames", function indicatorShortNames(_ref23, data) {
  var commit = _ref23.commit;

  commit("setIndicatorShortNames", data);
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_CAR$actions, "indicatorsRelative", function indicatorsRelative(_ref24, data) {
  var commit = _ref24.commit;

  commit("setIndicatorsRelative", data);
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_CAR$actions, "setOptionState", function setOptionState(_ref25, data) {
  var commit = _ref25.commit;

  commit("setOptionState", data);
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_CAR$actions, "storeMapData", function storeMapData(_ref26, ngMapData) {
  var commit = _ref26.commit;

  commit("setMapData", ngMapData);
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_CAR$actions, "storeShareCounter", function storeShareCounter(_ref27) {
  var commit = _ref27.commit;

  commit("setShareCounter");
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_CAR$actions, "reloadData", function reloadData(_ref28) {
  var commit = _ref28.commit;

  commit("setReloadData");
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_CAR$actions, "goToZonalChart", function goToZonalChart(_ref29, data) {
  var commit = _ref29.commit;

  commit("setZonalChartCounter", data);
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_CAR$actions, "fullscreen", function fullscreen(_ref30, data) {
  var commit = _ref30.commit;

  commit("setFullscreen", data);
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_CAR$actions, "setParams", function setParams(_ref31, data) {
  var commit = _ref31.commit;

  commit("setParams", data);
}), _CAR$actions);
// console.log(CAR.state.sourceIndicatorTableData);

CAR.mutations = {
  // setData: (state, {list}) => {
  //   state.ndDataStore = list
  // },
  setData: function setData(state, _ref32) {
    var list = _ref32.list;

    state.lsData = list;
  },
  setSourceClicked: function setSourceClicked(state, _ref33) {
    var list = _ref33.list;

    state.tableSourceSelected = list;
  },
  setShareCounter: function setShareCounter(state) {
    state.shareCounter++;
  },
  setZonalChartCounter: function setZonalChartCounter(state, option) {
    state.zonalChartCounter = option;
  },
  setFullscreen: function setFullscreen(state, val) {
    state.fullscreen = val;
  },
  setReloadData: function setReloadData(state) {
    state.reloadDataState = true;
  },
  setIndicatorSelected: function setIndicatorSelected(state, data) {
    state.indicatorSelected = data;
  },
  setHeaderIndex: function setHeaderIndex(state, _ref34) {
    var list = _ref34.list;

    state.tableColumnHeaderName = list.list[2];
    state.currentCARTableColumns = list.list[4];
    // console.log(list.list)
    if (list.list[2] === "INDICATORS") {
      // on refresh make default value selected source.
      state.tableColumnHeaderName = list.list[3]; //'NHMIS' default source;
    }
    state.stateSelectedIndicatorSource = list.stateSelectedIndicatorSource;
    state.tableColumnHeaderIndex = list.list[1];
  },
  setDefaultSource: function setDefaultSource(state, _ref35) {
    var list = _ref35.list;

    state.defaultSource = list.list;
  },
  setInitIndicatorSource: function setInitIndicatorSource(state, _ref36) {
    var list = _ref36.list;

    state.stateSelectedIndicatorSource = list.stateSelectedIndicatorSource;
  },
  setIndicators: function setIndicators(state, _ref37) {
    var list = _ref37.list;

    state.indicators = list;
  },
  setEstimateSourceData: function setEstimateSourceData(state, _ref38) {
    var list = _ref38.list;

    state.estimateDataMultipleSources = list.list;
  },
  setMultipleSourceData: function setMultipleSourceData(state, _ref39) {
    var list = _ref39.list;

    state.lsDataMultipleSources = list.list;
  },
  setTargetData: function setTargetData(state, _ref40) {
    var list = _ref40.list;

    state.lsTargetData = list.list;
  },
  setLgaData: function setLgaData(state, _ref41) {
    var list = _ref41.list;

    state.lsLgaData = list.list;
  },
  setCARdata: function setCARdata(state, _ref42) {
    var list = _ref42.list;

    state.lsCARdata = list.list;
  },
  setIndicatorMetaData: function setIndicatorMetaData(state, metaData) {
    state.storeMetaData = metaData;
  },
  setNdStateData: function setNdStateData(state, list) {
    state.ndStateData = list.list;
  },
  setMetaData: function setMetaData(state, _ref43) {
    var list = _ref43.list;

    state.lsMetaData = list.list;
  },
  setSelectedIndicator: function setSelectedIndicator(state, indicator) {
    state.selectedIndicator = indicator;
  },
  setSelectedState: function setSelectedState(state, stateVal) {
    state.selectedState = stateVal;
  },
  setIndicatorsAndProgramAreas: function setIndicatorsAndProgramAreas(state, obj) {
    // console.log(obj);

    state.programAreasToIndicators = obj;
    // state.indicatorsAndProgramAreas = obj
  },
  setIndicatorLength: function setIndicatorLength(state, val) {
    state.indicatorLength = val;
  },
  setLastUpdated: function setLastUpdated(state, val) {
    var date1 = new Date(val);
    date1 = date1.toString();
    var date = date1.split(" ");

    var fullDate = date[2] + "-" + date[1] + "-" + date[3];
    state.lastUpdated = fullDate;
  },
  setSourceMetaData: function setSourceMetaData(state, val) {
    state.sourceMetaData = val;
  },
  setIndicatorShortNames: function setIndicatorShortNames(state, obj) {
    state.shortIndicatorNames = obj;
  },
  setIndicatorsRelative: function setIndicatorsRelative(state, obj) {
    state.indicatorsAndRelative = obj;
  },
  setIndicatorAttributes: function setIndicatorAttributes(state, obj) {
    state.indicatorAttributesOtherSources = obj;
  },
  setOptionState: function setOptionState(state, obj) {
    state.optionStates = obj.data;
  },
  setMapData: function setMapData(state, ngMapData) {
    state.ngMapData = ngMapData.ngMapData;
  },
  setsourceIndicatorTableData: function setsourceIndicatorTableData(state, columns) {
    state.sourceIndicatorTableData = columns;
  },
  setParams: function setParams(state, payload) {
    state.params = payload;
  }
};
CAR.getters = {
  getRelatedIndicators: function getRelatedIndicators(state) {
    return state.compareSection.relatedIndicators;
  },
  getShareCounter: function getShareCounter(state) {
    return state.shareCounter;
  },
  getZonalChartCounter: function getZonalChartCounter(state) {
    return state.zonalChartCounter; //Accessed by mapGetters on MainCarDashboard.vue
  },
  getReloadDataState: function getReloadDataState(state) {
    return state.reloadDataState;
  },
  getIndicatorSelected: function getIndicatorSelected(state) {
    return state.indicatorSelected;
  },
  getSourceClicked: function getSourceClicked(state) {
    // return the exact source clicked and all the table source
    return [state.tableColumnHeaderName, state.tableColumnHeaderIndex].slice(0);
  },
  getTableSourceClicked: function getTableSourceClicked(state) {
    return state.tableSourceSelected;
  },
  getCarSources: function getCarSources(state) {
    return state.carSources.slice(0);
  },
  getSelectedIndicator: function getSelectedIndicator(state) {
    return state.selectedIndicator;
  },
  getSelectedIndicatorSource: function getSelectedIndicatorSource(state) {
    return state.stateSelectedIndicatorSource;
  },
  getSelectedState: function getSelectedState(state) {
    return state.selectedState;
  },
  getNdStateData: function getNdStateData(state) {
    return state.ndStateData;
  },
  getStoreMetaData: function getStoreMetaData(state) {
    return state.storeMetaData;
  },
  getTargetData: function getTargetData(state) {
    return state.lsTargetData;
  },
  getLgaData: function getLgaData(state) {
    return state.lsLgaData;
  },

  // getIndicatorsAndProgramAreas(state){
  //   console.log(state.programAreasToIndicators);

  //   // return state.indicatorsAndProgramAreas
  //   return state.programAreasToIndicators
  // },
  getIndicators: function getIndicators(state) {
    var firstRow = state.lsDataMultipleSources[0];
    var headerObj = {};
    var temp = [];
    firstRow.map(function (elem, index) {
      if (index > 1) {
        temp = elem.split("->");
        if (!headerObj[temp[0].trim()]) {
          headerObj[temp[0].trim()] = [];
        }
        headerObj[temp[0].trim()].push(temp[1].trim());
      }
    });
    return headerObj;
  },

  getIndicatorsAndRelative: function getIndicatorsAndRelative(state) {
    return function (indicator) {
      return state.indicatorsAndRelative[indicator] ? state.indicatorsAndRelative[indicator].slice(0) : [];
    };
  },
  getCurrentIndicatorsValue: function getCurrentIndicatorsValue(state) {
    var tableData = state.lsDataMultipleSources.slice(0);
    var indicatorAndSourceValueByState = {};
    state.optionStates.map(function (elem, index) {
      indicatorAndSourceValueByState[elem] = [];
    });
    // get the values of the indicators by state by year
    // Abia: [[2011, 91.5, ...], [2012, ...]]
    tableData.map(function (elem, index) {
      if (index > 0) {
        var stateName = elem[1];
        var rowDataWithoutState = elem.slice(0);
        rowDataWithoutState.splice(1, 1); // remove the state name
        indicatorAndSourceValueByState[stateName].push(rowDataWithoutState);
      }
    });
    return indicatorAndSourceValueByState;
  },

  // (state) => (id) =>
  getStateIndicatorsValueLatestYear: function getStateIndicatorsValueLatestYear(state) {
    return function (values) {
      var tableRow = state.lsDataMultipleSources[0].slice(0);
      tableRow.splice(1, 1); // remove org. unit.

      var indicatorYearValue = {};
      tableRow.map(function (elem, index) {
        if (index > 0) {
          for (var i = values.length - 1; i >= 0; i--) {
            // if(elem.split('-')[1].trim() === 'NHMIS') { // we don't need NHMIS data here
            //     continue;
            // }
            indicatorYearValue[elem] = [];
            var yearRow = values[i];
            var currentIndicatorVal = yearRow[index];
            if (currentIndicatorVal) {
              indicatorYearValue[elem].push(yearRow[0], currentIndicatorVal);
              break;
            }
          }
        }
      });
      // alert(indicatorYearValue["Percentage of children fully immunized against childhood diseases by age 1 - NHMIS"])
      return indicatorYearValue;
    };
  },
  getDataToRender: function getDataToRender(state) {
    return function (values, source, selectedIndicator) {
      var indicatorSourceToReturn = {};
      var programAreaIndicators = selectedIndicator;
      for (var value in values) {
        if (values.hasOwnProperty(value)) {
          var indicatorSource = value.split("-");
          var iSource = indicatorSource[1].trim();
          var indicator = indicatorSource[0].trim();
          if (iSource === source && indicator === selectedIndicator) {
            indicatorSourceToReturn[value] = values[value];
          }
        }
      }
      // console.log(values, indicatorSourceToReturn);
      return indicatorSourceToReturn;
    };
  },
  getShortIndicatorNames: function getShortIndicatorNames(state) {
    return function (indicatorName, columnHeaders) {
      if (columnHeaders) {
        state.tableColumnHeaderName = columnHeaders[0];
      }
      return state.shortIndicatorNames[indicatorName];
    };
  },
  // not called from component yet
  // async progAreaData(state) {
  //     return await axios.get(state.apiUrl);
  // },
  getOtherDatasetYear: function getOtherDatasetYear(state) {
    var tableData = state.lsDataMultipleSources.slice(0);
    var obj = {};
    tableData.map(function (elem, index) {
      if (index > 0) {
        if (!obj[elem[0]]) {
          obj[elem[0]] = [];
        }
        obj[elem[0]].push(elem);
      }
    });
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(obj);
  },

  getDataSourceDescriptions: function getDataSourceDescriptions(state) {
    return function (param) {
      return state.dataSourceDescriptions[param];
    };
  },
  getTargetGroups: function getTargetGroups(state) {
    return function (param) {
      return state.targetGroups[param];
    };
  },
  getSampledHouseholdData: function getSampledHouseholdData(state) {
    return function (param) {
      return state.sampledHouseHold[param];
    };
  },
  getDefaultSource: function getDefaultSource(state) {
    return state.defaultSource;
  },
  getCARngMapData: function getCARngMapData(state) {
    //console.log('from store: ',state.ngMapData);
    return state.ngMapData;
  },
  getSourceIndicatorTableData: function getSourceIndicatorTableData(state) {
    return state.sourceIndicatorTableData.slice(0); // Object.assign([], state.sourceIndicatorTableData);
  },
  getParams: function getParams(state) {
    return state.params;
  }
};
/* harmony default export */ __webpack_exports__["a"] = (CAR);

/***/ }),

/***/ 461:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(89);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__main__ = __webpack_require__(135);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Auth_auth__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_html2pdf_js__ = __webpack_require__(421);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_html2pdf_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_html2pdf_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_owl_carousel__ = __webpack_require__(422);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_owl_carousel___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vue_owl_carousel__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_crypto__ = __webpack_require__(541);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_crypto___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_crypto__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_cookies__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_cookies___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_vue_cookies__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





// import Menu from './components/DPRS/dprs-src/components/Menu.vue'
// import Footer from './components/DPRS/dprs-src/components/Footer.vue'



/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    // 'fmoh-menu': Menu,
    // 'app-footer': Footer,
    carousel: __WEBPACK_IMPORTED_MODULE_6_vue_owl_carousel___default.a

  },
  data: function data() {
    return {
      syncData: [],
      //////////////////////////////////////////////////////
      //SUB DASHBOARDS ACTIVE TAB STYLE
      activeClass: 'active',
      currentUrl: "",
      //////////////////////////////////////////////////////
      showNavigationBool: false,
      showMoreMenuBool: false,
      showSections: false,
      fullscreen: false,
      drawer: false,
      isTourActive: false,
      isTourStarts: false,
      tourButton: true,
      shareCounter: 0,
      // user location
      location: 'Guest',
      URLsToAccess: {
        "FMOHDirectorDPRS": ["/nhmis_reporting", "/nhmis_analysis", "/car_dashboard"], //"/inventory_dashboard"],
        "FMOHDPRSMnE": ["/nhmis_reporting", "/nhmis_analysis", "/car_dashboard"], //"/inventory_dashboard"],
        "PERM.Sec.FMOH": ["/nhmis_reporting", "/nhmis_analysis", "/car_dashboard"], //"/inventory_dashboard", "/new_nphcda_dashboard"],
        "FMOHPublicHealth": ["/nhmis_reporting", "/nhmis_analysis", "/car_dashboard"],
        "FMOHICT": ["/nhmis_reporting", "/nhmis_analysis", "/car_dashboard", "/hmh_dashboard"], //"/inventory_dashboard"],
        "NPHCDAED": ["/nhmis_reporting", "/nhmis_analysis", "/car_dashboard", "/nphcda_dashboard", "/new_nphcda_dashboard", "/nphcda_summary_dashboard"],
        "NPHCDADPRS": ["/nhmis_reporting", "/nhmis_analysis", "/car_dashboard", "/nphcda_dashboard", "/new_nphcda_dashboard", "/nphcda_summary_dashboard"],
        "Admin": ["/nhmis_reporting", "/nhmis_analysis", "/car_dashboard", "/hmh_dashboard", "/inventory_dashboard", "/nphcda_dashboard", "/new_nphcda_dashboard", "/nphcda_summary_dashboard", "/dashboard_usage"]
      },
      URLsNames: { "/nhmis_reporting": "NHMIS", "/nhmis_analysis": "NHMIS Monthly Analysis", "/car_dashboard": "CAR",
        "/hmh_dashboard": "HMH", "/inventory_dashboard": "Inventory",
        "/nphcda_dashboard": "Vaccine Wastage", "/new_nphcda_dashboard": "Weekly Immunization",
        "/nphcda_summary_dashboard": "Routine Immunization", "/dashboard_usage": "Dashboard Usage"
      },
      SettingsItems: ['A', 'B', 'C'],
      nameLookUp: {
        "CAR": 'Central<br/>Analytics'
      },
      //auth
      loggedIn: __WEBPACK_IMPORTED_MODULE_4__components_Auth_auth__["a" /* default */].loggedIn()

    };
  },
  mounted: function mounted() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      var ifConnected;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              ifConnected = window.navigator.onLine;


              if (ifConnected) {

                try {

                  window.setInterval(function () {

                    _this.synchDatabases();
                  }, 1000000);
                } catch (e) {}
                // console.error(e)

                // console.log(this.syncData);
              }

            case 2:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },

  methods: {
    synchDatabases: function synchDatabases() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var datas;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:

                __WEBPACK_IMPORTED_MODULE_3__main__["indDB"].sub_dashboard_interests.each(function (sub_dashboard_interest) {
                  _this2.syncData.push(sub_dashboard_interest);
                });
                datas = _this2.syncData;

                console.log(datas);
                datas.forEach(function (data) {
                  var payload = data;

                  __WEBPACK_IMPORTED_MODULE_2_axios___default.a.post('http://172.93.50.34:9000/api/v1/subDashboardInterest', payload).then(function (response) {
                    console.log(response.status);

                    var res = response.status;

                    if (res == 201) {
                      // console.log("-")
                      // console.log("--")
                      // console.log("---")
                      // console.log("----")
                      // console.log("User Added")
                      // console.log("----")
                      // console.log("---")
                      // console.log("--")
                      // console.log("-")


                      // console.log("-")
                      // console.log("--")
                      // console.log("---")
                      // console.log("----")
                      // console.log("Removing Record from Ofline Database Now ...")
                      // console.log("----")
                      // console.log("---")
                      // console.log("--")
                      // console.log("-")


                      __WEBPACK_IMPORTED_MODULE_3__main__["indDB"].sub_dashboard_interests.clear();

                      // console.log("-")
                      // console.log("--")
                      // console.log("---")
                      // console.log("----")
                      // console.log("Record removed from Ofline Database ")
                      // console.log("----")
                      // console.log("---")
                      // console.log("--")
                      // console.log("-")

                    }
                  }).catch(function (error) {
                    console.log(error);
                  });
                  _this2.syncData.splice(0, _this2.syncData.length);
                });
                __WEBPACK_IMPORTED_MODULE_3__main__["indDB"].sub_dashboard_interests.count(function (count) {
                  console.log(count);
                });

              case 5:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    },
    showNavigation: function showNavigation() {
      this.showNavigationBool = !this.showNavigationBool;
    },
    offMoreMenu: function offMoreMenu() {
      if (this.showMoreMenuBool == true) {
        this.showMoreMenu();
      }
    },
    showMoreMenu: function showMoreMenu() {
      // this.showMoreMenuBool = !this.showMoreMenuBool;
      this.showMoreMenuBool == false ? this.showMoreMenuBool = true : this.showMoreMenuBool = false;
    },
    nhmis: function nhmis() {
      this.$router.push({ path: '/' });
    },
    toggle: function toggle() {

      this.$refs['fullscreen'].toggle();
    },
    enter: function enter() {
      return true;
    },
    fullscreenChange: function fullscreenChange(fullscreen) {
      this.fullscreen = fullscreen;
      this.$store.dispatch('fullscreen', fullscreen);
    },

    // tour guide function
    startTour: function startTour() {
      this.isTourActive = false;
      // Instance the tour
      this.isTourStarts = false;
      introJs().start();
    },

    // print window function
    printPage: function printPage(doc) {
      window.print();
    },

    // go to url
    goto: function goto(url) {
      window.open(url);
      //location.href = "https://mapping.fmohconnect.gov.ng/data-inventory/add-dataset/";
    },

    // convert page to pdf
    convertToPDF: function convertToPDF(element_id) {
      var element = document.getElementById(element_id);
      var opt = {
        margin: 1,
        filename: 'central_analytics_dashboard.pdf',
        image: { type: 'jpeg', quality: 0.98 },
        html2canvas: { scale: 2 },
        jsPDF: { unit: 'mm', format: 'a2', orientation: 'l' }
      };
      // New Promise-based usage:
      __WEBPACK_IMPORTED_MODULE_5_html2pdf_js___default()().from(element).set(opt).save();
    },
    getNameLookUP: function getNameLookUP(name) {
      return this.nameLookUp[name];
    },
    startSlideTimer: function startSlideTimer() {
      // var counter = 0;
      // var slideTime = auth.getLocation() === "NERICC"? 360000: 300000;
      // this.URLsToAccess[auth.getLocation()].map( (elem, index) => {
      //   if (elem === '/new_nphcda_dashboard'){
      //     counter += 540000;
      //   }else{
      //     counter += slideTime;
      //   }
      //   setTimeout( () => {
      //     this.$router.push({ path: elem });
      //   }, counter)
      // })
    },
    isActiveLoc: function isActiveLoc(param) {
      return this.$route.path === param;
    },
    getSideMenuItems: function getSideMenuItems() {
      // var userLocations = this.URLsToAccess[auth.getLocation()];
      // var items = [];

      // this.sideMenuItems.map( (elem, index) => {
      //   if (userLocations.includes(elem.route)) {
      //     items.push(elem);
      //   }
      // });
      // this.items[0].items = items;
    },
    goToZonalChart: function goToZonalChart(e) {
      this.$store.dispatch('goToZonalChart', e); // dispatched to store to be used in MainCARDashboard
    },
    shareDashboardState: function shareDashboardState() {
      this.$store.dispatch('storeShareCounter');
    },
    reloadData: function reloadData() {
      var confirmation = window.confirm("Are you sure you want to refresh Platform Data?");
      if (confirmation) {
        this.$store.dispatch('reloadData');
      }
    }
  },
  props: {
    source: String
  },
  computed: {
    isCentralAnalytics: function isCentralAnalytics() {
      var url = this.$route.path;
      var CAR_path = ['/central_analytics', '/car_dashboard', '/fmoh_car', '/help', '/about'];
      if (CAR_path.includes(url)) {
        return true;
      }
      return false;
    },
    isMSDATPage: function isMSDATPage() {
      var url = this.$route.path;
      var MSDATPage = ['/central_analytics', '/car_dashboard'];
      if (MSDATPage.includes(url)) {
        return true;
      }
      return false;
    },
    isAdmin: function isAdmin() {
      return __WEBPACK_IMPORTED_MODULE_4__components_Auth_auth__["a" /* default */].getLocation() === 'Admin';
    },

    routeName: function routeName() {
      return this.$route.path;
      // this.$router.options.routes,
    },
    userLocations: function userLocations() {
      // console.log(auth.getLocation(), this.URLsToAccess[auth.getLocation()]);
      this.getSideMenuItems();
      this.startSlideTimer();
      this.loggedIn;
      return []; //this.URLsToAccess[auth.getLocation()];
    },


    //////////////////////////////////////////////////////
    //SUB DASHBOARDS
    currentPage: function currentPage() {
      return this.$route.path;
    }
    //////////////////////////////////////////////////////

  },
  created: function created() {
    var _this3 = this;

    __WEBPACK_IMPORTED_MODULE_4__components_Auth_auth__["a" /* default */].onChange = function (loggedIn) {
      _this3.loggedIn = loggedIn;
    };
    this.currentUrl = this.$route.path;
    // if(this.$route.path === "/state_profile"){
    //                console.log("MSDAT State Health Profiles")
    //           }else{
    //              console.log("Multi-Source Data Analytics & Triangulation (MSDAT) Platform")
    //           }

  },
  updated: function updated() {
    var _this4 = this;

    // let covid_button = document.getElementById("covid-button");
    var dropdown = document.getElementById("navigation-dropdown");
    var button = document.getElementById("dropdown-button");
    var section_dropdown = document.getElementById("section-dropdown");
    window.addEventListener('scroll', function () {
      _this4.showNavigationBool = false;
      _this4.showMoreMenuBool = false;
    });
    // window.addEventListener('click',()=> {
    //   this.showNavigationBool = false;
    //   this.showMoreMenuBool = false;
    // });
    window.addEventListener('click', function (event) {
      if (button === event.target || section_dropdown === event.target /* || covid_button === event.target*/) {
          _this4.showMoreMenuBool = false;
        } else {
        _this4.showNavigationBool = false;
      }
    });
  },

  watch: {
    loggedIn: function loggedIn(val) {
      this.getSideMenuItems();
      this.startSlideTimer();
    }
  }
  // computed: {
  //   avatarSize () {
  //     return `${this.slider}px`
  //   }
  // }@import './stylus/main'
  // @import '~vuetify/src/stylus/main'
});

/***/ }),

/***/ 462:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__ = __webpack_require__(137);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(419);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys__ = __webpack_require__(136);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_foreach__ = __webpack_require__(740);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_foreach___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash_foreach__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash_assign__ = __webpack_require__(232);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_lodash_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash_clonedeep__ = __webpack_require__(233);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash_clonedeep___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_lodash_clonedeep__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash_filter__ = __webpack_require__(739);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash_filter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_lodash_filter__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_diacriticless__ = __webpack_require__(214);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_diacriticless___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_diacriticless__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__types_default__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__VgtPagination_vue__ = __webpack_require__(777);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__VgtPagination_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__VgtPagination_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__VgtGlobalSearch_vue__ = __webpack_require__(775);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__VgtGlobalSearch_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__VgtGlobalSearch_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__VgtTableHeader_vue__ = __webpack_require__(779);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__VgtTableHeader_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__VgtTableHeader_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__VgtHeaderRow_vue__ = __webpack_require__(776);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__VgtHeaderRow_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__VgtHeaderRow_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__types_index__ = __webpack_require__(457);




//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//












// here we load each data type module.


var dataTypes = {};
var coreDataTypes = __WEBPACK_IMPORTED_MODULE_14__types_index__["a" /* default */];
__WEBPACK_IMPORTED_MODULE_4_lodash_foreach___default()(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys___default()(coreDataTypes), function (key) {
  var compName = key.replace(/^\.\//, '').replace(/\.js/, '');
  dataTypes[compName] = coreDataTypes[key].default;
});

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'vue-good-table',
  props: {
    isLoading: { default: false, type: Boolean },
    maxHeight: { default: null, type: String },
    fixedHeader: { default: false, type: Boolean },
    theme: { default: '' },
    mode: { default: 'local' }, // could be remote
    totalRows: {}, // required if mode = 'remote'
    styleClass: { default: 'vgt-table bordered' },
    columns: {},
    rows: {},
    lineNumbers: { default: false },
    responsive: { default: true },
    rtl: { default: false },
    rowStyleClass: { default: null, type: [Function, String] },

    enableColumnGrouping: {
      default: false,
      type: Boolean
    },
    groupOptions: {
      default: function _default() {
        return {
          enabled: false
        };
      }
    },

    selectOptions: {
      default: function _default() {
        return {
          enabled: false,
          selectionInfoClass: '',
          selectionText: 'rows selected',
          clearSelectionText: 'clear'
        };
      }
    },

    // sort
    sortOptions: {
      default: function _default() {
        return {
          enabled: true,
          initialSortBy: {}
        };
      }
    },

    // pagination
    paginationOptions: {
      default: function _default() {
        return {
          enabled: false,
          perPage: 10,
          perPageDropdown: null,
          position: 'bottom',
          dropdownAllowAll: true,
          mode: 'records' // or pages
        };
      }
    },

    searchOptions: {
      default: function _default() {
        return {
          enabled: false,
          trigger: null,
          externalQuery: null,
          searchFn: null,
          placeholder: 'Search Table'
        };
      }
    }
  },

  data: function data() {
    return {
      // loading state for remote mode
      tableLoading: false,

      // text options
      nextText: 'Next',
      prevText: 'Prev',
      rowsPerPageText: 'Rows per page',
      ofText: 'of',
      allText: 'All',
      pageText: 'page',

      // internal select options
      selectable: false,
      selectOnCheckboxOnly: false,
      selectAllByPage: true,
      selectionInfoClass: '',
      selectionText: 'rows selected',
      clearSelectionText: 'clear',

      // internal sort options
      sortable: false,
      defaultSortBy: null,

      // internal search options
      searchEnabled: false,
      searchTrigger: null,
      externalSearchQuery: null,
      searchFn: null,
      searchPlaceholder: 'Search Table',

      // internal pagination options
      perPage: null,
      paginate: false,
      paginateOnTop: false,
      paginateOnBottom: true,
      customRowsPerPageDropdown: [],
      paginateDropdownAllowAll: true,
      paginationMode: 'records',

      currentPage: 1,
      currentPerPage: 10,
      sortColumn: -1,
      sortType: 'asc',
      globalSearchTerm: '',
      filteredRows: [],
      columnFilters: {},
      forceSearch: false,
      sortChanged: false,
      dataTypes: dataTypes || {},
      childColumns: {}
    };
  },

  watch: {
    rows: {
      handler: function handler() {
        this.tableLoading = false;
        this.filterRows(this.columnFilters, false);
      },

      deep: true,
      immediate: true
    },

    selectOptions: {
      handler: function handler() {
        this.initializeSelect();
      },

      deep: true,
      immediate: true
    },

    paginationOptions: {
      handler: function handler() {
        this.initializePagination();
      },

      deep: true,
      immediate: true
    },

    searchOptions: {
      handler: function handler() {
        if (this.searchOptions.externalQuery !== undefined && this.searchOptions.externalQuery !== this.searchTerm) {
          this.handleSearch();
        }
        this.initializeSearch();
      },

      deep: true,
      immediate: true
    },

    sortOptions: {
      handler: function handler() {
        this.initializeSort();
      },

      deep: true,
      immediate: true
    },

    selectedRows: function selectedRows() {
      this.$emit('on-selected-rows-change', {
        selectedRows: this.selectedRows
      });
    }
  },

  computed: {
    wrapperStyles: function wrapperStyles() {
      return {
        overflow: 'scroll-y',
        maxHeight: this.maxHeight ? this.maxHeight : 'auto'
      };
    },
    hasHeaderRowTemplate: function hasHeaderRowTemplate() {
      return !!this.$slots['table-header-row'] || !!this.$scopedSlots['table-header-row'];
    },
    isTableLoading: function isTableLoading() {
      return this.isLoading || this.tableLoading;
    },
    showEmptySlot: function showEmptySlot() {
      if (!this.paginated.length) return true;

      if (this.paginated[0].label === 'no groups' && !this.paginated[0].children.length) return true;

      return false;
    },
    allSelected: function allSelected() {
      return this.selectedRowCount > 0 && (this.selectAllByPage && this.selectedPageRowsCount === this.totalPageRowCount || !this.selectAllByPage && this.selectedRowCount === this.totalRowCount);
    },
    allSelectedIndeterminate: function allSelectedIndeterminate() {
      return !this.allSelected && (this.selectAllByPage && this.selectedPageRowsCount > 0 || !this.selectAllByPage && this.selectedRowCount > 0);
    },
    selectionInfo: function selectionInfo() {
      return this.selectedRowCount + ' ' + this.selectionText;
    },
    selectedRowCount: function selectedRowCount() {
      return this.selectedRows.length;
    },
    selectedPageRowsCount: function selectedPageRowsCount() {
      return this.selectedPageRows.length;
    },
    selectedPageRows: function selectedPageRows() {
      var selectedRows = [];
      __WEBPACK_IMPORTED_MODULE_4_lodash_foreach___default()(this.paginated, function (headerRow) {
        __WEBPACK_IMPORTED_MODULE_4_lodash_foreach___default()(headerRow.children, function (row) {
          if (row.vgtSelected) {
            selectedRows.push(row);
          }
        });
      });
      return selectedRows;
    },
    selectedRows: function selectedRows() {
      var selectedRows = [];
      __WEBPACK_IMPORTED_MODULE_4_lodash_foreach___default()(this.processedRows, function (headerRow) {
        __WEBPACK_IMPORTED_MODULE_4_lodash_foreach___default()(headerRow.children, function (row) {
          if (row.vgtSelected) {
            selectedRows.push(row);
          }
        });
      });
      return selectedRows;
    },
    fullColspan: function fullColspan() {
      var fullColspan = this.childColumns.length;
      if (this.lineNumbers) fullColspan++;
      if (this.selectable) fullColspan++;
      return fullColspan;
    },
    groupHeaderOnTop: function groupHeaderOnTop() {
      if (this.groupOptions && this.groupOptions.enabled && this.groupOptions.headerPosition && this.groupOptions.headerPosition === 'bottom') {
        return false;
      }
      if (this.groupOptions && this.groupOptions.enabled) return true;

      // will only get here if groupOptions is false
      return false;
    },
    groupHeaderOnBottom: function groupHeaderOnBottom() {
      if (this.groupOptions && this.groupOptions.enabled && this.groupOptions.headerPosition && this.groupOptions.headerPosition === 'bottom') {
        return true;
      }
      return false;
    },
    totalRowCount: function totalRowCount() {
      var total = 0;
      __WEBPACK_IMPORTED_MODULE_4_lodash_foreach___default()(this.processedRows, function (headerRow) {
        total += headerRow.children ? headerRow.children.length : 0;
      });
      return total;
    },
    totalPageRowCount: function totalPageRowCount() {
      var total = 0;
      __WEBPACK_IMPORTED_MODULE_4_lodash_foreach___default()(this.paginated, function (headerRow) {
        total += headerRow.children ? headerRow.children.length : 0;
      });
      return total;
    },
    tableStyleClasses: function tableStyleClasses() {
      var classes = this.styleClass;
      classes += ' ' + this.theme;
      return classes;
    },
    searchTerm: function searchTerm() {
      return this.externalSearchQuery != null ? this.externalSearchQuery : this.globalSearchTerm;
    },


    //
    globalSearchAllowed: function globalSearchAllowed() {
      if (this.searchEnabled && !!this.globalSearchTerm && this.searchTrigger !== 'enter') {
        return true;
      }

      if (this.externalSearchQuery != null && this.searchTrigger !== 'enter') {
        return true;
      }

      if (this.forceSearch) {
        this.forceSearch = false;
        return true;
      }

      return false;
    },


    // this is done everytime sortColumn
    // or sort type changes
    //----------------------------------------
    processedRows: function processedRows() {
      var _this = this;

      // we only process rows when mode is local
      var computedRows = this.filteredRows;
      if (this.mode === 'remote') {
        return computedRows;
      }

      // take care of the global filter here also
      if (this.globalSearchAllowed) {
        // here also we need to de-construct and then
        // re-construct the rows.
        var allRows = [];
        __WEBPACK_IMPORTED_MODULE_4_lodash_foreach___default()(this.filteredRows, function (headerRow) {
          allRows.push.apply(allRows, __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray___default()(headerRow.children));
        });
        var filteredRows = [];
        __WEBPACK_IMPORTED_MODULE_4_lodash_foreach___default()(allRows, function (row) {
          __WEBPACK_IMPORTED_MODULE_4_lodash_foreach___default()(_this.childColumns, function (col) {
            // if col does not have search disabled,
            if (!col.globalSearchDisabled) {
              // if a search function is provided,
              // use that for searching, otherwise,
              // use the default search behavior
              if (_this.searchFn) {
                var foundMatch = _this.searchFn(row, col, _this.collectFormatted(row, col), _this.searchTerm);
                if (foundMatch) {
                  filteredRows.push(row);
                  return false; // break the loop
                }
              } else {
                // comparison
                var matched = __WEBPACK_IMPORTED_MODULE_9__types_default__["a" /* default */].filterPredicate(_this.collectFormatted(row, col), _this.searchTerm);
                if (matched) {
                  filteredRows.push(row);
                  return false; // break loop
                }
              }
            }
          });
        });

        // this is where we emit on search
        this.$emit('on-search', {
          searchTerm: this.searchTerm,
          rowCount: filteredRows.length
        });

        // here we need to reconstruct the nested structure
        // of rows
        computedRows = [];
        __WEBPACK_IMPORTED_MODULE_4_lodash_foreach___default()(this.filteredRows, function (headerRow) {
          var i = headerRow.vgt_header_id;
          var children = __WEBPACK_IMPORTED_MODULE_7_lodash_filter___default()(filteredRows, ['vgt_id', i]);
          if (children.length) {
            var newHeaderRow = __WEBPACK_IMPORTED_MODULE_6_lodash_clonedeep___default()(headerRow);
            newHeaderRow.children = children;
            computedRows.push(newHeaderRow);
          }
        });
      }

      // taking care of sort here only if sort has changed
      if (this.sortColumn !== -1 && this.isSortableColumn(this.sortColumn) && (
      // if search trigger is enter then we only sort
      // when enter is hit
      this.searchTrigger !== 'enter' || this.sortChanged)) {
        this.sortChanged = false;

        __WEBPACK_IMPORTED_MODULE_4_lodash_foreach___default()(computedRows, function (cRows) {
          cRows.children.sort(function (x, y) {
            if (!_this.childColumns[_this.sortColumn]) return 0;

            var xvalue = _this.collect(x, _this.childColumns[_this.sortColumn].field);
            var yvalue = _this.collect(y, _this.childColumns[_this.sortColumn].field);

            // if user has provided a custom sort, use that instead of
            // built-in sort
            var sortFn = _this.childColumns[_this.sortColumn].sortFn;

            if (sortFn && typeof sortFn === 'function') {
              return sortFn(xvalue, yvalue, _this.childColumns[_this.sortColumn], x, y) * (_this.sortType === 'desc' ? -1 : 1);
            }

            // built in sort
            var typeDef = _this.typedColumns[_this.sortColumn].typeDef;

            return typeDef.compare(xvalue, yvalue, _this.childColumns[_this.sortColumn]) * (_this.sortType === 'desc' ? -1 : 1);
          });
        });
      }

      // if the filtering is event based, we need to maintain filter
      // rows
      if (this.searchTrigger === 'enter') {
        this.filteredRows = computedRows;
      }
      return computedRows;
    },
    paginated: function paginated() {
      if (!this.processedRows.length) return [];

      if (this.mode === 'remote') {
        return this.processedRows;
      }

      // for every group, extract the child rows
      // to cater to paging
      var paginatedRows = [];
      __WEBPACK_IMPORTED_MODULE_4_lodash_foreach___default()(this.processedRows, function (childRows) {
        var _paginatedRows;

        (_paginatedRows = paginatedRows).push.apply(_paginatedRows, __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray___default()(childRows.children));
      });

      if (this.paginate) {
        var pageStart = (this.currentPage - 1) * this.currentPerPage;

        // in case of filtering we might be on a page that is
        // not relevant anymore
        // also, if setting to all, current page will not be valid
        if (pageStart >= paginatedRows.length || this.currentPerPage === -1) {
          this.currentPage = 1;
          pageStart = 0;
        }

        // calculate page end now
        var pageEnd = paginatedRows.length + 1;

        // if the setting is set to 'all'
        if (this.currentPerPage !== -1) {
          pageEnd = this.currentPage * this.currentPerPage;
        }

        paginatedRows = paginatedRows.slice(pageStart, pageEnd);
      }
      // reconstruct paginated rows here
      var reconstructedRows = [];
      __WEBPACK_IMPORTED_MODULE_4_lodash_foreach___default()(this.processedRows, function (headerRow) {
        var i = headerRow.vgt_header_id;
        var children = __WEBPACK_IMPORTED_MODULE_7_lodash_filter___default()(paginatedRows, ['vgt_id', i]);
        if (children.length) {
          var newHeaderRow = __WEBPACK_IMPORTED_MODULE_6_lodash_clonedeep___default()(headerRow);
          newHeaderRow.children = children;
          reconstructedRows.push(newHeaderRow);
        }
      });
      return reconstructedRows;
    },
    originalRows: function originalRows() {
      var rows = __WEBPACK_IMPORTED_MODULE_6_lodash_clonedeep___default()(this.rows);
      var nestedRows = [];
      if (!this.groupOptions.enabled) {
        nestedRows = this.handleGrouped([{
          label: 'no groups',
          children: rows
        }]);
      } else {
        nestedRows = this.handleGrouped(rows);
      }
      // we need to preserve the original index of
      // rows so lets do that
      var index = 0;
      __WEBPACK_IMPORTED_MODULE_4_lodash_foreach___default()(nestedRows, function (headerRow, i) {
        __WEBPACK_IMPORTED_MODULE_4_lodash_foreach___default()(headerRow.children, function (row, j) {
          row.originalIndex = index++;
        });
      });

      return nestedRows;
    },
    typedColumns: function typedColumns() {
      var columns = __WEBPACK_IMPORTED_MODULE_5_lodash_assign___default()(this.childColumns, []);
      for (var i = 0; i < this.childColumns.length; i++) {
        var column = columns[i];
        column.typeDef = this.dataTypes[column.type] || __WEBPACK_IMPORTED_MODULE_9__types_default__["a" /* default */];
      }
      return columns;
    },
    hasRowClickListener: function hasRowClickListener() {
      return this.$listeners && this.$listeners['on-row-click'];
    }
  },

  methods: {
    getColumnGroups: function getColumnGroups() {
      var columns = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.columns;

      var columnsGroups = [];
      columns.forEach(function (column) {
        if (column.children) {
          columnsGroups.push({
            label: column.label,
            colSpan: column.children.length
          });
        }
      });
      return columnsGroups;
    },
    getchildColumns: function getchildColumns() {
      var childColumns = [];
      this.columns.forEach(function (column) {
        childColumns.push.apply(childColumns, __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray___default()(column.children));
      });
      return childColumns;
    },
    handleSearch: function handleSearch() {
      this.resetTable();
      // for remote mode, we need to emit on-search
      if (this.mode === 'remote') {
        this.$emit('on-search', {
          searchTerm: this.searchTerm
        });
      }
    },
    reset: function reset() {
      this.initializeSort();
      this.changePage(1);
      this.$refs['filter-row'].reset(true);
    },
    emitSelectedRows: function emitSelectedRows() {
      this.$emit('on-select-all', {
        selected: this.selectedRowCount === this.totalRowCount,
        selectedRows: this.selectedRows
      });
    },
    unselectAllInternal: function unselectAllInternal(forceAll) {
      var _this2 = this;

      var rows = this.selectAllByPage && !forceAll ? this.paginated : this.filteredRows;
      __WEBPACK_IMPORTED_MODULE_4_lodash_foreach___default()(rows, function (headerRow, i) {
        __WEBPACK_IMPORTED_MODULE_4_lodash_foreach___default()(headerRow.children, function (row, j) {
          _this2.$set(row, 'vgtSelected', false);
        });
      });
      this.emitSelectedRows();
    },
    toggleSelectAll: function toggleSelectAll() {
      var _this3 = this;

      if (this.allSelected) {
        this.unselectAllInternal();
        return;
      }
      var rows = this.selectAllByPage ? this.paginated : this.filteredRows;
      __WEBPACK_IMPORTED_MODULE_4_lodash_foreach___default()(rows, function (headerRow) {
        __WEBPACK_IMPORTED_MODULE_4_lodash_foreach___default()(headerRow.children, function (row) {
          _this3.$set(row, 'vgtSelected', true);
        });
      });
      this.emitSelectedRows();
    },
    changePage: function changePage(value) {
      if (this.paginationOptions.enabled) {
        var paginationWidget = this.$refs.paginationBottom;
        if (this.paginationOptions.position === 'top') {
          paginationWidget = this.$refs.paginationTop;
        }
        if (paginationWidget) {
          paginationWidget.currentPage = value;
          // we also need to set the currentPage
          // for table.
          this.currentPage = value;
        }
      }
    },
    pageChangedEvent: function pageChangedEvent() {
      return {
        currentPage: this.currentPage,
        currentPerPage: this.currentPerPage,
        total: Math.floor(this.totalRowCount / this.currentPerPage)
      };
    },
    pageChanged: function pageChanged(pagination) {
      this.currentPage = pagination.currentPage;
      var pageChangedEvent = this.pageChangedEvent();
      pageChangedEvent.prevPage = pagination.prevPage;
      this.$emit('on-page-change', pageChangedEvent);
      if (this.mode === 'remote') {
        this.tableLoading = true;
      }
    },
    perPageChanged: function perPageChanged(pagination) {
      this.currentPerPage = pagination.currentPerPage;
      var perPageChangedEvent = this.pageChangedEvent();
      this.$emit('on-per-page-change', perPageChangedEvent);
      if (this.mode === 'remote') {
        this.tableLoading = true;
      }
    },
    sort: function sort(index) {
      if (!this.isSortableColumn(index)) return;

      if (this.sortColumn === index) {
        this.sortType = this.sortType === 'asc' ? 'desc' : 'asc';
      } else {
        this.sortType = 'asc';
        this.sortColumn = index;
      }

      this.$emit('on-sort-change', {
        sortType: this.sortType,
        columnIndex: this.sortColumn
      });

      // every time we change sort we need to reset to page 1
      this.changePage(1);

      // if the mode is remote, we don't need to do anything
      // after this. just set table loading to true
      if (this.mode === 'remote') {
        this.tableLoading = true;
        return;
      }
      this.sortChanged = true;
    },


    // checkbox click should always do the following
    onCheckboxClicked: function onCheckboxClicked(row, index, event) {
      this.$set(row, 'vgtSelected', !row.vgtSelected);
      this.$emit('on-row-click', {
        row: row,
        pageIndex: index,
        selected: !!row.vgtSelected,
        event: event
      });
    },
    onRowDoubleClicked: function onRowDoubleClicked(row, index, event) {
      this.$emit('on-row-dblclick', {
        row: row,
        pageIndex: index,
        selected: !!row.vgtSelected,
        event: event
      });
    },
    onRowClicked: function onRowClicked(row, index, event) {
      if (this.selectable && !this.selectOnCheckboxOnly) {
        this.$set(row, 'vgtSelected', !row.vgtSelected);
      }
      this.$emit('on-row-click', {
        row: row,
        pageIndex: index,
        selected: !!row.vgtSelected,
        event: event
      });
    },
    onCellClicked: function onCellClicked(row, column, rowIndex, event) {
      this.$emit('on-cell-click', {
        row: row,
        column: column,
        rowIndex: rowIndex,
        event: event
      });
    },
    onMouseenter: function onMouseenter(row, index) {
      this.$emit('on-row-mouseenter', {
        row: row,
        pageIndex: index
      });
    },
    onMouseleave: function onMouseleave(row, index) {
      this.$emit('on-row-mouseleave', {
        row: row,
        pageIndex: index
      });
    },
    searchTableOnEnter: function searchTableOnEnter() {
      if (this.searchTrigger === 'enter') {
        this.handleSearch();
        // we reset the filteredRows here because
        // we want to search across everything.
        this.filteredRows = __WEBPACK_IMPORTED_MODULE_6_lodash_clonedeep___default()(this.originalRows);
        this.forceSearch = true;
        this.sortChanged = true;
      }
    },
    searchTableOnKeyUp: function searchTableOnKeyUp() {
      if (this.searchTrigger !== 'enter') {
        this.handleSearch();
      }
    },
    resetTable: function resetTable() {
      this.unselectAllInternal(true);
      // every time we searchTable
      this.changePage(1);
    },


    // field can be:
    // 1. function
    // 2. regular property - ex: 'prop'
    // 3. nested property path - ex: 'nested.prop'
    collect: function collect(obj, field) {
      // utility function to get nested property
      function dig(obj, selector) {
        var result = obj;
        var splitter = selector.split('.');
        for (var i = 0; i < splitter.length; i++) {
          if (typeof result === 'undefined') {
            return undefined;
          }
          result = result[splitter[i]];
        }
        return result;
      }

      if (typeof field === 'function') return field(obj);
      if (typeof field === 'string') return dig(obj, field);
      return undefined;
    },
    collectFormatted: function collectFormatted(obj, column) {
      var headerRow = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

      var value = void 0;
      if (headerRow && column.headerField) {
        value = this.collect(obj, column.headerField);
      } else {
        value = this.collect(obj, column.field);
      }
      if (value === undefined) return '';

      // if user has supplied custom formatter,
      // use that here
      if (column.formatFn && typeof column.formatFn === 'function') {
        return column.formatFn(value);
      }

      // lets format the resultant data
      var type = column.typeDef;
      // this will only happen if we try to collect formatted
      // before types have been initialized. for example: on
      // load when external query is specified.
      if (!type) {
        type = this.dataTypes[column.type] || __WEBPACK_IMPORTED_MODULE_9__types_default__["a" /* default */];
      }
      return type.format(value, column);
    },
    formattedRow: function formattedRow(row) {
      var isHeaderRow = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

      var formattedRow = {};
      for (var i = 0; i < this.typedColumns.length; i++) {
        var col = this.typedColumns[i];
        // what happens if field is
        if (col.field) {
          formattedRow[col.field] = this.collectFormatted(row, col, isHeaderRow);
        }
      }
      return formattedRow;
    },


    // Check if a column is sortable.
    isSortableColumn: function isSortableColumn(index) {
      var _ref = this.childColumns[index] || { sortable: false },
          sortable = _ref.sortable;

      var isSortable = typeof sortable === 'boolean' ? sortable : this.sortable;
      return isSortable;
    },


    // Get classes for the given column index & element.
    getClasses: function getClasses(index, element) {
      // console.log(this.typedColumns);
      var _typedColumns$index = this.typedColumns[index],
          typeDef = _typedColumns$index.typeDef,
          custom = _typedColumns$index[element + 'Class'];
      var isRight = typeDef.isRight;

      if (this.rtl) isRight = true;
      var classes = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()({
        'vgt-right-align': isRight,
        'vgt-left-align': !isRight
      }, custom, !!custom);
      return classes;
    },


    // method to filter rows
    filterRows: function filterRows(columnFilters) {
      var _this4 = this;

      var fromFilter = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

      // if (!this.rows.length) return;
      // this is invoked either as a result of changing filters
      // or as a result of modifying rows.
      this.columnFilters = columnFilters;
      var computedRows = __WEBPACK_IMPORTED_MODULE_6_lodash_clonedeep___default()(this.originalRows);

      // do we have a filter to care about?
      // if not we don't need to do anything
      if (this.columnFilters && __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys___default()(this.columnFilters).length) {
        // every time we filter rows, we need to set current page
        // to 1
        // if the mode is remote, we only need to reset, if this is
        // being called from filter, not when rows are changing
        if (this.mode !== 'remote' || fromFilter) {
          this.changePage(1);
        }
        // we need to emit an event and that's that.
        // but this only needs to be invoked if filter is changing
        // not when row object is modified.
        if (fromFilter) {
          this.$emit('on-column-filter', {
            columnFilters: this.columnFilters
          });
        }

        // if mode is remote, we don't do any filtering here.
        if (this.mode === 'remote') {
          if (fromFilter) {
            this.tableLoading = true;
          } else {
            // if remote filtering has already been taken care of.
            this.filteredRows = computedRows;
          }
          return;
        }

        var _loop = function _loop(i) {
          var col = _this4.typedColumns[i];
          if (_this4.columnFilters[col.field]) {
            computedRows = __WEBPACK_IMPORTED_MODULE_4_lodash_foreach___default()(computedRows, function (headerRow) {
              var newChildren = headerRow.children.filter(function (row) {
                // If column has a custom filter, use that.
                if (col.filterOptions && typeof col.filterOptions.filterFn === 'function') {
                  return col.filterOptions.filterFn(_this4.collect(row, col.field), _this4.columnFilters[col.field]);
                }
                // Otherwise Use default filters
                var typeDef = col.typeDef;

                return typeDef.filterPredicate(_this4.collect(row, col.field), _this4.columnFilters[col.field]);
              });
              // should we remove the header?
              headerRow.children = newChildren;
            });
          }
        };

        for (var i = 0; i < this.typedColumns.length; i++) {
          _loop(i);
        }
      }
      this.filteredRows = computedRows;
    },
    getCurrentIndex: function getCurrentIndex(index) {
      return (this.currentPage - 1) * this.currentPerPage + index + 1;
    },
    getRowStyleClass: function getRowStyleClass(row) {
      var classes = '';
      if (this.hasRowClickListener) classes += 'clickable';
      var rowStyleClasses = void 0;
      if (typeof this.rowStyleClass === 'function') {
        rowStyleClasses = this.rowStyleClass(row);
      } else {
        rowStyleClasses = this.rowStyleClass;
      }
      if (rowStyleClasses) {
        classes += ' ' + rowStyleClasses;
      }
      return classes;
    },
    handleGrouped: function handleGrouped(originalRows) {
      __WEBPACK_IMPORTED_MODULE_4_lodash_foreach___default()(originalRows, function (headerRow, i) {
        headerRow.vgt_header_id = i;
        __WEBPACK_IMPORTED_MODULE_4_lodash_foreach___default()(headerRow.children, function (childRow) {
          childRow.vgt_id = i;
        });
      });
      return originalRows;
    },


    // handleRows() {
    //   if (!this.groupOptions.enabled) {
    //     this.filteredRows = this.handleGrouped([{
    //       label: 'no groups',
    //       children: this.originalRows,
    //     }]);
    //   } else {
    //     this.filteredRows = this.handleGrouped(this.originalRows);
    //   }
    // },

    handleDefaultSort: function handleDefaultSort() {
      for (var index = 0; index < this.childColumns.length; index++) {
        var _col = this.childColumns[index];
        if (_col.field === this.defaultSortBy.field) {
          this.sortColumn = index;
          this.sortType = this.defaultSortBy.type || 'asc';
          this.sortChanged = true;
          break;
        }
      }
    },
    initializePagination: function initializePagination() {
      var _this5 = this;

      var _paginationOptions = this.paginationOptions,
          enabled = _paginationOptions.enabled,
          perPage = _paginationOptions.perPage,
          position = _paginationOptions.position,
          perPageDropdown = _paginationOptions.perPageDropdown,
          dropdownAllowAll = _paginationOptions.dropdownAllowAll,
          nextLabel = _paginationOptions.nextLabel,
          prevLabel = _paginationOptions.prevLabel,
          rowsPerPageLabel = _paginationOptions.rowsPerPageLabel,
          ofLabel = _paginationOptions.ofLabel,
          pageLabel = _paginationOptions.pageLabel,
          allLabel = _paginationOptions.allLabel,
          setCurrentPage = _paginationOptions.setCurrentPage,
          mode = _paginationOptions.mode;


      if (typeof enabled === 'boolean') {
        this.paginate = enabled;
      }

      if (typeof perPage === 'number') {
        this.perPage = perPage;
      }

      if (position === 'top') {
        this.paginateOnTop = true; // default is false
        this.paginateOnBottom = false; // default is true
      } else if (position === 'both') {
        this.paginateOnTop = true;
        this.paginateOnBottom = true;
      }

      if (Array.isArray(perPageDropdown) && perPageDropdown.length) {
        this.customRowsPerPageDropdown = perPageDropdown;
      }

      if (typeof dropdownAllowAll === 'boolean') {
        this.paginateDropdownAllowAll = dropdownAllowAll;
      }

      if (typeof mode === 'string') {
        this.paginationMode = mode;
      }

      if (typeof nextLabel === 'string') {
        this.nextText = nextLabel;
      }

      if (typeof prevLabel === 'string') {
        this.prevText = prevLabel;
      }

      if (typeof rowsPerPageLabel === 'string') {
        this.rowsPerPageText = rowsPerPageLabel;
      }

      if (typeof ofLabel === 'string') {
        this.ofText = ofLabel;
      }

      if (typeof pageLabel === 'string') {
        this.pageText = pageLabel;
      }

      if (typeof allLabel === 'string') {
        this.allText = allLabel;
      }

      if (typeof setCurrentPage === 'number') {
        setTimeout(function () {
          _this5.changePage(setCurrentPage);
        }, 500);
      }
    },
    initializeSearch: function initializeSearch() {
      var _searchOptions = this.searchOptions,
          enabled = _searchOptions.enabled,
          trigger = _searchOptions.trigger,
          externalQuery = _searchOptions.externalQuery,
          searchFn = _searchOptions.searchFn,
          placeholder = _searchOptions.placeholder;


      if (typeof enabled === 'boolean') {
        this.searchEnabled = enabled;
      }

      if (trigger === 'enter') {
        this.searchTrigger = trigger;
      }

      if (typeof externalQuery === 'string') {
        this.externalSearchQuery = externalQuery;
      }

      if (typeof searchFn === 'function') {
        this.searchFn = searchFn;
      }

      if (typeof placeholder === 'string') {
        this.searchPlaceholder = placeholder;
      }
    },
    initializeSort: function initializeSort() {
      var _sortOptions = this.sortOptions,
          enabled = _sortOptions.enabled,
          initialSortBy = _sortOptions.initialSortBy;


      if (typeof enabled === 'boolean') {
        this.sortable = enabled;
      }

      if ((typeof initialSortBy === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(initialSortBy)) === 'object') {
        this.defaultSortBy = initialSortBy;
        this.handleDefaultSort();
      }
    },
    initializeSelect: function initializeSelect() {
      var _selectOptions = this.selectOptions,
          enabled = _selectOptions.enabled,
          selectionInfoClass = _selectOptions.selectionInfoClass,
          selectionText = _selectOptions.selectionText,
          clearSelectionText = _selectOptions.clearSelectionText,
          selectOnCheckboxOnly = _selectOptions.selectOnCheckboxOnly,
          selectAllByPage = _selectOptions.selectAllByPage;


      if (typeof enabled === 'boolean') {
        this.selectable = enabled;
      }

      if (typeof selectOnCheckboxOnly === 'boolean') {
        this.selectOnCheckboxOnly = selectOnCheckboxOnly;
      }

      if (typeof selectAllByPage === 'boolean') {
        this.selectAllByPage = selectAllByPage;
      }

      if (typeof selectionInfoClass === 'string') {
        this.selectionInfoClass = selectionInfoClass;
      }

      if (typeof selectionText === 'string') {
        this.selectionText = selectionText;
      }

      if (typeof clearSelectionText === 'string') {
        this.clearSelectionText = clearSelectionText;
      }
    },
    initializeColumns: function initializeColumns() {
      // take care of default sort on mount
      if (this.defaultSortBy) {
        this.handleDefaultSort();
      }
    }
  },
  created: function created() {
    this.childColumns = this.enableColumnGrouping ? this.getchildColumns() : this.columns;
  },
  mounted: function mounted() {
    if (this.perPage) {
      this.currentPerPage = this.perPage;
    }
  },


  components: {
    'vgt-pagination': __WEBPACK_IMPORTED_MODULE_10__VgtPagination_vue___default.a,
    'vgt-global-search': __WEBPACK_IMPORTED_MODULE_11__VgtGlobalSearch_vue___default.a,
    'vgt-header-row': __WEBPACK_IMPORTED_MODULE_13__VgtHeaderRow_vue___default.a,
    'vgt-table-header': __WEBPACK_IMPORTED_MODULE_12__VgtTableHeader_vue___default.a
  }
});

/***/ }),

/***/ 463:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'VgtFilterRow',
  props: ['lineNumbers', 'columns', 'typedColumns', 'globalSearchEnabled', 'selectable', 'mode'],
  watch: {
    columns: {
      handler: function handler() {
        this.populateInitialFilters();
      },

      deep: true
    }
  },
  data: function data() {
    return {
      columnFilters: {},
      timer: null
    };
  },

  computed: {
    // to create a filter row, we need to
    // make sure that there is atleast 1 column
    // that requires filtering
    hasFilterRow: function hasFilterRow() {
      if (this.mode === 'remote' || !this.globalSearchEnabled) {
        for (var i = 0; i < this.columns.length; i++) {
          var col = this.columns[i];
          if (col.filterOptions && col.filterOptions.enabled) {
            return true;
          }
        }
      }
      return false;
    }
  },
  methods: {
    reset: function reset() {
      var emitEvent = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      this.columnFilters = {};
      if (emitEvent) {
        this.$emit('filter-changed', this.columnFilters);
      }
    },
    isFilterable: function isFilterable(column) {
      return column.filterOptions && column.filterOptions.enabled;
    },
    isDropdown: function isDropdown(column) {
      return this.isFilterable(column) && column.filterOptions.filterDropdownItems && column.filterOptions.filterDropdownItems.length;
    },
    isDropdownObjects: function isDropdownObjects(column) {
      return this.isDropdown(column) && __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(column.filterOptions.filterDropdownItems[0]) === 'object';
    },
    isDropdownArray: function isDropdownArray(column) {
      return this.isDropdown(column) && __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(column.filterOptions.filterDropdownItems[0]) !== 'object';
    },


    // get column's defined placeholder or default one
    getPlaceholder: function getPlaceholder(column) {
      var placeholder = this.isFilterable(column) && column.filterOptions.placeholder || 'Filter ' + column.label;
      return placeholder;
    },
    updateFiltersOnEnter: function updateFiltersOnEnter(column, value) {
      if (this.timer) clearTimeout(this.timer);
      this.updateFiltersImmediately(column, value);
    },
    updateFiltersOnKeyup: function updateFiltersOnKeyup(column, value) {
      // if the trigger is enter, we don't filter on keyup
      if (column.filterOptions.trigger === 'enter') return;
      this.updateFilters(column, value);
    },


    // since vue doesn't detect property addition and deletion, we
    // need to create helper function to set property etc
    updateFilters: function updateFilters(column, value) {
      var _this = this;

      if (this.timer) clearTimeout(this.timer);
      this.timer = setTimeout(function () {
        _this.updateFiltersImmediately(column, value);
      }, 400);
    },
    updateFiltersImmediately: function updateFiltersImmediately(column, value) {
      this.$set(this.columnFilters, column.field, value);
      this.$emit('filter-changed', this.columnFilters);
    },
    populateInitialFilters: function populateInitialFilters() {
      for (var i = 0; i < this.columns.length; i++) {
        var col = this.columns[i];
        // lets see if there are initial
        // filters supplied by user
        if (this.isFilterable(col) && typeof col.filterOptions.filterValue !== 'undefined' && col.filterOptions.filterValue !== null) {
          this.updateFiltersImmediately(col, col.filterOptions.filterValue);
          this.$set(col.filterOptions, 'filterValue', undefined);
        }
      }
    }
  },
  mounted: function mounted() {
    // take care of initial filters
    this.populateInitialFilters();
  }
});

/***/ }),

/***/ 464:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'VgtGlobalSearch',
  props: ['value', 'searchEnabled', 'globalSearchPlaceholder'],
  data: function data() {
    return {
      globalSearchTerm: null
    };
  },

  computed: {
    showControlBar: function showControlBar() {
      if (this.searchEnabled) return true;
      if (this.$slots && this.$slots['internal-table-actions']) return true;
      return false;
    }
  },
  methods: {
    updateValue: function updateValue(value) {
      this.$emit('input', value);
      this.$emit('on-keyup', value);
    },
    entered: function entered(value) {
      this.$emit('on-enter', value);
    }
  }
});

/***/ }),

/***/ 465:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'VgtHeaderRow',
  props: {
    headerRow: {
      type: Object
    },
    columns: {
      type: Array
    },
    lineNumbers: {
      type: Boolean
    },
    selectable: {
      type: Boolean
    },
    collectFormatted: {
      type: Function
    },
    formattedRow: {
      type: Function
    },
    getClasses: {
      type: Function
    },
    fullColspan: {
      type: Number
    }
  },
  data: function data() {
    return {};
  },

  computed: {},
  methods: {},
  mounted: function mounted() {},

  components: {}
});

/***/ }),

/***/ 466:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_clonedeep__ = __webpack_require__(233);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_clonedeep___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_clonedeep__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VgtPaginationPageInfo_vue__ = __webpack_require__(778);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VgtPaginationPageInfo_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__VgtPaginationPageInfo_vue__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'VgtPagination',
  props: {
    styleClass: { default: 'table table-bordered' },
    total: { default: null },
    perPage: {},
    rtl: { default: false },
    customRowsPerPageDropdown: {
      default: function _default() {
        return [];
      }
    },
    paginateDropdownAllowAll: { default: true },
    mode: { default: 'records' },

    // text options
    nextText: { default: 'Next' },
    prevText: { default: 'Prev' },
    rowsPerPageText: { default: 'Rows per page:' },
    ofText: { default: 'of' },
    pageText: { default: 'page' },
    allText: { default: 'All' }
  },

  data: function data() {
    return {
      currentPage: 1,
      prevPage: 0,
      currentPerPage: 10,
      rowsPerPageOptions: [],
      defaultRowsPerPageDropdown: [10, 20, 30, 40, 50]
    };
  },

  watch: {
    perPage: function perPage() {
      this.handlePerPage();
      this.perPageChanged();
    },
    customRowsPerPageDropdown: function customRowsPerPageDropdown() {
      if (this.customRowsPerPageDropdown !== null && Array.isArray(this.customRowsPerPageDropdown) && this.customRowsPerPageDropdown.lenght !== 0) {
        this.rowsPerPageOptions = this.customRowsPerPageDropdown;
      }
    }
  },

  computed: {
    currentPerPageString: function currentPerPageString() {
      return this.currentPerPage === -1 ? 'All' : this.currentPerPage;
    },
    paginatedInfo: function paginatedInfo() {
      if (this.currentPerPage === -1) {
        return '1 - ' + this.total + ' ' + this.ofText + ' ' + this.total;
      }
      var first = (this.currentPage - 1) * this.currentPerPage + 1 ? (this.currentPage - 1) * this.currentPerPage + 1 : 1;

      if (first > this.total) {
        // this probably happened as a result of filtering
        first = 1;
        this.currentPage = 1;
        this.prevPage = 0;
      }

      var last = Math.min(this.total, this.currentPerPage * this.currentPage);
      return first + ' - ' + last + ' ' + this.ofText + ' ' + this.total;
    },
    nextIsPossible: function nextIsPossible() {
      return this.currentPerPage === -1 ? false : this.total > this.currentPerPage * this.currentPage;
    },
    prevIsPossible: function prevIsPossible() {
      return this.currentPage > 1;
    }
  },

  methods: {
    // optionSelected(option) {
    //   return this.currentPerPage === option;
    // },

    reset: function reset() {},
    changePage: function changePage(pageNumber) {
      if (pageNumber > 0 && this.total > this.currentPerPage * (pageNumber - 1)) {
        this.prevPage = this.currentPage;
        this.currentPage = pageNumber;
        this.pageChanged();
      }
    },
    nextPage: function nextPage() {
      if (this.currentPerPage === -1) return;
      if (this.nextIsPossible) {
        this.prevPage = this.currentPage;
        ++this.currentPage;
        this.pageChanged();
      }
    },
    previousPage: function previousPage() {
      if (this.currentPage > 1) {
        this.prevPage = this.currentPage;
        --this.currentPage;
        this.pageChanged();
      }
    },
    pageChanged: function pageChanged() {
      this.$emit('page-changed', {
        currentPage: this.currentPage,
        prevPage: this.prevPage
      });
    },
    perPageChanged: function perPageChanged(event) {
      if (event) {
        this.currentPerPage = parseInt(event.target.value, 10);
      }
      if (this.currentPerPage === -1) {
        // reset current page to 1
        this.currentPage = 1;
      }
      this.$emit('per-page-changed', { currentPerPage: this.currentPerPage });
    },
    getRowsPerPageDropdown: function getRowsPerPageDropdown() {
      return this.rowsPerPageOptions;
    },
    handlePerPage: function handlePerPage() {
      this.rowsPerPageOptions = __WEBPACK_IMPORTED_MODULE_0_lodash_clonedeep___default()(this.defaultRowsPerPageDropdown);
      if (this.perPage) {
        this.currentPerPage = this.perPage;
        // if perPage doesn't already exist, we add it
        var found = false;
        for (var i = 0; i < this.rowsPerPageOptions.length; i++) {
          if (this.rowsPerPageOptions[i] === this.perPage) {
            found = true;
          }
        }
        if (!found && this.perPage !== -1) this.rowsPerPageOptions.push(this.perPage);
      } else {
        // reset to default
        this.currentPerPage = 10;
      }

      if (this.customRowsPerPageDropdown !== null && Array.isArray(this.customRowsPerPageDropdown) && this.customRowsPerPageDropdown.length !== 0) {
        this.rowsPerPageOptions = this.customRowsPerPageDropdown;
      }
    }
  },

  mounted: function mounted() {
    this.handlePerPage();
  },


  components: {
    'pagination-page-info': __WEBPACK_IMPORTED_MODULE_1__VgtPaginationPageInfo_vue___default.a
  }
});

/***/ }),

/***/ 467:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_nan__ = __webpack_require__(472);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_nan___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_nan__);

//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'VgtPaginationPageInfo',
  props: {
    currentPerPage: {
      default: 10
    },
    currentPage: {
      default: 1
    },
    totalRecords: {
      default: 0
    },
    ofText: {
      default: 'of',
      type: String
    },
    pageText: {
      default: 'page',
      type: String
    }
  },
  data: function data() {
    return {};
  },

  computed: {
    pageInfo: function pageInfo() {
      return this.ofText + ' ' + this.lastPage;
    },
    lastPage: function lastPage() {
      return this.currentPerPage === -1 ? 1 : Math.ceil(this.totalRecords / this.currentPerPage);
    }
  },
  methods: {
    changePage: function changePage(event) {
      var value = parseInt(event.target.value, 10);

      //! invalid number
      if (__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_nan___default()(value) || value > this.lastPage || value < 1) {
        event.target.value = this.currentPage;
        return false;
      }

      //* valid number
      event.target.value = value;
      this.$emit('page-changed', value);
    }
  },
  mounted: function mounted() {},

  components: {}
});

/***/ }),

/***/ 468:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_assign__ = __webpack_require__(232);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VgtFilterRow_vue__ = __webpack_require__(774);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VgtFilterRow_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__VgtFilterRow_vue__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'VgtTableHeader',
  props: {
    enableColumnGrouping: {
      default: false,
      type: Boolean
    },
    lineNumbers: {
      default: false,
      type: Boolean
    },
    selectable: {
      default: false,
      type: Boolean
    },
    allSelected: {
      default: false,
      type: Boolean
    },
    allSelectedIndeterminate: {
      default: false,
      type: Boolean
    },
    columns: {
      type: Array
    },
    columnGroups: {
      type: Array
    },
    mode: {
      type: String
    },
    typedColumns: {},

    //* Sort related
    sortColumn: {
      type: Number
    },
    sortType: {
      type: String
    },

    // utility functions
    isSortableColumn: {
      type: Function
    },
    getClasses: {
      type: Function
    },

    //* search related
    searchEnabled: {
      type: Boolean
    },

    tableRef: {},

    paginated: {}
  },
  watch: {
    tableRef: {
      handler: function handler() {
        this.setColumnStyles();
      },

      immediate: true
    },
    paginated: {
      handler: function handler() {
        if (this.tableRef) {
          this.setColumnStyles();
        }
      },

      deep: true
    }
  },
  data: function data() {
    return {
      checkBoxThStyle: {},
      lineNumberThStyle: {},
      columnStyles: []
    };
  },

  computed: {},
  methods: {
    toggleSelectAll: function toggleSelectAll() {
      this.$emit('on-toggle-select-all');
    },
    sort: function sort(index) {
      this.$emit('on-sort-change', index);
    },
    getHeaderClasses: function getHeaderClasses(column, index) {
      var isSortable = this.isSortableColumn(index);
      var classes = __WEBPACK_IMPORTED_MODULE_0_lodash_assign___default()({}, this.getClasses(index, 'th'), {
        sorting: isSortable,
        'sorting-desc': isSortable && this.sortColumn === index && this.sortType === 'desc',
        'sorting-asc': isSortable && this.sortColumn === index && this.sortType === 'asc'
      });
      return classes;
    },
    filterRows: function filterRows(columnFilters) {
      this.$emit('filter-changed', columnFilters);
    },
    getWidthStyle: function getWidthStyle(dom) {
      var cellStyle = window.getComputedStyle(dom, null);
      return {
        width: cellStyle.width
      };
    },
    setColumnStyles: function setColumnStyles() {
      var _this = this;

      var colStyles = [];
      setTimeout(function () {
        for (var i = 0; i < _this.columns.length; i++) {
          if (_this.tableRef) {
            var skip = 0;
            if (_this.selectable) skip++;
            if (_this.lineNumbers) skip++;
            var cell = _this.tableRef.rows[0].cells[i + skip];
            colStyles.push(_this.getWidthStyle(cell));
          } else {
            colStyles.push({
              width: _this.columns[i].width ? _this.columns[i].width : 'auto'
            });
          }
        }
        _this.columnStyles = colStyles;
      }, 200);
    },
    getColumnStyle: function getColumnStyle(column, index) {
      var styleObject = {
        width: column.width ? column.width : 'auto'
      };
      //* if fixed header we need to get width from original table
      if (this.tableRef) {
        if (this.selectable) index++;
        if (this.lineNumbers) index++;

        var cell = this.tableRef.rows[0].cells[index];
        var cellStyle = window.getComputedStyle(cell, null);
        styleObject.width = cellStyle.width;
      }
      return styleObject;
    }
  },
  mounted: function mounted() {},

  components: {
    'vgt-filter-row': __WEBPACK_IMPORTED_MODULE_1__VgtFilterRow_vue___default.a
  }
});

/***/ }),

/***/ 469:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_multiselect__ = __webpack_require__(415);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_multiselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_multiselect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__auth__ = __webpack_require__(96);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  components: { MultiSelect: __WEBPACK_IMPORTED_MODULE_0_vue_multiselect___default.a },
  data: function data() {
    return {
      selectedLocation: '',
      optionLocations: ["FMOH Director DPRS", "PERM. Sec. FMOH", "HMH FMOH", "FMOH Public Health", "FMOH ICT", "FMOH DPRS MnE", "NPHCDA ED", "NERICC", "NPHCDA DPRS", "Admin"],
      email: '',
      pass: '',
      error: false
    };
  },

  methods: {
    login: function login() {
      var _this = this;

      // auth.login(this.email, this.pass, this.selectedLocation, loggedIn => {
      __WEBPACK_IMPORTED_MODULE_1__auth__["a" /* default */].login(this.selectedLocation, function (loggedIn) {
        // console.log(this.email, this.pass, this.selectedLocation)
        if (!loggedIn) {
          _this.error = true;
        } else {
          _this.$router.replace(_this.$route.query.redirect || '/');
          // window.location.reload();
        }
      });
    }
  }
});

/***/ }),

/***/ 470:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_firebase__ = __webpack_require__(692);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_firebase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_firebase__);
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'signUP',
  data: function data() {
    return {
      email: '',
      password: ''
    };
  },
  methods: {
    signUp: function signUp() {
      __WEBPACK_IMPORTED_MODULE_0_firebase___default.a.auth().createUserWithEmailAndPassword(this.email, this.password).then(function (user) {
        alert('Your account has been created');
      }, function (err) {
        alert('Oops... ' + err.message);
      });
    }
  }
});

/***/ }),

/***/ 662:
/***/ (function(module, exports) {

module.exports = {"modp1":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a63a3620ffffffffffffffff"},"modp2":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece65381ffffffffffffffff"},"modp5":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca237327ffffffffffffffff"},"modp14":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aacaa68ffffffffffffffff"},"modp15":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aaac42dad33170d04507a33a85521abdf1cba64ecfb850458dbef0a8aea71575d060c7db3970f85a6e1e4c7abf5ae8cdb0933d71e8c94e04a25619dcee3d2261ad2ee6bf12ffa06d98a0864d87602733ec86a64521f2b18177b200cbbe117577a615d6c770988c0bad946e208e24fa074e5ab3143db5bfce0fd108e4b82d120a93ad2caffffffffffffffff"},"modp16":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aaac42dad33170d04507a33a85521abdf1cba64ecfb850458dbef0a8aea71575d060c7db3970f85a6e1e4c7abf5ae8cdb0933d71e8c94e04a25619dcee3d2261ad2ee6bf12ffa06d98a0864d87602733ec86a64521f2b18177b200cbbe117577a615d6c770988c0bad946e208e24fa074e5ab3143db5bfce0fd108e4b82d120a92108011a723c12a787e6d788719a10bdba5b2699c327186af4e23c1a946834b6150bda2583e9ca2ad44ce8dbbbc2db04de8ef92e8efc141fbecaa6287c59474e6bc05d99b2964fa090c3a2233ba186515be7ed1f612970cee2d7afb81bdd762170481cd0069127d5b05aa993b4ea988d8fddc186ffb7dc90a6c08f4df435c934063199ffffffffffffffff"},"modp17":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aaac42dad33170d04507a33a85521abdf1cba64ecfb850458dbef0a8aea71575d060c7db3970f85a6e1e4c7abf5ae8cdb0933d71e8c94e04a25619dcee3d2261ad2ee6bf12ffa06d98a0864d87602733ec86a64521f2b18177b200cbbe117577a615d6c770988c0bad946e208e24fa074e5ab3143db5bfce0fd108e4b82d120a92108011a723c12a787e6d788719a10bdba5b2699c327186af4e23c1a946834b6150bda2583e9ca2ad44ce8dbbbc2db04de8ef92e8efc141fbecaa6287c59474e6bc05d99b2964fa090c3a2233ba186515be7ed1f612970cee2d7afb81bdd762170481cd0069127d5b05aa993b4ea988d8fddc186ffb7dc90a6c08f4df435c93402849236c3fab4d27c7026c1d4dcb2602646dec9751e763dba37bdf8ff9406ad9e530ee5db382f413001aeb06a53ed9027d831179727b0865a8918da3edbebcf9b14ed44ce6cbaced4bb1bdb7f1447e6cc254b332051512bd7af426fb8f401378cd2bf5983ca01c64b92ecf032ea15d1721d03f482d7ce6e74fef6d55e702f46980c82b5a84031900b1c9e59e7c97fbec7e8f323a97a7e36cc88be0f1d45b7ff585ac54bd407b22b4154aacc8f6d7ebf48e1d814cc5ed20f8037e0a79715eef29be32806a1d58bb7c5da76f550aa3d8a1fbff0eb19ccb1a313d55cda56c9ec2ef29632387fe8d76e3c0468043e8f663f4860ee12bf2d5b0b7474d6e694f91e6dcc4024ffffffffffffffff"},"modp18":{"gen":"02","prime":"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"}}

/***/ }),

/***/ 67:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_diacriticless__ = __webpack_require__(214);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_diacriticless___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_diacriticless__);


var escapeRegExp = function escapeRegExp(str) {
  return str.replace(/[\\^$*+?.()|[\]{}]/g, '\\$&');
};

/* harmony default export */ __webpack_exports__["a"] = ({
  format: function format(x) {
    return x;
  },
  filterPredicate: function filterPredicate(rowval, filter) {
    // take care of nulls
    if (typeof rowval === 'undefined' || rowval === null) {
      return false;
    }

    // row value
    var rowValue = __WEBPACK_IMPORTED_MODULE_0_diacriticless___default()(String(rowval).toLowerCase());

    // search term
    var searchTerm = __WEBPACK_IMPORTED_MODULE_0_diacriticless___default()(escapeRegExp(filter).toLowerCase());

    // comparison
    return rowValue.search(searchTerm) > -1;
  },
  compare: function compare(x, y) {
    function cook(d) {
      if (typeof d === 'undefined' || d === null) return '';
      return d.toLowerCase();
    }
    x = cook(x);
    y = cook(y);
    if (x < y) return -1;
    if (x > y) return 1;
    return 0;
  }
});

/***/ }),

/***/ 676:
/***/ (function(module, exports) {

module.exports = {"name":"elliptic","version":"6.4.0","description":"EC cryptography","main":"lib/elliptic.js","files":["lib"],"scripts":{"jscs":"jscs benchmarks/*.js lib/*.js lib/**/*.js lib/**/**/*.js test/index.js","jshint":"jscs benchmarks/*.js lib/*.js lib/**/*.js lib/**/**/*.js test/index.js","lint":"npm run jscs && npm run jshint","unit":"istanbul test _mocha --reporter=spec test/index.js","test":"npm run lint && npm run unit","version":"grunt dist && git add dist/"},"repository":{"type":"git","url":"git@github.com:indutny/elliptic"},"keywords":["EC","Elliptic","curve","Cryptography"],"author":"Fedor Indutny <fedor@indutny.com>","license":"MIT","bugs":{"url":"https://github.com/indutny/elliptic/issues"},"homepage":"https://github.com/indutny/elliptic","devDependencies":{"brfs":"^1.4.3","coveralls":"^2.11.3","grunt":"^0.4.5","grunt-browserify":"^5.0.0","grunt-cli":"^1.2.0","grunt-contrib-connect":"^1.0.0","grunt-contrib-copy":"^1.0.0","grunt-contrib-uglify":"^1.0.1","grunt-mocha-istanbul":"^3.0.1","grunt-saucelabs":"^8.6.2","istanbul":"^0.4.2","jscs":"^2.9.0","jshint":"^2.6.0","mocha":"^2.1.0"},"dependencies":{"bn.js":"^4.4.0","brorand":"^1.0.1","hash.js":"^1.0.0","hmac-drbg":"^1.0.0","inherits":"^2.0.1","minimalistic-assert":"^1.0.0","minimalistic-crypto-utils":"^1.0.0"}}

/***/ }),

/***/ 679:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 680:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 681:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 682:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 683:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 684:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 685:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 686:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 687:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 688:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 689:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 690:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 691:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 742:
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": 238,
	"./af.js": 238,
	"./ar": 245,
	"./ar-dz": 239,
	"./ar-dz.js": 239,
	"./ar-kw": 240,
	"./ar-kw.js": 240,
	"./ar-ly": 241,
	"./ar-ly.js": 241,
	"./ar-ma": 242,
	"./ar-ma.js": 242,
	"./ar-sa": 243,
	"./ar-sa.js": 243,
	"./ar-tn": 244,
	"./ar-tn.js": 244,
	"./ar.js": 245,
	"./az": 246,
	"./az.js": 246,
	"./be": 247,
	"./be.js": 247,
	"./bg": 248,
	"./bg.js": 248,
	"./bm": 249,
	"./bm.js": 249,
	"./bn": 250,
	"./bn.js": 250,
	"./bo": 251,
	"./bo.js": 251,
	"./br": 252,
	"./br.js": 252,
	"./bs": 253,
	"./bs.js": 253,
	"./ca": 254,
	"./ca.js": 254,
	"./cs": 255,
	"./cs.js": 255,
	"./cv": 256,
	"./cv.js": 256,
	"./cy": 257,
	"./cy.js": 257,
	"./da": 258,
	"./da.js": 258,
	"./de": 261,
	"./de-at": 259,
	"./de-at.js": 259,
	"./de-ch": 260,
	"./de-ch.js": 260,
	"./de.js": 261,
	"./dv": 262,
	"./dv.js": 262,
	"./el": 263,
	"./el.js": 263,
	"./en-au": 264,
	"./en-au.js": 264,
	"./en-ca": 265,
	"./en-ca.js": 265,
	"./en-gb": 266,
	"./en-gb.js": 266,
	"./en-ie": 267,
	"./en-ie.js": 267,
	"./en-il": 268,
	"./en-il.js": 268,
	"./en-in": 269,
	"./en-in.js": 269,
	"./en-nz": 270,
	"./en-nz.js": 270,
	"./en-sg": 271,
	"./en-sg.js": 271,
	"./eo": 272,
	"./eo.js": 272,
	"./es": 275,
	"./es-do": 273,
	"./es-do.js": 273,
	"./es-us": 274,
	"./es-us.js": 274,
	"./es.js": 275,
	"./et": 276,
	"./et.js": 276,
	"./eu": 277,
	"./eu.js": 277,
	"./fa": 278,
	"./fa.js": 278,
	"./fi": 279,
	"./fi.js": 279,
	"./fil": 280,
	"./fil.js": 280,
	"./fo": 281,
	"./fo.js": 281,
	"./fr": 284,
	"./fr-ca": 282,
	"./fr-ca.js": 282,
	"./fr-ch": 283,
	"./fr-ch.js": 283,
	"./fr.js": 284,
	"./fy": 285,
	"./fy.js": 285,
	"./ga": 286,
	"./ga.js": 286,
	"./gd": 287,
	"./gd.js": 287,
	"./gl": 288,
	"./gl.js": 288,
	"./gom-deva": 289,
	"./gom-deva.js": 289,
	"./gom-latn": 290,
	"./gom-latn.js": 290,
	"./gu": 291,
	"./gu.js": 291,
	"./he": 292,
	"./he.js": 292,
	"./hi": 293,
	"./hi.js": 293,
	"./hr": 294,
	"./hr.js": 294,
	"./hu": 295,
	"./hu.js": 295,
	"./hy-am": 296,
	"./hy-am.js": 296,
	"./id": 297,
	"./id.js": 297,
	"./is": 298,
	"./is.js": 298,
	"./it": 300,
	"./it-ch": 299,
	"./it-ch.js": 299,
	"./it.js": 300,
	"./ja": 301,
	"./ja.js": 301,
	"./jv": 302,
	"./jv.js": 302,
	"./ka": 303,
	"./ka.js": 303,
	"./kk": 304,
	"./kk.js": 304,
	"./km": 305,
	"./km.js": 305,
	"./kn": 306,
	"./kn.js": 306,
	"./ko": 307,
	"./ko.js": 307,
	"./ku": 308,
	"./ku.js": 308,
	"./ky": 309,
	"./ky.js": 309,
	"./lb": 310,
	"./lb.js": 310,
	"./lo": 311,
	"./lo.js": 311,
	"./lt": 312,
	"./lt.js": 312,
	"./lv": 313,
	"./lv.js": 313,
	"./me": 314,
	"./me.js": 314,
	"./mi": 315,
	"./mi.js": 315,
	"./mk": 316,
	"./mk.js": 316,
	"./ml": 317,
	"./ml.js": 317,
	"./mn": 318,
	"./mn.js": 318,
	"./mr": 319,
	"./mr.js": 319,
	"./ms": 321,
	"./ms-my": 320,
	"./ms-my.js": 320,
	"./ms.js": 321,
	"./mt": 322,
	"./mt.js": 322,
	"./my": 323,
	"./my.js": 323,
	"./nb": 324,
	"./nb.js": 324,
	"./ne": 325,
	"./ne.js": 325,
	"./nl": 327,
	"./nl-be": 326,
	"./nl-be.js": 326,
	"./nl.js": 327,
	"./nn": 328,
	"./nn.js": 328,
	"./oc-lnc": 329,
	"./oc-lnc.js": 329,
	"./pa-in": 330,
	"./pa-in.js": 330,
	"./pl": 331,
	"./pl.js": 331,
	"./pt": 333,
	"./pt-br": 332,
	"./pt-br.js": 332,
	"./pt.js": 333,
	"./ro": 334,
	"./ro.js": 334,
	"./ru": 335,
	"./ru.js": 335,
	"./sd": 336,
	"./sd.js": 336,
	"./se": 337,
	"./se.js": 337,
	"./si": 338,
	"./si.js": 338,
	"./sk": 339,
	"./sk.js": 339,
	"./sl": 340,
	"./sl.js": 340,
	"./sq": 341,
	"./sq.js": 341,
	"./sr": 343,
	"./sr-cyrl": 342,
	"./sr-cyrl.js": 342,
	"./sr.js": 343,
	"./ss": 344,
	"./ss.js": 344,
	"./sv": 345,
	"./sv.js": 345,
	"./sw": 346,
	"./sw.js": 346,
	"./ta": 347,
	"./ta.js": 347,
	"./te": 348,
	"./te.js": 348,
	"./tet": 349,
	"./tet.js": 349,
	"./tg": 350,
	"./tg.js": 350,
	"./th": 351,
	"./th.js": 351,
	"./tl-ph": 352,
	"./tl-ph.js": 352,
	"./tlh": 353,
	"./tlh.js": 353,
	"./tr": 354,
	"./tr.js": 354,
	"./tzl": 355,
	"./tzl.js": 355,
	"./tzm": 357,
	"./tzm-latn": 356,
	"./tzm-latn.js": 356,
	"./tzm.js": 357,
	"./ug-cn": 358,
	"./ug-cn.js": 358,
	"./uk": 359,
	"./uk.js": 359,
	"./ur": 360,
	"./ur.js": 360,
	"./uz": 362,
	"./uz-latn": 361,
	"./uz-latn.js": 361,
	"./uz.js": 362,
	"./vi": 363,
	"./vi.js": 363,
	"./x-pseudo": 364,
	"./x-pseudo.js": 364,
	"./yo": 365,
	"./yo.js": 365,
	"./zh-cn": 366,
	"./zh-cn.js": 366,
	"./zh-hk": 367,
	"./zh-hk.js": 367,
	"./zh-mo": 368,
	"./zh-mo.js": 368,
	"./zh-tw": 369,
	"./zh-tw.js": 369
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 742;

/***/ }),

/***/ 743:
/***/ (function(module, exports) {

module.exports = {"2.16.840.1.101.3.4.1.1":"aes-128-ecb","2.16.840.1.101.3.4.1.2":"aes-128-cbc","2.16.840.1.101.3.4.1.3":"aes-128-ofb","2.16.840.1.101.3.4.1.4":"aes-128-cfb","2.16.840.1.101.3.4.1.21":"aes-192-ecb","2.16.840.1.101.3.4.1.22":"aes-192-cbc","2.16.840.1.101.3.4.1.23":"aes-192-ofb","2.16.840.1.101.3.4.1.24":"aes-192-cfb","2.16.840.1.101.3.4.1.41":"aes-256-ecb","2.16.840.1.101.3.4.1.42":"aes-256-cbc","2.16.840.1.101.3.4.1.43":"aes-256-ofb","2.16.840.1.101.3.4.1.44":"aes-256-cfb"}

/***/ }),

/***/ 766:
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxOS40ODgiIGhlaWdodD0iMTcuODY0IiB2aWV3Qm94PSIwIDAgMTkuNDg4IDE3Ljg2NCI+PGRlZnM+PHN0eWxlPi5he2ZpbGw6IzVhNWE1YTt9PC9zdHlsZT48L2RlZnM+PHBhdGggY2xhc3M9ImEiIGQ9Ik0xNy43MzYsMjguNTI5YS40MS40MSwwLDAsMC0uNDQ2LjA4OGwtMi41MjQsMi41MDZhMS4yMjQsMS4yMjQsMCwwLDEtLjYyNi4zMzNsLTIuMDQ0LjQwNmExLjIyNiwxLjIyNiwwLDAsMS0xLjEwOC0uMzMzLDEuMjExLDEuMjExLDAsMCwxLS4zMzUtMS4xbC4zNjEtMS43OTFINC41YS40MDYuNDA2LDAsMSwxLDAtLjgxMkgxMS4zNmMuMDE0LS4wMTYuMDIyLS4wMzUuMDM4LS4wNUwxMi45ODIsMjYuMkg0LjVhLjQwNi40MDYsMCwxLDEsMC0uODEyaDguOTk0YS40LjQsMCwwLDEsLjIzLjA3OWwyLjY1My0yLjYzNGEyLjM2NCwyLjM2NCwwLDAsMSwuOC0uNTIuNDA1LjQwNSwwLDAsMCwuMDczLS43MTYsMS42NDEsMS42NDEsMCwwLDAtLjktLjI2OEgxLjYzNUExLjYzMiwxLjYzMiwwLDAsMCwwLDIyLjk1NFYzOC43ODhhLjQwOS40MDksMCwwLDAsLjcuMjg3bDMuOTY5LTMuOTQxSDE2LjM1M2ExLjYzMiwxLjYzMiwwLDAsMCwxLjYzNS0xLjYyNFYyOC45QS40MDYuNDA2LDAsMCwwLDE3LjczNiwyOC41MjlaTTkuNCwzMS4wNzRINC41YS40MDYuNDA2LDAsMSwxLDAtLjgxMkg5LjRhLjQwNi40MDYsMCwxLDEsMCwuODEyWiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMCAtMjEuMzMpIi8+PHBhdGggY2xhc3M9ImEiIGQ9Ik0zMDQuNzI3LDY0YTEuNDQ0LDEuNDQ0LDAsMCwwLTEuMDE1LjQybC00LjU2Myw0LjU2M2EuMzc0LjM3NCwwLDAsMC0uMS4xOTFsLS4zNzUsMS44NzVhLjM3NS4zNzUsMCwwLDAsLjM2OC40NDguMzgzLjM4MywwLDAsMCwuMDczLS4wMDdsMS44NzQtLjM3NWEuMzczLjM3MywwLDAsMCwuMTkyLS4xbDQuNTY0LTQuNTYzaDBBMS40MzUsMS40MzUsMCwwLDAsMzA0LjcyNyw2NFptLS41OTUsMy0uOTctLjk3LjUzLS41My45Ny45N1oiIHRyYW5zZm9ybT0idHJhbnNsYXRlKC0yODYuNjc0IC02Mi41KSIvPjwvc3ZnPg=="

/***/ }),

/***/ 767:
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyMi40MjkiIGhlaWdodD0iMTQuOTUzIiB2aWV3Qm94PSIwIDAgMjIuNDI5IDE0Ljk1MyI+PGRlZnM+PHN0eWxlPi5he2ZpbGw6IzVhNWE1YTt9LmJ7ZmlsbDojZmZmO3N0cm9rZTojZmZmO308L3N0eWxlPjwvZGVmcz48cGF0aCBjbGFzcz0iYSIgZD0iTTE4LjA4NCw5LjY0NUE3LDcsMCwwLDAsNSw3Ljc3NmE1LjYwNSw1LjYwNSwwLDAsMCwuNjA3LDExLjE3N0gxNy43NTdhNC42NTksNC42NTksMCwwLDAsLjMyNy05LjMwOFoiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDAgLTQpIi8+PHBhdGggY2xhc3M9ImIiIGQ9Ik0xOS4wNzIsMTUuMTA5YTMuMTYzLDMuMTYzLDAsMCwwLTQuMjM0LTEuNDQ3Yy4xNjguMzQzLjM2OS43ODMuMzY5Ljc4M2EyLjMxNCwyLjMxNCwwLDAsMSwyLjcyOCwzLjYzOGwtLjAzMS4wMzItLjI1Mi0uNTE0LS40NDYsMS4zLDEuMy40NDUtLjIxOC0uNDQ1LjAzMS0uMDI3QTMuMTY2LDMuMTY2LDAsMCwwLDE5LjA3MiwxNS4xMDlaIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtNC4xNzUgLTkuNTc0KSIvPjxwYXRoIGNsYXNzPSJiIiBkPSJNMTEuMzQ1LDE4LjYzYTIuMzA5LDIuMzA5LDAsMCwxLC4zNjctMi41NzZsLjAzMS0uMDMzLjI1MS41MTIuNDQ1LTEuMy0xLjMtLjQ0Ny4yMTkuNDQ2LS4wMzIuMDI1YTMuMTY1LDMuMTY1LDAsMCwwLDMuNDg0LDUuMjE4Yy0uMTY5LS4zNDItLjM2OS0uNzg0LS4zNjktLjc4NEEyLjMxMiwyLjMxMiwwLDAsMSwxMS4zNDUsMTguNjNaIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtMy4xMDMgLTguODI4KSIvPjwvc3ZnPg=="

/***/ }),

/***/ 768:
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),

/***/ 773:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(683)
}
var Component = __webpack_require__(15)(
  /* script */
  __webpack_require__(462),
  /* template */
  __webpack_require__(786),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 774:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(681)
}
var Component = __webpack_require__(15)(
  /* script */
  __webpack_require__(463),
  /* template */
  __webpack_require__(784),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-11e01574",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 775:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(684)
}
var Component = __webpack_require__(15)(
  /* script */
  __webpack_require__(464),
  /* template */
  __webpack_require__(787),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 776:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(680)
}
var Component = __webpack_require__(15)(
  /* script */
  __webpack_require__(465),
  /* template */
  __webpack_require__(783),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 777:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(679)
}
var Component = __webpack_require__(15)(
  /* script */
  __webpack_require__(466),
  /* template */
  __webpack_require__(782),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 778:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(690)
}
var Component = __webpack_require__(15)(
  /* script */
  __webpack_require__(467),
  /* template */
  __webpack_require__(790),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-6e7e147a",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 779:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(689)
}
var Component = __webpack_require__(15)(
  /* script */
  __webpack_require__(468),
  /* template */
  __webpack_require__(789),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-6e70da7f",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 780:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(682)
}
var Component = __webpack_require__(15)(
  /* script */
  __webpack_require__(469),
  /* template */
  __webpack_require__(785),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 781:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(691)
}
var Component = __webpack_require__(15)(
  /* script */
  __webpack_require__(470),
  /* template */
  __webpack_require__(791),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-f63c3a14",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 782:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "vgt-wrap__footer vgt-clearfix"
  }, [_c('div', {
    staticClass: "footer__row-count vgt-pull-left"
  }, [_c('span', {
    staticClass: "footer__row-count__label"
  }, [_vm._v(_vm._s(_vm.rowsPerPageText))]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.currentPerPage),
      expression: "currentPerPage"
    }],
    staticClass: "footer__row-count__select",
    attrs: {
      "autocomplete": "off",
      "name": "perPageSelect"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.currentPerPage = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.perPageChanged]
    }
  }, [_vm._l((_vm.getRowsPerPageDropdown()), function(option, idx) {
    return _c('option', {
      key: 'rows-dropdown-option-' + idx,
      domProps: {
        "value": option
      }
    }, [_vm._v("\n        " + _vm._s(option) + "\n      ")])
  }), _vm._v(" "), (_vm.paginateDropdownAllowAll) ? _c('option', {
    attrs: {
      "value": "-1"
    }
  }, [_vm._v(_vm._s(_vm.allText))]) : _vm._e()], 2)]), _vm._v(" "), _c('div', {
    staticClass: "footer__navigation vgt-pull-right"
  }, [_c('a', {
    staticClass: "footer__navigation__page-btn",
    class: {
      disabled: !_vm.prevIsPossible
    },
    attrs: {
      "href": "javascript:undefined",
      "tabindex": "0"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        $event.stopPropagation();
        return _vm.previousPage($event)
      }
    }
  }, [_c('span', {
    staticClass: "chevron",
    class: {
      'left': !_vm.rtl, 'right': _vm.rtl
    }
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.prevText))])]), _vm._v(" "), (_vm.mode === 'pages') ? _c('pagination-page-info', {
    attrs: {
      "totalRecords": _vm.total,
      "currentPerPage": _vm.currentPerPage,
      "currentPage": _vm.currentPage,
      "ofText": _vm.ofText,
      "pageText": _vm.pageText
    },
    on: {
      "page-changed": _vm.changePage
    }
  }) : _c('div', {
    staticClass: "footer__navigation__info"
  }, [_vm._v(_vm._s(_vm.paginatedInfo))]), _vm._v(" "), _c('a', {
    staticClass: "footer__navigation__page-btn",
    class: {
      disabled: !_vm.nextIsPossible
    },
    attrs: {
      "href": "javascript:undefined",
      "tabindex": "0"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        $event.stopPropagation();
        return _vm.nextPage($event)
      }
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.nextText))]), _vm._v(" "), _c('span', {
    staticClass: "chevron",
    class: {
      'right': !_vm.rtl, 'left': _vm.rtl
    }
  })])], 1)])
},staticRenderFns: []}

/***/ }),

/***/ 783:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [(_vm.headerRow.mode === 'span') ? _c('th', {
    staticClass: "vgt-left-align vgt-row-header",
    attrs: {
      "colspan": _vm.fullColspan
    }
  }, [_vm._t("table-header-row", [(_vm.headerRow.html) ? _c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.headerRow.label)
    }
  }) : _c('span', [_vm._v("\n        " + _vm._s(_vm.headerRow.label) + "\n      ")])], {
    row: _vm.headerRow
  })], 2) : _vm._e(), _vm._v(" "), (_vm.headerRow.mode !== 'span' && _vm.lineNumbers) ? _c('th', {
    staticClass: "vgt-row-header"
  }) : _vm._e(), _vm._v(" "), (_vm.headerRow.mode !== 'span' && _vm.selectable) ? _c('th', {
    staticClass: "vgt-row-header"
  }) : _vm._e(), _vm._v(" "), _vm._l((_vm.columns), function(column, i) {
    return (_vm.headerRow.mode !== 'span') ? _c('th', {
      key: i,
      staticClass: "vgt-row-header",
      class: _vm.getClasses(i, 'td')
    }, [_vm._t("table-header-row", [(!column.html) ? _c('span', [_vm._v("\n        " + _vm._s(_vm.collectFormatted(_vm.headerRow, column, true)) + "\n      ")]) : _vm._e(), _vm._v(" "), (column.html) ? _c('span', {
      domProps: {
        "innerHTML": _vm._s(_vm.collectFormatted(_vm.headerRow, column, true))
      }
    }) : _vm._e()], {
      row: _vm.headerRow,
      column: column,
      formattedRow: _vm.formattedRow(_vm.headerRow, true)
    })], 2) : _vm._e()
  })], 2)
},staticRenderFns: []}

/***/ }),

/***/ 784:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.hasFilterRow) ? _c('tr', [(_vm.lineNumbers) ? _c('th') : _vm._e(), _vm._v(" "), (_vm.selectable) ? _c('th') : _vm._e(), _vm._v(" "), _vm._l((_vm.columns), function(column, index) {
    return (!column.hidden) ? _c('th', {
      key: index,
      staticClass: "filter-th"
    }, [(_vm.isFilterable(column)) ? _c('div', [(!_vm.isDropdown(column)) ? _c('input', {
      staticClass: "vgt-input",
      attrs: {
        "type": "text",
        "placeholder": _vm.getPlaceholder(column)
      },
      domProps: {
        "value": _vm.columnFilters[column.field]
      },
      on: {
        "keyup": function($event) {
          if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
          _vm.updateFiltersOnEnter(column, $event.target.value)
        },
        "input": function($event) {
          _vm.updateFiltersOnKeyup(column, $event.target.value)
        }
      }
    }) : _vm._e(), _vm._v(" "), (_vm.isDropdownArray(column)) ? _c('select', {
      staticClass: "vgt-select",
      domProps: {
        "value": _vm.columnFilters[column.field]
      },
      on: {
        "input": function($event) {
          _vm.updateFilters(column, $event.target.value)
        }
      }
    }, [_c('option', {
      key: "-1",
      attrs: {
        "value": ""
      }
    }, [_vm._v(_vm._s(_vm.getPlaceholder(column)))]), _vm._v(" "), _vm._l((column.filterOptions.filterDropdownItems), function(option, i) {
      return _c('option', {
        key: i,
        domProps: {
          "value": option
        }
      }, [_vm._v("\n            " + _vm._s(option) + "\n          ")])
    })], 2) : _vm._e(), _vm._v(" "), (_vm.isDropdownObjects(column)) ? _c('select', {
      staticClass: "vgt-select",
      domProps: {
        "value": _vm.columnFilters[column.field]
      },
      on: {
        "input": function($event) {
          _vm.updateFilters(column, $event.target.value, true)
        }
      }
    }, [_c('option', {
      key: "-1",
      attrs: {
        "value": ""
      }
    }, [_vm._v(_vm._s(_vm.getPlaceholder(column)))]), _vm._v(" "), _vm._l((column.filterOptions.filterDropdownItems), function(option, i) {
      return _c('option', {
        key: i,
        domProps: {
          "value": option.value
        }
      }, [_vm._v(_vm._s(option.text))])
    })], 2) : _vm._e()]) : _vm._e()]) : _vm._e()
  })], 2) : _vm._e()
},staticRenderFns: []}

/***/ }),

/***/ 785:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container-fluid"
  }, [_c('div', {
    staticClass: "row form",
    staticStyle: {
      "margin-top": "5%"
    }
  }, [_c('h1', {
    staticClass: "text-xs-center",
    staticStyle: {
      "font-weight": "bold"
    }
  }, [_vm._v("\n      Welcome to the Nigeria Federal Ministry of Health Dashboards\n    ")]), _vm._v(" "), (_vm.$route.query.redirect) ? _c('p', {
    staticClass: "text-center"
  }, [_c('small', {
    staticStyle: {
      "color": "teal"
    }
  }, [_vm._v("Login first to view a dashboard for your location.")])]) : _vm._e(), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('h2', {
    staticClass: "text-center"
  }, [_vm._v("Login")]), _vm._v(" "), _c('div', {
    staticClass: "text-center"
  }, [_vm._m(1), _vm._v(" "), _c('p'), _vm._v(" "), _c('form', {
    staticClass: "form-horizontal",
    attrs: {
      "xs6": "",
      "autocomplete": "off"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.login($event)
      }
    }
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_c('multi-select', {
    attrs: {
      "options": _vm.optionLocations,
      "hide-selected": true,
      "searchable": true,
      "allow-empty": true,
      "show-labels": false,
      "placeholder": "Select location"
    },
    model: {
      value: (_vm.selectedLocation),
      callback: function($$v) {
        _vm.selectedLocation = $$v
      },
      expression: "selectedLocation"
    }
  })], 1), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.error) ? _c('p', {
    staticStyle: {
      "border-color": "gray"
    }
  }, [_c('label', {
    staticClass: "red--text"
  }, [_vm._v("Incorrect login details.")])]) : _vm._e(), _vm._v(" "), _c('v-btn', {
    attrs: {
      "type": "submit",
      "dark": "",
      "color": "green"
    }
  }, [_vm._v("Login")])], 1)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('img', {
    staticClass: "img-center img-circle img-reponsive",
    staticStyle: {
      "display": "block",
      "margin": "0 auto"
    },
    attrs: {
      "src": "static/img/login_logo.png",
      "alt": "Coat Of Arms"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', [_c('small', [_vm._v("choose a location")])])
}]}

/***/ }),

/***/ 786:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "vgt-wrap",
    class: {
      'rtl': _vm.rtl,
      'nocturnal': _vm.theme === 'nocturnal',
        'black-rhino': _vm.theme === 'black-rhino',
    }
  }, [(_vm.isTableLoading) ? _c('div', {
    staticClass: "vgt-loading vgt-center-align"
  }, [_vm._t("loadingContent", [_c('span', {
    staticClass: "vgt-loading__content"
  }, [_vm._v("\n        Loading...\n      ")])])], 2) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "vgt-inner-wrap",
    class: {
      'is-loading': _vm.isTableLoading
    }
  }, [(_vm.paginate && _vm.paginateOnTop) ? _vm._t("pagination-top", [_c('vgt-pagination', {
    ref: "paginationTop",
    attrs: {
      "perPage": _vm.perPage,
      "rtl": _vm.rtl,
      "total": _vm.totalRows || _vm.totalRowCount,
      "mode": _vm.paginationMode,
      "nextText": _vm.nextText,
      "prevText": _vm.prevText,
      "rowsPerPageText": _vm.rowsPerPageText,
      "customRowsPerPageDropdown": _vm.customRowsPerPageDropdown,
      "paginateDropdownAllowAll": _vm.paginateDropdownAllowAll,
      "ofText": _vm.ofText,
      "pageText": _vm.pageText,
      "allText": _vm.allText
    },
    on: {
      "page-changed": _vm.pageChanged,
      "per-page-changed": _vm.perPageChanged
    }
  })], {
    pageChanged: _vm.pageChanged,
    perPageChanged: _vm.perPageChanged,
    total: _vm.totalRows || _vm.totalRowCount
  }) : _vm._e(), _vm._v(" "), _c('vgt-global-search', {
    attrs: {
      "search-enabled": _vm.searchEnabled && _vm.externalSearchQuery == null,
      "global-search-placeholder": _vm.searchPlaceholder
    },
    on: {
      "on-keyup": _vm.searchTableOnKeyUp,
      "on-enter": _vm.searchTableOnEnter
    },
    model: {
      value: (_vm.globalSearchTerm),
      callback: function($$v) {
        _vm.globalSearchTerm = $$v
      },
      expression: "globalSearchTerm"
    }
  }, [_c('template', {
    slot: "internal-table-actions"
  }, [_vm._t("table-actions")], 2)], 2), _vm._v(" "), (_vm.selectedRowCount) ? _c('div', {
    staticClass: "vgt-selection-info-row clearfix",
    class: _vm.selectionInfoClass
  }, [_vm._v("\n      " + _vm._s(_vm.selectionInfo) + "\n      "), _c('a', {
    attrs: {
      "href": ""
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.unselectAllInternal(true)
      }
    }
  }, [_vm._v("\n        " + _vm._s(_vm.clearSelectionText) + "\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "vgt-selection-info-row__actions vgt-pull-right"
  }, [_vm._t("selected-row-actions")], 2)]) : _vm._e(), _vm._v(" "), (_vm.fixedHeader) ? _c('table', {
    staticClass: "vgt-fixed-header",
    class: _vm.tableStyleClasses
  }, [_c("vgt-table-header", {
    tag: "thead",
    attrs: {
      "columns": _vm.$props.enableColumnGrouping ? _vm.getchildColumns() : _vm.columns,
      "enableColumnGrouping": _vm.$props.enableColumnGrouping,
      "columnGroups": _vm.getColumnGroups(),
      "line-numbers": _vm.lineNumbers,
      "selectable": _vm.selectable,
      "all-selected": _vm.allSelected,
      "all-selected-indeterminate": _vm.allSelectedIndeterminate,
      "mode": _vm.mode,
      "typed-columns": _vm.typedColumns,
      "sort-column": _vm.sortColumn,
      "sort-type": _vm.sortType,
      "isSortableColumn": _vm.isSortableColumn,
      "getClasses": _vm.getClasses,
      "searchEnabled": _vm.searchEnabled,
      "paginated": _vm.paginated,
      "table-ref": _vm.$refs.table
    },
    on: {
      "on-toggle-select-all": _vm.toggleSelectAll,
      "on-sort-change": _vm.sort,
      "filter-changed": _vm.filterRows
    },
    scopedSlots: _vm._u([{
      key: "table-column",
      fn: function(props) {
        return [_vm._t("table-column", [_c('span', [_vm._v(_vm._s(props.column.label))])], {
          column: props.column
        })]
      }
    }])
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    class: {
      'vgt-responsive': _vm.responsive
    },
    style: (_vm.wrapperStyles)
  }, [_c('table', {
    ref: "table",
    class: _vm.tableStyleClasses
  }, [_c("vgt-table-header", {
    tag: "thead",
    attrs: {
      "columnGroups": _vm.getColumnGroups(),
      "columns": _vm.$props.enableColumnGrouping ? _vm.getchildColumns() : _vm.columns,
      "enableColumnGrouping": _vm.$props.enableColumnGrouping,
      "line-numbers": _vm.lineNumbers,
      "selectable": _vm.selectable,
      "all-selected": _vm.allSelected,
      "all-selected-indeterminate": _vm.allSelectedIndeterminate,
      "mode": _vm.mode,
      "typed-columns": _vm.typedColumns,
      "sort-column": _vm.sortColumn,
      "sort-type": _vm.sortType,
      "isSortableColumn": _vm.isSortableColumn,
      "getClasses": _vm.getClasses,
      "searchEnabled": _vm.searchEnabled
    },
    on: {
      "on-toggle-select-all": _vm.toggleSelectAll,
      "on-sort-change": _vm.sort,
      "filter-changed": _vm.filterRows
    },
    scopedSlots: _vm._u([{
      key: "table-column",
      fn: function(props) {
        return [_vm._t("table-column", [_c('span', [_vm._v(_vm._s(props.column.label))])], {
          column: props.column
        })]
      }
    }])
  }), _vm._v(" "), _vm._l((_vm.paginated), function(headerRow, index) {
    return _c('tbody', {
      key: index
    }, [(_vm.groupHeaderOnTop) ? _c('vgt-header-row', {
      attrs: {
        "header-row": headerRow,
        "columns": _vm.columns,
        "line-numbers": _vm.lineNumbers,
        "selectable": _vm.selectable,
        "collect-formatted": _vm.collectFormatted,
        "formatted-row": _vm.formattedRow,
        "get-classes": _vm.getClasses,
        "full-colspan": _vm.fullColspan
      },
      scopedSlots: _vm._u([{
        key: "table-header-row",
        fn: function(props) {
          return _vm.hasHeaderRowTemplate ? [_vm._t("table-header-row", null, {
            column: props.column,
            formattedRow: props.formattedRow,
            row: props.row
          })] : undefined
        }
      }])
    }) : _vm._e(), _vm._v(" "), _vm._l((headerRow.children), function(row, index) {
      return _c('tr', {
        key: row.originalIndex,
        class: _vm.getRowStyleClass(row),
        on: {
          "mouseenter": function($event) {
            _vm.onMouseenter(row, index)
          },
          "mouseleave": function($event) {
            _vm.onMouseleave(row, index)
          },
          "dblclick": function($event) {
            _vm.onRowDoubleClicked(row, index, $event)
          },
          "click": function($event) {
            _vm.onRowClicked(row, index, $event)
          }
        }
      }, [(_vm.lineNumbers) ? _c('th', {
        staticClass: "line-numbers"
      }, [_vm._v("\n              " + _vm._s(_vm.getCurrentIndex(index)) + "\n            ")]) : _vm._e(), _vm._v(" "), (_vm.selectable) ? _c('th', {
        staticClass: "vgt-checkbox-col",
        on: {
          "click": function($event) {
            $event.preventDefault();
            $event.stopPropagation();
            _vm.onCheckboxClicked(row, index, $event)
          }
        }
      }, [_c('input', {
        attrs: {
          "type": "checkbox"
        },
        domProps: {
          "checked": row.vgtSelected
        }
      })]) : _vm._e(), _vm._v(" "), _vm._l((_vm.childColumns), function(column, i) {
        return (!column.hidden && column.field) ? _c('td', {
          key: i,
          class: _vm.getClasses(i, 'td'),
          on: {
            "click": function($event) {
              _vm.onCellClicked(row, column, index, $event)
            }
          }
        }, [_vm._t("table-row", [(!column.html) ? _c('span', [_vm._v("\n                  " + _vm._s(_vm.collectFormatted(row, column)) + "\n                ")]) : _vm._e(), _vm._v(" "), (column.html) ? _c('span', {
          domProps: {
            "innerHTML": _vm._s(_vm.collect(row, column.field))
          }
        }) : _vm._e()], {
          row: row,
          column: column,
          formattedRow: _vm.formattedRow(row),
          index: index
        })], 2) : _vm._e()
      })], 2)
    }), _vm._v(" "), (_vm.groupHeaderOnBottom) ? _c('vgt-header-row', {
      attrs: {
        "header-row": headerRow,
        "columns": _vm.columns,
        "line-numbers": _vm.lineNumbers,
        "selectable": _vm.selectable,
        "collect-formatted": _vm.collectFormatted,
        "formatted-row": _vm.formattedRow,
        "get-classes": _vm.getClasses,
        "full-colspan": _vm.fullColspan
      },
      scopedSlots: _vm._u([{
        key: "table-header-row",
        fn: function(props) {
          return _vm.hasHeaderRowTemplate ? [_vm._t("table-header-row", null, {
            column: props.column,
            formattedRow: props.formattedRow,
            row: props.row
          })] : undefined
        }
      }])
    }) : _vm._e()], 2)
  }), _vm._v(" "), (_vm.showEmptySlot) ? _c('tbody', [_c('tr', [_c('td', {
    attrs: {
      "colspan": _vm.fullColspan
    }
  }, [_vm._t("emptystate", [_c('div', {
    staticClass: "vgt-center-align vgt-text-disabled"
  }, [_vm._v("\n                  No data for table\n                ")])])], 2)])]) : _vm._e()], 2)]), _vm._v(" "), (_vm.paginate && _vm.paginateOnBottom) ? _vm._t("pagination-bottom", [_c('vgt-pagination', {
    ref: "paginationBottom",
    attrs: {
      "perPage": _vm.perPage,
      "rtl": _vm.rtl,
      "total": _vm.totalRows || _vm.totalRowCount,
      "mode": _vm.paginationMode,
      "nextText": _vm.nextText,
      "prevText": _vm.prevText,
      "rowsPerPageText": _vm.rowsPerPageText,
      "customRowsPerPageDropdown": _vm.customRowsPerPageDropdown,
      "paginateDropdownAllowAll": _vm.paginateDropdownAllowAll,
      "ofText": _vm.ofText,
      "pageText": _vm.pageText,
      "allText": _vm.allText
    },
    on: {
      "page-changed": _vm.pageChanged,
      "per-page-changed": _vm.perPageChanged
    }
  })], {
    pageChanged: _vm.pageChanged,
    perPageChanged: _vm.perPageChanged,
    total: _vm.totalRows || _vm.totalRowCount
  }) : _vm._e()], 2)])
},staticRenderFns: []}

/***/ }),

/***/ 787:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.showControlBar) ? _c('div', {
    staticClass: "vgt-global-search vgt-clearfix"
  }, [_c('div', {
    staticClass: "vgt-global-search__input vgt-pull-left"
  }, [(_vm.searchEnabled) ? _c('span', {
    staticClass: "input__icon"
  }, [_c('div', {
    staticClass: "magnifying-glass"
  })]) : _vm._e(), _vm._v(" "), (_vm.searchEnabled) ? _c('input', {
    staticClass: "vgt-input vgt-pull-left",
    attrs: {
      "type": "text",
      "placeholder": _vm.globalSearchPlaceholder
    },
    domProps: {
      "value": _vm.value
    },
    on: {
      "input": function($event) {
        _vm.updateValue($event.target.value)
      },
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        _vm.entered($event.target.value)
      }
    }
  }) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "vgt-global-search__actions vgt-pull-right"
  }, [_vm._t("internal-table-actions")], 2)]) : _vm._e()
},staticRenderFns: []}

/***/ }),

/***/ 788:
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-app', {
    attrs: {
      "id": "inspire"
    }
  }, [_c('h4', {
    staticClass: "info-header"
  }, [_vm._v("\n  You are viewing an older version of MSDAT.\n  "), _c('span', [_c('a', {
    staticClass: "info-header-link",
    attrs: {
      "href": "https://msdat.fmohconnect.gov.ng/dashboard/Health_Outcomes_and_Service_Coverage",
      "target": "_blank",
      "rel": "noopener noreferrer"
    }
  }, [_vm._v("Click here to move to new version.")])])]), _vm._v(" "), _c('ul', {
    staticClass: "nav nav-tabs small toptab",
    staticStyle: {
      "background-color": "rgb(39, 81, 80)",
      "border": "0px"
    },
    attrs: {
      "id": "toptab",
      "role": "tablist"
    }
  }, [_c('li', {
    staticClass: "nav-item"
  }, [_c('router-link', {
    class: [_vm.currentPage.includes('state_profile') ? _vm.activeClass : ''],
    attrs: {
      "to": "/state_profile"
    }
  }, [_vm._v("State Profiles")])], 1), _vm._v(" "), _c('li', {
    staticClass: "nav-item dropdown"
  }, [_c('a', {
    staticClass: "dropdown-toggle",
    class: [_vm.currentPage.includes('nhmis_analysis') ? _vm.activeClass : ''],
    attrs: {
      "type": "button",
      "data-toggle": "dropdown",
      "data-hover": "dropdown"
    }
  }, [_vm._v("NHMIS Analysis "), _c('span', {
    staticClass: "caret"
  })]), _vm._v(" "), _c('ul', {
    staticClass: "dropdown-menu "
  }, [_c('li', {
    staticClass: "nav-item"
  }, [_c('a', {
    attrs: {
      "href": "https://msdat.old.fmohconnect.gov.ng/covid19_health_service_uptake/index.html",
      "target": "blank"
    }
  }, [_vm._v("Health Service Uptake")])]), _vm._v(" "), _c('li', {
    staticClass: "nav-item"
  }, [_c('router-link', {
    attrs: {
      "to": "/nhmis_analysis"
    }
  }, [_vm._v("Routine NHMIS Analysis")])], 1), _vm._v(" "), _c('li', {
    staticClass: "nav-item"
  }, [_c('a', {
    attrs: {
      "href": "http://monthly-nhmis-analysis.fmohconnect.gov.ng/",
      "target": "blank"
    }
  }, [_vm._v("NHMIS Insights")])])])]), _vm._v(" "), _c('li', {
    staticClass: "nav-item"
  }, [_c('router-link', {
    class: [_vm.currentPage.includes('central_analytics') ? _vm.activeClass : ''],
    attrs: {
      "to": "/central_analytics"
    }
  }, [_vm._v("MSDAT Platform")])], 1)]), _vm._v(" "), _c('v-toolbar', {
    staticStyle: {
      "height": "52px",
      "margin-top": "-5px padding: 5px 0",
      "border": "0px solid green",
      "box-shadow": "0 5px 5px -5px #333"
    },
    attrs: {
      "color": "green",
      "dark": "",
      "app": ""
    }
  }, [_c('img', {
    staticClass: "img-responsive float-left pr-2",
    staticStyle: {
      "border-right": "1px solid #EEEEEE"
    },
    attrs: {
      "id": "logo",
      "src": "static/img/fmoh_logo.png",
      "width": "150px",
      "alt": "Logo"
    },
    on: {
      "click": function($event) {
        _vm.goto('http://health.gov.ng')
      }
    }
  }), _vm._v(" "), _c('v-menu', {
    attrs: {
      "nudge-width": 90
    }
  }, [_c('v-toolbar-title', {
    staticClass: "ml-0",
    attrs: {
      "slot": "activator"
    },
    slot: "activator"
  }, [(this.$route.path === '/state_profile') ? _c('p', {
    staticClass: "navheader float-left pl-1 ml-2"
  }, [_vm._v("MSDAT State Health Profiles")]) : _c('p', {
    staticClass: "navheader float-left pl-1 ml-2 ",
    attrs: {
      "id": "name-title"
    }
  }, [_vm._v("Multi-Source Data Analytics & Triangulation (MSDAT) Platform")])])], 1), _vm._v(" "), _c('v-toolbar-items', {
    staticClass: " float-right"
  }, [_c('div', {
    staticClass: "car-nav"
  }, [_c('span', {
    staticClass: "covid-menu",
    staticStyle: {
      "font-size": "13px",
      "text-align": "right"
    }
  }, [_c('a', {
    staticClass: "covid-button",
    staticStyle: {
      "margin-right": "25px",
      "text-decoration": "none",
      "border": "1px solid white",
      "padding": "9px 10px"
    },
    attrs: {
      "id": "covid-button",
      "href": "https://msdat.fmohconnect.gov.ng/covid19_health_service_uptake/index.html"
    }
  }, [_vm._v("Health Service Uptake")]), _vm._v(" "), _c('router-link', {
    staticStyle: {
      "margin-right": "25px",
      "text-decoration": "none",
      "color": "white"
    },
    attrs: {
      "to": "/about"
    }
  }, [_vm._v("About")]), _vm._v(" "), _c('router-link', {
    staticStyle: {
      "margin-right": "25px",
      "text-decoration": "none",
      "color": "white"
    },
    attrs: {
      "to": "/help"
    }
  }, [_vm._v("Help and FAQs")])], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isMSDATPage),
      expression: "isMSDATPage"
    }],
    staticClass: "sections-button"
  }, [_c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isMSDATPage),
      expression: "isMSDATPage"
    }],
    staticClass: "material-button-raised tour-guide ",
    attrs: {
      "data-step": "1",
      "data-intro": "<b>Jump To Section</b><p>You can jump to any section of the platform by selecting the desired section from the drop-down menu</p>",
      "id": "dropdown-button"
    },
    on: {
      "click": function($event) {
        _vm.showNavigation()
      }
    }
  }, [_vm._v("Sections  "), _c('span', {
    staticClass: "caret"
  })]), _vm._v(" "), _c('div', {
    staticClass: "dropdown-div"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showNavigationBool),
      expression: "showNavigationBool"
    }],
    staticClass: "navigation-dropdown",
    attrs: {
      "id": "navigation-dropdown "
    }
  }, [_c('ul', [_c('li', {
    on: {
      "click": function($event) {
        _vm.goToZonalChart('zonalChart')
      }
    }
  }, [_vm._v("Zonal Section")]), _vm._v(" "), _c('li', {
    on: {
      "click": function($event) {
        _vm.goToZonalChart('compare-section')
      }
    }
  }, [_vm._v("Multi-Source Indicator Comparison Section")]), _vm._v(" "), _c('li', {
    on: {
      "click": function($event) {
        _vm.goToZonalChart('datasets')
      }
    }
  }, [_vm._v("Multi-Dataset Comparison Section")]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "javascript:Userback.open();"
    }
  }, [_vm._v("\n                  Feedback\n                  ")])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "car-icons-container-sm",
    on: {
      "mouseleave": _vm.offMoreMenu
    }
  }, [_c('span', {
    staticClass: "more-menu",
    on: {
      "click": _vm.showMoreMenu
    }
  }, [_c('v-icon', {
    directives: [{
      name: "tooltip",
      rawName: "v-tooltip.bottom",
      value: ('Site Options'),
      expression: "'Site Options'",
      modifiers: {
        "bottom": true
      }
    }],
    staticClass: "white--text",
    attrs: {
      "medium": ""
    }
  }, [_vm._v("more_vert")])], 1), _vm._v(" "), _c('div', {
    staticClass: "dropdown-div",
    on: {
      "mouseleave": _vm.offMoreMenu
    }
  }, [(_vm.showMoreMenuBool === true) ? _c('div', {
    staticClass: "navigation-dropdown navigation-more-menu",
    attrs: {
      "id": "navigation-more-menu"
    }
  }, [_c('ul', {
    on: {
      "click": _vm.offMoreMenu
    }
  }, [_c('li', [_c('router-link', {
    attrs: {
      "to": "/about"
    }
  }, [_c('v-icon', {
    attrs: {
      "title": "About"
    }
  }, [_vm._v("info")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "padding-left": "10px"
    }
  }, [_vm._v("About Dashboard")])], 1)], 1), _vm._v(" "), _c('li', {
    on: {
      "click": function($event) {
        _vm.startTour()
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "title": "Use a tour guide"
    }
  }, [_vm._v("slideshow")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "padding-left": "13px"
    }
  }, [_vm._v("Play Tour Guide")])], 1), _vm._v(" "), _c('hr'), _vm._v(" "), _c('li', {
    on: {
      "click": function($event) {
        _vm.shareDashboardState()
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "title": "Share"
    }
  }, [_vm._v("share")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "padding-left": "13px"
    }
  }, [_vm._v("Share")])], 1), _vm._v(" "), _c('li', {
    on: {
      "click": function($event) {
        _vm.printPage()
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "title": "Print"
    }
  }, [_vm._v("print")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "padding-left": "13px"
    }
  }, [_vm._v("Print ")])], 1), _vm._v(" "), _c('li', {
    on: {
      "click": function($event) {
        _vm.toggle()
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "title": "Fullscreen"
    }
  }, [_vm._v("fullscreen")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "padding-left": "13px"
    }
  }, [_vm._v("View Fullscreen")])], 1), _vm._v(" "), _c('hr'), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "https://mapping.fmohconnect.gov.ng/data-inventory/add-dataset/"
    }
  }, [_c('v-icon', {
    attrs: {
      "title": "Submit new data source"
    }
  }, [_vm._v("file_upload")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "padding-left": "10px"
    }
  }, [_vm._v("Submit new Data Source")])], 1)]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "updatelog"
    }
  }, [_c('img', {
    staticStyle: {
      "margin-left": "8px"
    },
    attrs: {
      "src": __webpack_require__(767),
      "alt": ""
    }
  }), _vm._v(" "), _c('span', {
    staticStyle: {
      "padding-left": "10px"
    }
  }, [_vm._v("See Updates")])])], 1), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "javascript:Userback.open();"
    }
  }, [_c('img', {
    staticStyle: {
      "margin-left": "8px"
    },
    attrs: {
      "src": __webpack_require__(766),
      "alt": ""
    }
  }), _vm._v(" "), _c('span', {
    staticStyle: {
      "padding-left": "14px"
    }
  }, [_vm._v("Feedback")])])]), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "/contact"
    }
  }, [_c('v-icon', {
    attrs: {
      "title": "Contact"
    }
  }, [_vm._v("email")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "padding-left": "10px"
    }
  }, [_vm._v("Contact")])], 1)], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "/help"
    }
  }, [_c('v-icon', {
    attrs: {
      "title": "Help"
    }
  }, [_vm._v("help")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "padding-left": "10px"
    }
  }, [_vm._v("Help and FAQs")])], 1)], 1), _vm._v(" "), _c('li', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(768),
      "alt": "subscribe"
    }
  }), _vm._v(" "), _c('span', {
    staticStyle: {
      "padding-left": "19px"
    }
  }, [_vm._v("Subscribe to our newsletter")])])])]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "car-icons-container-lg"
  })])]), _vm._v(" "), _c('v-spacer')], 1), _vm._v(" "), _c('main', [_c('v-content', [(_vm.$route.matched.length) ? [_c('fullscreen', {
    ref: "fullscreen",
    attrs: {
      "fullscreen": _vm.fullscreen
    },
    on: {
      "change": _vm.fullscreenChange,
      "update:fullscreen": function($event) {
        _vm.fullscreen = $event
      }
    }
  }, [_c('router-view')], 1)] : _vm._e()], 2)], 1), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _c('v-footer', {
    staticClass: "col-md-12 pa-3",
    staticStyle: {
      "width": "100%",
      "height": "35px",
      "font-size": "12px",
      "position": "fixed",
      "bottom": "0"
    },
    attrs: {
      "id": "footer",
      "color": "green",
      "app": ""
    }
  }, [_c('div', {
    staticClass: "col-md-7 col-sm-6 col-xs-4 "
  }, [_c('v-spacer'), _vm._v(" "), _c('div', {
    staticClass: "white--text footer-text",
    staticStyle: {
      "line-height": "11px"
    },
    attrs: {
      "id": "footerTextLeft"
    }
  }, [_vm._v("Built with "), _c('label', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("♥")]), _vm._v(" by\n      "), _c('a', {
    staticClass: "white--text",
    attrs: {
      "href": "https://ehealth4everyone.com",
      "target": "_blank"
    }
  }, [_vm._v("eHealth4everyone")])])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-5 col-sm-6 col-xs-8 white--text",
    staticStyle: {
      "text-align": "right"
    }
  }, [_c('v-spacer'), _vm._v(" "), _c('div', {
    staticClass: "footer-text",
    staticStyle: {
      "line-height": "15px"
    },
    attrs: {
      "id": "footerTextRight"
    }
  }, [_vm._v(_vm._s(this.$store.state.CAR.indicatorLength) + " Indicators, " + _vm._s(this.$store.state.CAR.sourceMetaData) + " Data sources. "), _c('router-link', {
    directives: [{
      name: "tooltip",
      rawName: "v-tooltip.top",
      value: ('See UpdateLog'),
      expression: "'See UpdateLog'",
      modifiers: {
        "top": true
      }
    }],
    staticClass: "update-log",
    attrs: {
      "to": "/updatelog"
    }
  }, [_vm._v("Last Updated: 19-Sept-2022")])], 1)], 1)])], 1)
},staticRenderFns: []}

/***/ }),

/***/ 789:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [(_vm.enableColumnGrouping) ? _c('tr', {
    staticClass: "grouped-columns-header-row",
    staticStyle: {
      "font-weight": "bold"
    }
  }, [(_vm.lineNumbers) ? _c('th') : _vm._e(), _vm._v(" "), (_vm.selectable) ? _c('td') : _vm._e(), _vm._v(" "), _vm._l((_vm.columnGroups), function(group) {
    return _c('td', {
      attrs: {
        "colspan": group.colSpan
      }
    }, [_vm._v("\n      " + _vm._s(group.label) + "\n    ")])
  })], 2) : _vm._e(), _vm._v(" "), _c('tr', [(_vm.lineNumbers) ? _c('th', {
    staticClass: "line-numbers"
  }) : _vm._e(), _vm._v(" "), (_vm.selectable) ? _c('th', {
    staticClass: "vgt-checkbox-col"
  }, [_c('input', {
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": _vm.allSelected,
      "indeterminate": _vm.allSelectedIndeterminate
    },
    on: {
      "change": _vm.toggleSelectAll
    }
  })]) : _vm._e(), _vm._v(" "), _vm._l((_vm.columns), function(column, index) {
    return (!column.hidden) ? _c('th', {
      key: index,
      class: _vm.getHeaderClasses(column, index),
      style: (_vm.columnStyles[index]),
      on: {
        "click": function($event) {
          _vm.sort(index)
        }
      }
    }, [_vm._t("table-column", [_c('span', [_vm._v(_vm._s(column.label))])], {
      column: column
    })], 2) : _vm._e()
  })], 2), _vm._v(" "), _c("vgt-filter-row", {
    ref: "filter-row",
    tag: "tr",
    attrs: {
      "global-search-enabled": _vm.searchEnabled,
      "line-numbers": _vm.lineNumbers,
      "selectable": _vm.selectable,
      "columns": _vm.columns,
      "mode": _vm.mode,
      "typed-columns": _vm.typedColumns
    },
    on: {
      "filter-changed": _vm.filterRows
    }
  })])
},staticRenderFns: []}

/***/ }),

/***/ 790:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "footer__navigation__page-info"
  }, [_vm._v("\n  " + _vm._s(_vm.pageText) + " "), _c('input', {
    staticClass: "footer__navigation__page-info__current-entry",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": _vm.currentPage
    },
    on: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        $event.stopPropagation();
        return _vm.changePage($event)
      }
    }
  }), _vm._v(" " + _vm._s(_vm.pageInfo) + "\n")])
},staticRenderFns: []}

/***/ }),

/***/ 791:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sign-up"
  }, [_c('p', [_vm._v("Sign up to create your Personalize view")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.email),
      expression: "email"
    }],
    attrs: {
      "type": "text",
      "placeholder": "Email Address"
    },
    domProps: {
      "value": (_vm.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.email = $event.target.value
      }
    }
  }), _c('br'), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.password),
      expression: "password"
    }],
    attrs: {
      "type": "password",
      "placeholder": "Password"
    },
    domProps: {
      "value": (_vm.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.password = $event.target.value
      }
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('button', {
    on: {
      "click": _vm.signup
    }
  }, [_vm._v("Sign Up")]), _c('br'), _vm._v(" "), _c('span', [_vm._v("Already have an account "), _c('router-link', {
    attrs: {
      "to": "/login"
    }
  }, [_vm._v("login.")])], 1)])
},staticRenderFns: []}

/***/ }),

/***/ 798:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ 799:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ 800:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ 801:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ 95:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_clone__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_clone___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_clone__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__default__ = __webpack_require__(67);



var number = __WEBPACK_IMPORTED_MODULE_0_lodash_clone___default()(__WEBPACK_IMPORTED_MODULE_1__default__["a" /* default */]);

number.isRight = true;

number.filterPredicate = function (rowval, filter) {
  return number.compare(rowval, filter) === 0;
};

number.compare = function (x, y) {
  function cook(d) {
    // if d is null or undefined we give it the smallest
    // possible value
    if (d === undefined || d === null) return -Infinity;
    return d.indexOf('.') >= 0 ? parseFloat(d) : parseInt(d, 10);
  }

  x = typeof x === 'number' ? x : cook(x);
  y = typeof y === 'number' ? y : cook(y);
  if (x < y) return -1;
  if (x > y) return 1;
  return 0;
};

/* harmony default export */ __webpack_exports__["default"] = (number);

/***/ }),

/***/ 96:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__logindetails__ = __webpack_require__(459);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__logindetails___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__logindetails__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_cookies__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_cookies___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_cookies__);
/* globals localStorage */




/* harmony default export */ __webpack_exports__["a"] = ({
  // login (email, pass, loc, cb) {
  login: function login(loc, cb) {
    var _this = this;

    cb = arguments[arguments.length - 1];
    if (localStorage.token) {
      if (cb) cb(true);
      this.onChange(true);
      return;
    }
    // pretendRequest(email, pass, loc, (res) => {
    pretendRequest(loc, function (res) {
      if (res.authenticated) {
        localStorage.token = res.token;
        if (cb) cb(true);
        _this.onChange(true);
      } else {
        if (cb) cb(false);
        _this.onChange(false);
      }
    });
  },

  // .substr(19)
  getLocation: function getLocation() {
    return __WEBPACK_IMPORTED_MODULE_1_vue_cookies___default.a.get("token") ? __WEBPACK_IMPORTED_MODULE_1_vue_cookies___default.a.get("location") : 'Guest';
  },
  getToken: function getToken() {
    return localStorage.token ? localStorage.token : __WEBPACK_IMPORTED_MODULE_1_vue_cookies___default.a.get("token") ? __WEBPACK_IMPORTED_MODULE_1_vue_cookies___default.a.get("token") : null;
  },
  logout: function logout(cb) {
    delete localStorage.token;
    __WEBPACK_IMPORTED_MODULE_1_vue_cookies___default.a.remove("token");
    __WEBPACK_IMPORTED_MODULE_1_vue_cookies___default.a.remove("location");
    if (cb) cb();
    this.onChange(false);
  },
  loggedIn: function loggedIn() {
    // return !!localStorage.token
    return !!this.getToken();
  },
  onChange: function onChange() {}
});

// function pretendRequest (email, pass, loc, cb) {
function pretendRequest(loc, cb) {
  setTimeout(function () {

    var checkMatch = false;
    for (var index in __WEBPACK_IMPORTED_MODULE_0__logindetails___default.a) {
      if (
      // email === loginDetails[index]['username']  &&
      pass === 'dashboard' || 'Chukwuma123' // loginDetails[index]['password'] // &&
      //   loc === loginDetails[index]['location']
      ) {
          checkMatch = true;
        }
    }
    if (checkMatch) {

      if (pass === 'Chukwuma123') {
        localStorage.user_type = 'superadmin';
      }
      if (pass === 'dashboard') {
        localStorage.user_type = 'admin';
      }

      var loc = 'Admin';
      var authVals = {
        authenticated: true,
        token: Math.random().toString(36).substring(7) + new Date().getTime() + loc.trim().replace(/\s/g, '')
        // set the tokens to the as the cookies value
      };if (loc !== 'Guest') {
        __WEBPACK_IMPORTED_MODULE_1_vue_cookies___default.a.set("token", authVals.token, "9m"); // expires after 9 months
      }
      // set the location cookies
      if (__WEBPACK_IMPORTED_MODULE_1_vue_cookies___default.a.isKey("location")) {
        __WEBPACK_IMPORTED_MODULE_1_vue_cookies___default.a.remove("location"); // removing existing location
      }
      __WEBPACK_IMPORTED_MODULE_1_vue_cookies___default.a.set("location", loc.trim().replace(/\s/g, ''), -1); // set new location; -1 ~~ never expire
      // set the authval as the callback
      cb(authVals);
    } else {
      cb({ authenticated: false });
    }
  }, 0);
}

/***/ })

},[135]);


// WEBPACK FOOTER //
// static/js/app.7205e92878291f1ad471.js